(function (root, factory) {
    'use strict';

    var edapOpts = root.edapOptions || {};

    // Set a default for the EDAP window namespace
    edapOpts.ns = edapOpts.ns || 'edap';

    // Make sure that any default opts are set in the global options
    root.edapOptions = edapOpts;

    // Browser globals
    // Execute the EDAP factory function if it is not globally exposed
    if (!(root[edapOpts.ns] && typeof root[edapOpts.ns].trigger === 'function')) {
        root[edapOpts.ns] = factory(root);
    } else {
        throw new Error('EDAP Init: window.edap already defined - you may be loading multiple instances of EDAP');
    }

    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('edap-integrations', [], function () {
            return root[edapOpts.ns];
        });
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = root[edapOpts.ns];
    }
}(window || this, function (root) {
define('circularlog',[], function() {
    'use strict';

    function CircularLog(numMaxEntries) {
        var circularlog = this,
            maxEntries;

       /**
        *  Validates the values of maxEntries before it is set
        *
        *  @private
        *  @throws {Error} - If num does not pass validation
        *  @param {Number} [num] - The number to validate
        */
        function validateMaxEntries(num) {
            if (typeof num !== 'number') {
                throw new Error('CircularLog requires a number for maxEntries');
            }

            if (num < 0) {
                throw new Error('CircularLog requires the number of maxEntries to be >=0');
            }
        }


       /**
        *  Resizes the entries array down to the maxEntries size by using FIFO logic.
        *
        *  @private
        */
        function drainOverages() {
            var entries = circularlog.entries,
                i;

            if (entries.length > maxEntries) {
                for (i = entries.length; i > maxEntries; i--) {
                    entries.shift();
                }
            }
        }

        // Publically accessible entries array so that it isn't hidden in a Dev Tools Inspector
        circularlog.entries = [];


       /**
        *  Getter for the circularlog.entries
        *
        *  @public
        *  @returns {Array} - The array of entries in the log
        */
        circularlog.getEntries = function() {
            return circularlog.entries;
        };


       /**
        *  Add an entry to the log
        *
        *  @public
        *  @param {Object} [item] - The item to append to the log
        */
        circularlog.push = function(item) {
            var entries = circularlog.entries;

            entries.push(item);
            drainOverages();
        };


       /**
        *  Setter for the max number of entries in the log. Changing this value will resize the array, if necessary.
        *
        *  @public
        *  @param {Object} [num] - Maximum number of entries allowed in the log
        */
        circularlog.setMaxEntries = function(num) {
            validateMaxEntries(num);
            maxEntries = num;
            drainOverages();
        };

        // Set the maxEntries from the constructor parameter
        circularlog.setMaxEntries(numMaxEntries);
    }

    return CircularLog;
});

define('edaphelpers',[], function() {
    'use strict';

    function EdapHelpers() {
        var helpers = this,
            defaultOpts = {
                ns: 'edap',
                dataLayerName: 'analyticsdatalayer'
            };


        /**
         *  Getter for the window object, mainly for spy-based testing and abstraction
         *
         *  @returns {Object} - The window object
         */
        helpers.getWindow = function() {
            return window;
        };


        /**
         *  Returns the window.edapOptions global contents
         *
         *  @returns {Object} - window.edapOptions global object
         */
        helpers.getGlobalOptions = function() {
            window.edapOptions = window.edapOptions || {};
            window.edapOptions = helpers.defaults(window.edapOptions, [defaultOpts]);
            return window.edapOptions;
        };


        /**
         *  Abstraction around getting the window-level EDAP singleton
         *
         *  @throws {TypeError} - If we can't find the global namespace
         *  @returns {Object} - Returns the window EDAP singleton
         */
        helpers.getEdapGlobal = function() {
            var win = helpers.getWindow(),
                ns = helpers.getGlobalOptions().ns,
                err;

            if (typeof ns === 'function') {
                return ns();
            } else if (typeof ns === 'string') {
                if (!helpers.has(win, ns)) {
                    win[ns] = [];
                }
                return win[ns];
            }

            err = new TypeError('edapOptions.ns was neither function nor string');
            throw err;
        };

        /**
         *  Assigns own enumerable properties of source object(s) to the destination object for all destination properties that resolve to undefined.
         *  Once a property is set, additional values of the same property are ignored.
         *  A replacement for Lodash's _.defaults()
         *
         *  @param {Object} [destinationObj] - The destination object to merge options into and then return
         *  @param {Array} [sourceObjArr] - An array of options objects
         *  @returns {Object} - The merged options object
         */
        helpers.defaults = function(destinationObj, sourceObjArr) {
            var option,
                i;

            for (i = 0; i < sourceObjArr.length; i++) {
                for (option in sourceObjArr[i]) {
                    if (sourceObjArr[i].hasOwnProperty(option) && destinationObj[option] === undefined) {
                        destinationObj[option] = sourceObjArr[i][option];
                    }
                }
            }

            return destinationObj;
        };

        /**
         *  Iterates over own enumerable properties of an object invoking a function for each property.
         *  A replacement for Lodash's _.forOwn()
         *
         *  @param {Object} [obj] - The destination object to merge options into and then return
         *  @param {Function} [iteratee] - The function invoked per iteration
         */
        helpers.forOwn = function(obj, iteratee) {
            Object.keys(obj).forEach(function(key) {
                iteratee(obj[key], key, obj);
            });
        };

        /**
         *  Check if the value is an Object.
         *
         *  @param {Any} [val] - The value to check
         *  @returns {Boolean} - Returns true if val is an object, else false
         */
        helpers.isObject = function(val) {
            var type = typeof val;
            return val !== null && (type === 'object' || type === 'function');
        };

        /**
         *  Creates a deep copy.
         *  A less-complex version of Lodash's _.clone()
         *
         *  @param {Any} [item] - Item to be copied
         *  @returns {Object} - Returns the cloned item
         */
        helpers.clone = function(item) {
            var NORMALIZE_TYPES = [Number, String, Boolean],
                result = null,
                i;

            // null, undefined values check
            if (!item) {
                return item;
            }

            // normalizing primitives if someone did new String('aaa'), or new Number('444');
            NORMALIZE_TYPES.forEach(function(type) {
                if (item instanceof type) {
                    result = type(item);
                }
            });

            if (result !== null) {
                return result;
            }

            if (Array.isArray(item) || Object.prototype.toString.call(item) === '[object Array]') {
                result = [];
                item.forEach(function(child, index) {
                    result[index] = helpers.clone(child);
                });
            } else if (typeof item === 'object') {
                // it is an object literal
                result = {};
                for (i in item) {
                    if (item.hasOwnProperty(i)) {
                        result[i] = helpers.clone(item[i]);
                    }
                }
            } else {
                result = item;
            }

            return result;
        };

        /**
         *  Checks if path is a direct property.
         *  Replacement of Lodash's _.has()
         *
         *  @param {Object} [obj] - Object to query
         *  @param {String} [path] - The path to check
         *  @returns {Boolean} - true if path is a direct property, else false
         */
        helpers.has = function(obj, path) {
            return obj !== null && Object.hasOwnProperty.call(obj, path);
        };
    }

    return new EdapHelpers();
});

define('consolehelpers',['edaphelpers'], function(edapHelpers) {
    'use strict';

    var validLogLevels = ['log', 'info', 'warn', 'error'];

    function ConsoleHelpers() {
        var consoleHelper = this,
            i,
            len;

        consoleHelper.validLogLevels = {};
        consoleHelper.logLevel = 'log';
        consoleHelper.enabled = true;


        /**
         *  Enables logging to console
         */
        consoleHelper.enable = function() {
            consoleHelper.enabled = true;
        };


        /**
         *  Disables logging to console
         */
        consoleHelper.disable = function() {
            consoleHelper.enabled = false;
        };


        /**
         *  Sets the console logging level to log messages
         *
         *  @param {String} [loglevel] - Console logging level to use to log messages
         *  @returns {Boolean} - If the logging level was set
         */
        consoleHelper.setLogLevel = function(loglevel) {
            if (consoleHelper.validLogLevels[loglevel]) {
                consoleHelper.logLevel = loglevel;
                return true;
            }

            return false;
        };


        /**
         *  Getter for logging level
         *
         *  @returns {String} - Returns the logging level
         */
        consoleHelper.getLogLevel = function() {
            return consoleHelper.logLevel;
        };


        /**
         *  Getter for the window.console, if it exists
         *
         *  @returns {Object} - Returns the window.console or null
         */
        consoleHelper.getConsole = function() {
            var win = edapHelpers.getWindow();

            if (win.console !== null && (typeof win.console === 'object' || typeof win.console === 'function')) {
                return win.console;
            }

            return null;
        };


        /**
         *  Contains the logic to determine if a log entry should be logged
         *
         *  @returns {Boolean} - If a log entry should be logged
         */
        consoleHelper.shouldLog = function() {
            var con;

            if (consoleHelper.enabled === false) {
                return false;
            }

            con = consoleHelper.getConsole();

            if (con === null) {
                return false;
            }

            return true;
        };


        /**
         *  Writes a log/logs to console
         *  Accepts a variable number of parameters that are passed through
         *  to console[logLevel]  ex. (assuming logLevel = 'log')
         *      console.log(str1, obj1, obj2);
         *
         *  @param {*} [arguments] - list of arguments to be apply()'d to the console
         */
        consoleHelper.log = function() {
            var con,
                logLevel;

            if (!consoleHelper.shouldLog()) {
                return;
            }

            con = consoleHelper.getConsole();
            logLevel = consoleHelper.getLogLevel();

            try {
                con[logLevel].apply(con, arguments);
            } catch (err) {
                // Do our best to log the message if we can
                if (logLevel !== 'log' && typeof con.log === 'function') {
                    con.log.apply(con, arguments);
                }
            }
        };


        /**
         *  Starts a console group() thread.
         *
         *  @param {String} [title] - Title of the console.group
         */
        consoleHelper.startLog = function(title) {
            var con;

            if (!consoleHelper.shouldLog()) {
                return;
            }

            con = consoleHelper.getConsole();

            if (typeof con.groupCollapsed === 'function') {
                con.groupCollapsed(title);
            } else if (typeof con.group === 'function') {
                con.group(title);
            } else {
                consoleHelper.log(title);
            }
        };


        /**
         *  Writes a log/logs to the end of a console group
         *  Accepts a variable number of parameters that are passed through
         *  to console.log. ex.
         *      console.log(str1, obj1, obj2);
         *
         *  @param {*} [arguments] - list of arguments to be apply()'d to this.log()
         */
        consoleHelper.endLog = function() {
            var con;

            if (!consoleHelper.shouldLog()) {
                return;
            }

            con = consoleHelper.getConsole();

            if (arguments.length > 0) {
                consoleHelper.log.apply(consoleHelper, arguments);
            }

            if (typeof con.groupEnd === 'function') {
                con.groupEnd();
            }
        };

        // Load up the validLogLevels object
        for (i = 0, len = validLogLevels.length; i < len; i++) {
            consoleHelper.validLogLevels[validLogLevels[i]] = true;
        }
    }

    return ConsoleHelpers;
});

define('cookieparser',['edaphelpers'], function(edapHelpers) {
    'use strict';

    function CookieParser() {
        var parser = this;

        /**
         *  Returns the window.document
         *
         *  @returns {Object} - Returns the window.document
         */
        parser.getDocument = function() {
            return window.document;
        };


        /**
         *  Returns the window.document.cookies data string
         *
         *  @returns {String} - window.document.cookies data string or an empty string
         */
        parser.getCookies = function() {
            return parser.getDocument().cookie || '';
        };


        /**
         *  Parses the "edapConfig" cookie and returns an object of the data
         *
         *  NOTE: No decoding is done on the keys/values so be careful not to include ";" or "|"
         *  as it would break the parsing
         *
         *  Cookie format should be:
         *      edapConfig=key1=value1|key2=value2|key3=value3|...
         *  will return:
         *      {
         *          key1: value1,
         *          key2: value2,
         *          key3: value3
         *          ...
         *      }
         *
         *  @return {Object} - Object as described in the description above
         */
        parser.getConfigData = function() {
            var edapCookieData = {},
                cookies,
                edapCookieRegexed,
                edapCookieRawData,
                splitEqualsRegExp,
                edapCookieDataParts,
                tmp,
                i,
                len;

            try {
                cookies = parser.getCookies();
                edapCookieRegexed = cookies.match(/edapConfig=([^;]+)(;|$)/);
                edapCookieRawData = (edapCookieRegexed === null ? null : edapCookieRegexed[1]);
                splitEqualsRegExp = new RegExp('=(.+)');

                if (edapCookieRawData !== null) {
                    edapCookieDataParts = edapCookieRawData.split('|');

                    for (i = 0, len = edapCookieDataParts.length; i < len; i++) {
                        tmp = edapCookieDataParts[i].split(splitEqualsRegExp);
                        edapCookieData[tmp[0]] = tmp[1];
                    }
                }
            } catch (err) {
                edapCookieData = {};
                edapHelpers.getEdapGlobal().push(function(edap) {
                    edap.error(err);
                });
            }

            return edapCookieData;
        };
    }

    return new CookieParser();
});

define('doneable',[], function() {
    'use strict';

    /**
     *  Doneable is a simple single callback Promise-like implementation. Its purpose
     *  is to be able to return a future based on the callback being "done", regardless
     *  of its resolution state (resolve/rejected) liked a normal Promise.
     *
     *  @constructor
     *  @param {Function} [cb] - The main function to execute in the Doneable
     *  @param {Object} [opts] - Options supported are:
     *                            - error - Set the error function to be called on any errors
     */
    function Doneable(cb, opts) {
        var doneable = this,
            doneCallbacks = [],
            state = 'pending';

        opts = opts || {};

        /**
         *  Logs any errors to the opts.error function
         *
         *  @private
         *  @param {Object} [err] - error to log
         */
        function logError(err) {
            if (typeof opts.error === 'function') {
                opts.error(err);
            }
        }


        /**
         *  Executes all the callbacks waiting to be executed in the queue
         *
         *  @private
         */
        function processDoneCallbacks() {
            var i;

            for (i = 0; i < doneCallbacks.length; i++) {
                try {
                    doneCallbacks[i].call(doneable);
                } catch (e) {
                    logError(e);
                }
            }

            doneCallbacks = [];
        }


        /**
         *  Function to be called when the main function is "done"
         *
         *  @private
         */
        function done() {
            processDoneCallbacks();
            state = 'done';
        }


        /**
         *  Assign a callback function when the main function is "done". If the Doneable is already
         *  "done" then the callback will be executed immediately.
         *
         *  @method
         *  @param {Function} [onDone] - Function to queue as a callback when the Doneable is done
         *  @returns {Doneable} - Returns the Doneable instance to support chaining
         */
        doneable.then = function(onDone) {
            if (typeof onDone === 'function') {
                doneCallbacks.push(onDone);
            }

            if (state === 'done') {
                done();
            }

            return doneable;
        };


        // Execute the main function and pass in done()
        try {
            cb(done);
        } catch (e) {
            // If something blows up then we will attempt to log the error
            // but will consider this Doneable instance "done"
            logError(e);
            done();
        }

        return doneable;
    }

    /**
     *  Creates a doneable object based on the completion of one or more doneables
     *  If an element of the passed array isn't a Doneable, we'll immediately consider it done
     *
     *  @method
     *  @param {Array} [parts] - Doneables to complete before calling done
     *  @param {Object} [opts] - Options to be passed to the created Doneable. Options supported are:
     *                            - error - Set the error function to be called on any errors
     *  @returns {Doneable} - Returns a Doneable instance to support chaining
     */
    Doneable.all = function(parts, opts) {
        return new Doneable(function(done) {
            var numDone = 0,
                numParts,
                i,
                curr;

            if (parts && parts.length) {
                numParts = parts.length;
            } else {
                // there is nothing to do, call done
                numParts = 0;
                done();
            }

            function checkNumDone() {
                numDone += 1;
                if (numDone === numParts) {
                    done();
                }
            }

            for (i = 0; i < parts.length; i++) {
                curr = parts[i];

                if (curr instanceof Doneable) {
                    curr.then(checkNumDone);
                } else {
                    // If it isn't a Doneable assume, it is done
                    checkNumDone();
                }
            }
        }, opts);
    };


    return Doneable;
});

define('featureflag',['edaphelpers'], function(edapHelpers) {
    'use strict';

    function FeatureFlag(edap, data) {
        var featureFlag = this,
            err;

        /**
         *  Validate
         */

        if (!edap || !edap.hasOwnProperty('edapVersion')) {
            throw new TypeError('FeatureFlag: must pass in EDAP when creating a new instance');
        }

        if (!(featureFlag instanceof FeatureFlag)) {
            err = new TypeError('FeatureFlag must be called with the "new" keyword');
            edap.error(err);
            throw err;
        }

        /**
         *  Sets all the FeatureFlag options from an object
         *
         *  @public
         *  @param {Object} [obj] - Object of values to set
         */
        featureFlag.setAll = function(obj) {
            var keys,
                i,
                len,
                e;

            if (typeof obj !== 'object') {
                e = new TypeError('featureFlag.set called without valid obj');
                edap.error(e);
                throw e;
            }

            keys = Object.keys(featureFlag.internal);
            for (i = 0, len = keys.length; i < len; i++) {
                if (obj.hasOwnProperty(keys[i])) {
                    featureFlag.set(keys[i], obj[keys[i]]);
                }
            }
        };


        /**
         *  Sets key/value data
         *
         *  @public
         *  @param {String} [key] - Key name
         *  @param {Any} [value] - Value to assign to the key
         */
        featureFlag.set = function(key, value) {
            if (featureFlag.internal.hasOwnProperty(key)) {
                featureFlag.internal[key] = value;
            }
        };


        /**
         *  Gets the cloned value of a single key or returns the cloned data object
         *
         *  @public
         *  @param {String} [optKey] - Optional key name to return its value
         *  @returns {Object} - If optKey is passed and it is a data key then the cloned value is returned.
         *                      If optKey is passed and it is not a valid key then null is returned.
         *                      If optKey is not passed then the entire cloned data object is returned.
         */
        featureFlag.get = function(optKey) {
            if (typeof optKey === 'string') {
                if (featureFlag.internal.hasOwnProperty(optKey)) {
                    // return JSON.parse(JSON.stringify(featureFlag.internal[optKey]));
                    return edapHelpers.clone(featureFlag.internal[optKey]);
                }
            } else {
                // Do a deep clone so that payload is cloned
                return edapHelpers.clone(featureFlag.internal, true);
            }

            return null;
        };


        /**
         *  Constructor
         */

        // Set the default
        featureFlag.internal = {
            name: null,
            value: null,
            payload: {}
        };

        if (data) {
            featureFlag.setAll(data);
        }

        return featureFlag;
    }

    return FeatureFlag;
});

define('features',['featureflag'], function(FeatureFlag) {
    'use strict';

    function Features(edap) {
        var features = this,
            featuresInternal,
            err;

        /**
         *  Validate
         */

        if (!edap || !edap.hasOwnProperty('edapVersion')) {
            throw new TypeError('Features: must pass in EDAP when creating a new instance');
        }

        if (!(features instanceof Features)) {
            err = new TypeError('Features must be called with the "new" keyword');
            edap.error(err);
            throw err;
        }


        /**
         *  Container to hold all the internal data for the Features Object.
         *
         *  @private
         */
        features.internal = {};
        featuresInternal = features.internal;


        /**
         *  Add a callback to be executed after all the FeatureFlags are loaded via load().
         *  If load() has already been called then the callback is executed immedaitely.
         *
         *  @public
         *  @param {Function} [cb] - Function to be executed after FeatureFlags are loaded
         */
        features.onLoad = function(cb) {
            var error;

            if (typeof cb !== 'function') {
                error = new TypeError('onLoad(): must be passed a function');
                edap.error(error);
                throw error;
            }

            if (featuresInternal.hasLoaded) {
                try {
                    cb();
                } catch (e) {
                    edap.error(e);
                }
            } else {
                featuresInternal.loadCallbacks.push(cb);
            }
        };


        /**
         *  Loads all the FeatureFlag instances. This is a clean slate method that will remove any
         *  other existing FeatureFlags. If you wish to add just 1 new Feature then you should use
         *  features.addFeatureFlag() instead. After all FeatureFlags are loaded it will execute any
         *  functions that were stored via onLoad().
         *
         *  NOTE: This function is designed to be only be called once. If you wish to re-init your
         *        FeatureFlags then you can use reset() to allow you to call load() again.
         *
         *  @public
         *  @param {Array} [featureFlags] - Array of FeatureFlag objects to store
         */
        features.load = function(featureFlags) {
            var logName = 'load',
                i,
                len,
                error;

            if (!(featureFlags instanceof Array)) {
                err = new TypeError(logName + '(): featureFlags must be an Array of FeatureFlag instances');
                edap.error(error);
                throw error;
            }

            if (featuresInternal.hasLoaded === true) {
                error = new TypeError(logName + '(): Features has already been loaded, try calling reset() first');
                edap.error(error);
                throw error;
            }

            // When load is called we always zero out the existing list of Features
            featuresInternal.featureList = {};

            // Load all the FeatureFlags
            for (i = 0, len = featureFlags.length; i < len; i++) {
                features.addFeatureFlag(featureFlags[i]);
            }

            featuresInternal.hasLoaded = true;

            // Now execute all the onLoad callbacks since the FeatureFlags have been loaded
            for (i = 0, len = featuresInternal.loadCallbacks.length; i < len; i++) {
                try {
                    featuresInternal.loadCallbacks[i](edap);
                } catch (e) {
                    edap.error(e);
                }
            }

            featuresInternal.loadCallbacks = [];
        };


        /**
         *  Add a single FeatureFlag into the Feature List. It will overwrite an existing feature with the
         *  same name in the list.
         *
         *  @public
         *  @param {FeatureFlag} [featureFlag] - FeatureFlag object to store
         */
        features.addFeatureFlag = function(featureFlag) {
            var error;

            if (!(featureFlag instanceof FeatureFlag)) {
                error = new TypeError('addFeatureFlag(): attempting to load a non-FeatureFlag model');
                edap.error(error);
                throw error;
            }

            featuresInternal.featureList[featureFlag.get('name')] = featureFlag;
        };


        /**
         *  Gets a single FeatureFlag object by name
         *
         *  @public
         *  @param {String} [name] - name of the Feature Flag object to get
         *  @returns {Object} - returns the FeatureFlag object if it is in the list, otherwise null
         */
        features.getFeature = function(name) {
            if (featuresInternal.featureList.hasOwnProperty(name)) {
                return featuresInternal.featureList[name];
            }

            return null;
        };


        /**
         *  Gets the value of a property of a specific Feature Flag
         *
         *  @public
         *  @param {String} [featureName] - name of the Feature Flag object to get
         *  @param {String} [propertyName] - name of the property to get from the Feature Flag instance
         *  @returns {Object} - returns the value of the property of a specific Feature Flag, or null
         */
        features.getFeatureProperty = function(featureName, propertyName) {
            var ff = features.getFeature(featureName);

            if (ff !== null) {
                return ff.get(propertyName);
            }

            return null;
        };


        /**
         *  Resets the internal data structures. Doing this will allow you to call
         *  load() again.
         *
         *  @public
         */
        features.reset = function() {
            featuresInternal.featureList = {};
            featuresInternal.loadCallbacks = [];
            featuresInternal.hasLoaded = false;
        };


        /**
         *  Constructor
         */

        // Init the internal data structures
        features.reset();

        return features;
    }

    return Features;
});

define('lifecycle',['edaphelpers'], function(edapHelpers) {
    'use strict';

    function Lifecycle(supportedHooks) {
        var lifecycle = this,
            idCounter = 0,
            callbacks = {},
            idToEventLookup = {},
            supportedLifecycleEvents;

        /**
         *  Validates if a string is a supported lifecyle name
         *
         *  @private
         *  @param {String} [name] - name to validate
         *  @returns {Boolean} - if the name is a supported lifecycle event
         */
        function isValidLifecycleName(name) {
            return supportedLifecycleEvents.indexOf(name) > -1;
        }


        /**
         *  Returns the registered callbacks. This should only be used for debugging
         *
         *  @private
         *  @returns {Object} - the `callbacks` object
         */
        lifecycle.getCallbacks = function() {
            return callbacks;
        };


        /**
         *  Resets the registered lifecycle callbacks
         *
         *  @public
         */
        lifecycle.reset = function() {
            callbacks = {};

            edapHelpers.forOwn(supportedLifecycleEvents, function(value) {
                callbacks[value] = [];
            });
        };


        /**
         *  Executes the array of registered callbacks for a given lifecycle event. It will apply the data array passed
         *  into this function to all callbacks as a processing chain. A primary use case is to mutate the data so
         *  this is by definition a "side effect" function.
         *  NOTE: This assumes all callbacks are synchronous. Async callbacks are not supported.
         *
         *  @example
         *  var newData = edap.public.lifecycle.execute('onDataExtraction', [eventName, dataPayload, opts]);
         *  Would return:
         *  newData[0] === <event name after data extraction has occured>
         *  newData[1] === <data payload after data extraction has occured>
         *  newData[2] === <options name after data extraction has occured>
         *  Any of the values passed into execute() may be manipulated by a registered lifecycle hook.
         *
         *  @public
         *  @throws {TypeError} - If lifecycleName is not a supported lifecycle
         *  @param {String} [lifecycleName] - The name of the lifecycle event to execute all callbacks for
         *  @param {Array} [data] - Optional. Array of data values to be apply()'d to each callback function for that lifecycle event.
         *  @returns {Array} - The data set after it has been run through each callback for that lifecycle event
         */
        lifecycle.execute = function(lifecycleName, data) {
            var logName = 'execute';

            if (!isValidLifecycleName(lifecycleName)) {
                throw new TypeError(logName + ': ' + lifecycleName + 'is not a valid Lifecycle name');
            }

            // Reset data to an empty array if it is null or undefined
            if (typeof data === 'undefined') {
                data = [];
            }

            if (!Array.isArray(data)) {
                throw new TypeError(logName + ': ' + 'data must be an Array');
            }

            // Special case where we want to pass along the original data as "output" if there were no callbacks in the list
            if (callbacks[lifecycleName].length === 0) {
                return data;
            }

            edapHelpers.forOwn(callbacks[lifecycleName], function(callbackArr) {
                var fn = callbackArr[1],
                    ret = fn.apply(null, data);

                // We will chain any results returned by the callbacks. If it is undefined then we'll just pass along the original data
                if (ret !== undefined) {
                    data = ret;
                }
            });

            return data;
        };


        /**
         *  Registers a new callback to a lifecycle event. Callbacks will be executed in a FIFO manner.
         *
         *  @example
         *  var lifecycleId = edap.public.lifecycle.register('onDataExtraction', function(eventName, data, options) {
         *      data.newField = 1;
         *      return [eventName, data, options];
         *  });
         *  would inject the `newField` key and value into the data payload of an event when the 'onDataExraction'
         *  hook was executed()'d.
         *
         *  @public
         *  @throws {TypeError} - If lifecycleName is not a supported lifecycle
         *  @param {String} [lifecycleName] - The name of the lifecycle event to execute all callbacks for
         *  @param {Function} [fn] - Callback function to be executed when the lifecycle is executed
         *  @returns {Number} - ID of the lifecycle hook to be used with unregister()
         */
        lifecycle.register = function(lifecycleName, fn) {
            var logName = 'register';

            if (!isValidLifecycleName(lifecycleName)) {
                throw new TypeError(logName + ': ' + lifecycleName + 'is not a valid Lifecycle name');
            }

            if (!(typeof fn === 'function')) {
                throw new TypeError(logName + ': ' + 'fn must be a Function');
            }

            idCounter++;

            callbacks[lifecycleName].push([idCounter, fn]);
            idToEventLookup[idCounter] = lifecycleName;

            return idCounter;
        };


        /**
         *  Unregisters a lifecycle event
         *
         *  @example
         *  var lifecycleId = edap.public.lifecycle.register('onDataExtraction', function(eventName, data, options) {
         *      ...
         *  });
         *  edap.public.lifecycle.unregister(lifecycleId);
         *
         *  @public
         *  @throws {TypeError} - If id is not defined
         */
        lifecycle.unregister = function(id) {
            var logName = 'unregister',
                lifecycleName,
                callbackId,
                lifecycleCallbacks,
                i,
                len;

            if (!id) {
                throw new TypeError(logName + ': ' + 'id must be passed in');
            }

            // See if this is a registered id and find the corresponding lifecycleName
            lifecycleName = idToEventLookup[id];

            // if the ID doens't exist then just act like it was unregistered
            if (lifecycleName === undefined) {
                return;
            }

            lifecycleCallbacks = callbacks[lifecycleName];
            for (i = 0, len = lifecycleCallbacks.length; i < len; i++) {
                callbackId = lifecycleCallbacks[i][0];

                // Since an id can only map to a single lifecycle name we should break once we find a match
                if (callbackId === id) {
                    lifecycleCallbacks.splice(i, 1);
                    break;
                }
            }

            delete idToEventLookup[id];
        };


        if (!Array.isArray(supportedHooks)) {
            throw new TypeError('Lifecycle requires an Array of supported lifecycles');
        }

        // Clone this so that someone with the original array reference won't be allowed to update
        // after the list of supported Lifecycle events is initialized.
        supportedLifecycleEvents = edapHelpers.clone(supportedHooks);

        // Initialize the data structures
        lifecycle.reset();
    }

    return Lifecycle;
});

define('playback',['doneable', 'circularlog', 'edaphelpers'], function(Doneable, CircularLog, edapHelpers) {
    'use strict';

    function Playback(edap) {
        var playback = this,
            eventCounter = 0,
            defaultMaxLogEvents = 200,
            isDisabled = false,
            defaultEventLog = {
                id: null,
                eventName: null,
                data: null,
                executedListeners: []
            };


        /**
         *
         * Internal Methods
         *
         */


       /**
        *  Object contains the mark name -> event ID mapping
        */
        playback.marks = {};


       /**
        *  Array with the sequence of event triggers and their associated data
        */
        playback.eventLog = new CircularLog(defaultMaxLogEvents);


       /**
        *  Gets the next unique incrementing event ID
        *
        *  @private
        *  @returns {Integer} - The next unique incrementing event ID
        */
        playback.getNextEventID = function() {
            // Post-Incrementing meaning it will increment after it returns the value
            // ie. first time it runs it will return 0
            return eventCounter++;
        };


       /**
        *  Creates a new Event instance.
        *
        *  @private
        *  @returns {Object} - new Event instance
        */
        playback.createEventInstance = function() {
            var newLog = edapHelpers.clone(defaultEventLog);
            newLog.id = playback.getNextEventID();
            return newLog;
        };


       /**
        *  Gets the eventLog index position for the event ID associated with a mark.
        *
        *  @private
        *  @throws {Error} - If the proper index cannot be determined
        *  @param {String} [markName] - Name of the mark to find the correct index
        *  @returns {Array} - [index position in eventLog, number of missed events]
        */
        playback.getIndexOfMark = function(markName) {
            var logName = 'getIndexOfMark',
                eventLog = playback.eventLog.getEntries(),
                eventID = playback.marks[markName],
                index,
                missedEvents,
                err,
                i,
                len,
                ret;

            if (typeof eventID !== 'number') {
                err = new Error(logName + '(): invalid mark name ' + markName);
                edap.error(err);
                throw err;
            }

            // If we haven't hit the maxLogEvents and started shift()'ing off old events then eventID
            // should match up with the eventsLog index position.
            if (eventLog[eventID] && eventLog[eventID].id === eventID) {
                index = eventID;
                ret = [index, 0];

            // If we have hit the max and started dropping old events then we will search the eventLog
            // for the correct position that correlates to eventID value.
            } else {
                // If the oldest event in the log is more recent than the mark event ID then we know we
                // are going to miss some events. In that case we should just return 0 as the start index
                // and the number of missed events.
                if (eventLog[0].id > eventID) {
                    missedEvents = eventLog[0].id - eventID;
                    index = 0;
                    return [index, missedEvents];
                }

                // Otherwise we just search for the eventID in the log.
                for (i = 0, len = eventLog.length; i < len; i++) {
                    if (eventLog[i].id === eventID) {
                        index = i;
                        return [index, 0];
                    }
                }

                // If we can't find it or make sense of where it could be then we are going to throw an
                // error since we don't know how to play back events that we can't line up.
                err = new Error(logName + '(): could not find eventID=' + eventID);
                edap.error(err);
                throw err;
            }

            return ret;
        };


        /**
         *
         * Public Methods
         *
         */


       /**
        *  Sets the maximum number of log entries that will be stored. This is a circular buffer so
        *  the oldest entries will be flushed out to make room for newer entries. If the buffer is
        *  lowered below the current number of entries then this function will also flush out the oldest
        *  entries until it is at the new maximum number.
        *
        *  @public
        *  @throws {TypeError} - if parameter validation fails
        *  @param {Integer} [num] - New maximum number of entries to set, must be >= 0
        */
        playback.setMaxLogEvents = function(num) {
            var logName = 'setMaxLogEvents',
                err;

            if (typeof num !== 'number' || num < 0) {
                err = new TypeError(logName + '(): must be passed a positive integer or 0');
                edap.error(err);
                throw err;
            }

            playback.eventLog.setMaxEntries(num);
        };


       /**
        *  Resets the marks, eventLog, and event ID.
        *
        *  @public
        */
        playback.reset = function() {
            playback.eventLog = new CircularLog(defaultMaxLogEvents);
            playback.marks = {};
            eventCounter = 0;
        };


       /**
        *  Adds a new event and its associated data into the eventLog.
        *
        *  @public
        *  @param {String} [event] - Name of the event that was trigger()'d
        *  @param {String} [data] - Extended data that was passed to each listener for this event
        *  @returns {Object} - Event object or null if the Playback system is disabled.
        *                      When an Event object is returned it will have the following keys:
        *                          id - The incrementing event ID
        *                          eventName - name of the event
        *                          data - extended data passed to each listener
        *                          executedListeners - Array of listener UUID's that have been executed
        *                                              with this event
        */
        playback.addEvent = function(event, data) {
            var newLog;

            // If this is disabled then we bail
            if (isDisabled) {
                return null;
            }

            newLog = playback.createEventInstance();
            newLog.eventName = event;
            newLog.data = data;

            // Insert the new log into the eventLog
            playback.eventLog.push(newLog);
            return newLog;
        };


       /**
        *  Creates a named mark at the current event ID. This is used in conjunction with replay()
        *  so that you can replay the events from the mark to the most current event. Primarily used
        *  when code is being loaded async and you want to have that code process messages that were
        *  triggered before the code was loaded. Named marks must have unique names.
        *
        *  @public
        *  @param {String} [markName] - The name of the mark
        */
        playback.setMark = function(markName) {
            var logName = 'setMark',
                err;

            if (typeof markName !== 'string') {
                err = new TypeError(logName + '(): markName must be a string');
                edap.error(err);
                throw err;
            }

            if (playback.marks.hasOwnProperty(markName)) {
                err = new TypeError(logName + '(): ' + markName + ' already used');
                edap.error(err);
                throw err;
            }

            playback.marks[markName] = eventCounter;
        };


       /**
        *  Removes a mark from the playback system.
        *
        *  @public
        *  @throws {TypeError} - if parameter validation fails
        *  @param {String} [markName] - The name of the mark
        *  @returns {Boolean} - true if markName existed and was removed, otherwise false
        */
        playback.removeMark = function(markName) {
            var err;

            if (typeof markName !== 'string') {
                err = new TypeError('removeMark(): markName must be a string');
                edap.error(err);
                throw err;
            }

            if (playback.marks.hasOwnProperty(markName)) {
                delete playback.marks[markName];
                return true;
            }

            return false;
        };


       /**
        *  Replays events from the eventLog.
        *
        *  @public
        *  @throws {TypeError} - if parameter validation fails
        *  @param {String} [optMarkName] - Name of the mark to start replaying from. Defaults to 'init'.
        *  @param {Object} [triggerOpts] - Options to pass into each trigger() call for
        *                                  each message that is being replayed.
        *  @returns {Doneable} - Resolves when all the callbacks for the event are done
        */
        playback.replay = function(optMarkName, triggerOpts) {
            var logName = 'replay',
                triggerDoneables = [],
                triggerDone,
                eventLog,
                clonedEventLog,
                indexInfo,
                startIndex,
                missedEvents,
                i,
                len,
                err;

            // defaults to the "init" mark if none is passed
            optMarkName = optMarkName || 'init';
            triggerOpts = triggerOpts || {};

            if (!playback.marks.hasOwnProperty(optMarkName)) {
                err = new TypeError(logName + '(): cannot find markName=' + optMarkName);
                edap.error(err);
                throw err;
            }

            eventLog = playback.eventLog.getEntries();
            indexInfo = playback.getIndexOfMark(optMarkName);

            // Decode info into more readable variable names
            startIndex = indexInfo[0];
            missedEvents = indexInfo[1];

            // If we have missed some events then log it
            if (missedEvents > 0) {
                edap.error(logName + '(): missed ' + indexInfo[1] + ' events in replay');
            }

            // Get a non-deep clone so that we preserve the original list, but get the references
            // to the Event objects stored in each index position.
            clonedEventLog = edapHelpers.clone(eventLog);

            for (i = startIndex, len = clonedEventLog.length; i < len; i++) {
                // For each event we want to pass in the event info and data. The "forceData" flag is set so that
                // this trigger won't extend the current ADL over the data, it will just use the data as is. The
                // "playbackObj" is passed so that trigger won't execute any previously executed listeners and so
                // it can update the EventLog entry with any new listeners that get executed.
                triggerDone = edap.trigger(clonedEventLog[i].eventName, clonedEventLog[i].data, edapHelpers.defaults(
                    {},
                    [triggerOpts,
                        {
                            forceData: true,
                            playbackObj: clonedEventLog[i]
                        }
                    ]
                ));
                triggerDoneables.push(triggerDone);
            }

            // We are providing a Doneable return value so that it is possible to wait until all events that
            // need to be replayed are complete.
            return Doneable.all(triggerDoneables);
        };


       /**
        *  Enables the Playback system to log events into the eventLog for replay.
        *
        *  @public
        */
        playback.enable = function() {
            isDisabled = false;
        };


       /**
        *  Disables logging of events into the eventLog. This only disables the logging, it does not
        *  clear any existing logs. If you want to clear existing data use playback.reset().
        *
        *  @public
        */
        playback.disable = function() {
            isDisabled = true;
        };


       /**
        *  Helper to check if the playback system is logging events to the eventLog.
        *
        *  @public
        *  @returns {Boolean} - if playback logging is disabled then it returs true, otherwise false
        */
        playback.isDisabled = function() {
            return isDisabled;
        };

        return playback;
    }

    return Playback;
});

define('edap',[
    'circularlog',
    'consolehelpers',
    'cookieparser',
    'doneable',
    'edaphelpers',
    'featureflag',
    'features',
    'lifecycle',
    'playback'
], function(CircularLog, ConsoleHelpers, cookieParser, Doneable, edapHelpers, FeatureFlag, Features, Lifecycle, Playback) {
    'use strict';

    /**
     *  Event-driven Data Abstraction Platform (EDAP)
     *
     *  EDAP is a front-end event bus that is purpose built to handle event-based analytics. Some of the primary
     *  advantages are:
     *   - Increases data integrity since all callbacks are based on the same event, with the same data
     *   - Allows for extending your data layer on a per-event basis without worrying about race conditions
     *   - Has a built-in history function to help understand what is happening on the event bus
     *   - Can handle page-transition events on the next page, therefore increasing the chances of data being collected
     *   - Event listeners have the ability to report when async operations are complete
     *
     *  @constructor
     *  @param {Object} [edapOptions] - Supported properties:
     *                                      {String} [dataLayerName] - name of the data layer in the window (default: "analyticsdatalayer")
     *                                      {String} [ns] - window namespace to expose EDAP (default: "edap")
     *                                      {Boolean} [noAMD] - when set to true it will not expose EDAP as a requirejs module
     */
    function Edap() {
        var persistentLogger = {},
            loggingKey = 'delayProcessing',
            uuidRegex = new RegExp('^[a-z0-9]{8}-[a-z0-9]{4}-4[a-z0-9]{3}-[a-z0-9]{4}-[a-z0-9]{12}$'),
            edapError = 'edap.error',
            edapLoadCookie = 'edap.load.cookie',
            edapFlush = 'edap.flush',
            defaultMaxHistoryEntries = 200,
            edapReset = 'edap.reset',
            keyPrefix = 'edap:',
            // The list of all events that are triggered or listened to in core EDAP
            coreSupportedEvents = [
                edapError,
                edapFlush,
                edapReset
            ],
            onEventTriggerHookName = 'onEventTrigger',
            onEventDataExtractionHookName = 'onEventDataExtraction',
            onEventCompleteHookName = 'onEventComplete',
            onListenerAddedHookName = 'onListenerAdded',
            onListenerRemovedHookName = 'onListenerRemoved',
            supportedLifecycleHooks = [
                onEventTriggerHookName,
                onEventDataExtractionHookName,
                onEventCompleteHookName,
                onListenerAddedHookName,
                onListenerRemovedHookName
            ],
            ignoredConsoleEvents,
            now,
            hasPerformanceNow,
            winPerformance,
            configCookieData,
            env,
            edapThis,
            edapPublic,
            edapInternal;

        // Setup pointers to different objects for easier maintainability
        edapThis = this;
        edapThis.internal = {};
        edapThis['public'] = {};
        edapInternal = edapThis.internal;
        edapPublic = edapThis['public'];


        // Set the version
        edapThis.edapVersion = '5.0.0';


        /**
         *
         * Internal Methods
         *
         */

        edapInternal.reset = function() {
            edapThis.logs = {
                error: []
            };

            edapInternal.inError = false;
            edapInternal.listeners = {};
            edapInternal.events = {};
            edapInternal.history = new CircularLog(defaultMaxHistoryEntries);
            edapInternal.scopes = {};
            edapInternal.savedCmds = null;
            edapInternal.config = {
                maxWaitTime: 2  // in seconds
            };

            // Reset the list of ignored console events
            ignoredConsoleEvents = {};

            // Initialize UUID cached values
            edapInternal.initializeUuidGeneration();

            // Reset any defined lifecycle hooks
            edapPublic.lifecycle.reset();
        };

        /**
         *  Takes a boolean expression (isValid) and handles logging and throwing Exceptions if it isn't true
         *
         *  @private
         *  @param {Boolean} [isValid] - Value of the expression that should be true
         *  @param {String} [errStr] - The error to log in the Exception, if needed
         */
        edapInternal.validateCondition = function(isValid, errStr) {
            var err;

            if (!isValid) {
                err = new TypeError(errStr);
                edapThis.error(err);
                throw err;
            }
        };


        /**
         *  Takes an Array instance and returns an object where the keys are the array
         *  index values and the values are true.
         *
         *  @private
         *  @param {Array} [arr] - Array of toString()'able values
         *  @returns {Object} - Keys are the arr values, values are set to true.
         */
        edapInternal.arrayToObject = function(arr) {
            var ret = {},
                i,
                len;

            edapInternal.validateCondition(arr instanceof Array, 'arrayToObject(): arr not passed an Array');

            for (i = 0, len = arr.length; i < len; i++) {
                ret[arr[i]] = true;
            }

            return ret;
        };


        /**
         *  History logger.
         *  All log entries will be available in Edap.internal.history
         *
         *  @private
         *  @param {String} [log] - Wraps the String in an Array and pushes into the log
         */
        edapInternal.logHistory = function(log) {
            edapInternal.history.push([log]);
        };


        /**
         *  Should be used only once when flushing any existing window.edap queued commands.
         *  It will run each command by passing it into Edap.push().
         *  @see edapThis.push
         *
         *  @private
         *  @param {Array} [cmds] - Array of Arrays of commands to execute
         */
        edapInternal.flushAsyncCommands = function(cmds) {
            var currentCmd;

            while (cmds.length > 0) {
                currentCmd = cmds.shift(); // remove elements from array as we go to prevent any looping
                try {
                    edapThis.push.call(edapThis, currentCmd);
                } catch (e) {}
            }
        };

        /**
         *  Gets the data associated with the key in storage.
         *
         *  @param {String} key - The key the data is associated with*
         *  @param {Object} storageOpts - Options for configuring the storage engine
         *  @returns {Object} - The data object from storage associated with the key, or null
         *                      if the key is missing or an error occurs in decoding the data
         */
        persistentLogger.get = function(key, storageOpts) {
            var data = null,
                possibleStorages = ['localStorage', 'sessionStorage'],
                storages = 'localStorage';

            if (storageOpts && storageOpts.storages && possibleStorages.indexOf(storageOpts.storages) !== -1) {
                storages = storageOpts.storages;
            }

            key = keyPrefix + key;

            try {
                data = window[storages].getItem(key);
            } catch (e) {
                edapThis.error(e);
            }

            return (typeof data === 'string') ? JSON.parse(data) : data;
        };

        /**
         * Sets a key-value pair in storage
         *
         * @param {String} key - The key to store the data under
         * @param {Any} value - The value to store at `key`
         * @param {Object} storageOpts - Options to pass about how to persist the data
         * @returns {Boolean} - true if the data was set, false if it was not
         */
        persistentLogger.set = function(key, value, storageOpts) {
            var storages = 'localStorage';

            if (storageOpts && storageOpts.storages) {
                storages = storageOpts.storages;
            }

            // everything edap-related gets prefixed before setting it
            key = keyPrefix + key;

            // setItem() expects value to be a string
            if (typeof value !== 'string') {
                value = JSON.stringify(value);
            }

            try {
                window[storages].setItem(key, value);
                return true;
            } catch (e) {
                edapThis.error(e);
            }

            return false;
        };

        /**
         *  Gets the Persistent Logging instance used by EDAP
         *
         *  @private
         *  @returns {Object} - the persistent logger instance used by EDAP
         */
        edapInternal.getPersistentLogger = function() {
            return persistentLogger;
        };

        /**
         *  Removes an item from client-side storage based on matching the eventName and JSON.stringify
         *  matching the data.
         *
         *  @private
         *  @param {String} [eventName] - Name of the event
         *  @param {String} [data] - Event-specific data to be extended into the global Data Layer
         *  @returns {Boolean} - true: if successful, false: if not
         */
        edapInternal.removeCmd = function(eventName, data) {
            var ret = false,
                existingCmds,
                jsonData,
                i,
                len;

            try {
                existingCmds = persistentLogger.get(loggingKey);
                jsonData = JSON.stringify(data);

                if (existingCmds === null) {
                    return true;
                }

                if (existingCmds && existingCmds.hasOwnProperty('ver')) {
                    for (i = 0, len = existingCmds.cmds.length; i < len; i++) {
                        if (eventName === existingCmds.cmds[i][0] && jsonData === JSON.stringify(existingCmds.cmds[i][1])) {
                            existingCmds.cmds.splice(i, 1);

                            // Force this loop to end
                            i = len;
                        }
                    }
                    persistentLogger.set(loggingKey, existingCmds);

                    ret = true;
                } else {
                    edapThis.error(new TypeError('removeCmd found incorrectly formatted cmd data: ' + JSON.stringify(existingCmds)));
                }
            } catch (e) {
                edapThis.error(e);
            }

            return ret;
        };

        /**
         *  Execute all the client-side stored events
         *
         *  @private
         *  @param {String} [eventName] - Name of the event
         *  @param {String} [data] - Event-specific data to be extended into the global Data Layer
         *  @returns {Doneable} - Will resolve when all the stored events have completed processing
         */
        edapInternal.processStoredCmds = function() {
            return new Doneable(function(done) {
                var completeCmds = 0,
                    existingCmds,
                    err,
                    numCmds,
                    i;

                function checkDone() {
                    completeCmds++;
                    if (completeCmds === numCmds) {
                        done();
                    }
                }

                function triggerCmd(idx) {
                    var eventName = existingCmds.cmds[idx][0],
                        data = existingCmds.cmds[idx][1];

                    edapThis.trigger(eventName, data).then(function() {
                        edapInternal.removeCmd(eventName, data);
                        checkDone();
                    });
                }

                try {
                    existingCmds = persistentLogger.get(loggingKey);
                } catch (e) {
                    edapThis.error(e);
                    done();
                    return;
                }

                if (existingCmds === null) {
                    done();
                    return;
                }

                if (!existingCmds || !existingCmds.hasOwnProperty('ver')) {
                    err = new TypeError('processStoredCmds(): stored values not in the correct format: ' + JSON.stringify(existingCmds));
                    edapThis.error(err);
                    done();
                    return;
                }

                numCmds = existingCmds.cmds.length;

                for (i = 0; i < numCmds; i++) {
                    triggerCmd(i);
                }
            }, {error: edapThis.error});
        };

        /**
         *  Gets a list of related listener uuids to an event name. Events can be hierarchical so the the
         *  hierarchy is traversed in most specific to least specific order. Example:
         *    eventName: 'test.foo.bar'
         *    Callbacks would be concatentated in the following order:
         *      test.foo.bar
         *      test.foo.*
         *      test.*
         *      *
         *
         *  @private
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [eventName] - Name of the event
         *  @returns {Array} - Array of listener uuids related to eventName in
         *                     most specific to least specific order
         */
        edapInternal.getCallbacks = function(eventName) {
            var logName = 'getCallbacks',
                ret = [],
                parts,
                newParts,
                newEventName,
                i;

            edapInternal.validateCondition(typeof eventName === 'string', logName + '(): eventName must be a string');

            parts = eventName.split('.');
            for (i = parts.length; i > 0; i--) {
                newParts = parts.slice(0, i);
                newEventName = newParts.join('.');

                if (eventName === newEventName) {
                    if (edapInternal.events.hasOwnProperty(newEventName)) {
                        ret = ret.concat(edapInternal.events[newEventName]);
                    }
                }

                newParts[i - 1] = '*';
                newEventName = newParts.join('.');

                if (edapInternal.events.hasOwnProperty(newEventName)) {
                    ret = ret.concat(edapInternal.events[newEventName]);
                }
            }

            return ret;
        };


        /**
         *  Parses the edapConfig cookie and loads the config appropriately
         *  Currently it supports the following options:
         *      logging: 'on' | 'off' - force enable/disable logging regardless of environment
         *      logLevel: see consolehelpers - sets the console logging level where messages are logged
         *      historySize: number - Sets the max history entries for EDAP to maintain internally
         *      playbackSize: number - Sets the max size of the saved event queue used for Playback
         */
        edapInternal.setupFromCookie = function() {
            var asInteger = edapInternal.asInteger;

            // Setup the console logging logic
            configCookieData = cookieParser.getConfigData();

            if (configCookieData.logging === 'on') {
                edapPublic.console.enable();
            } else if (configCookieData.logging === 'off') {
                edapPublic.console.disable();
            } else {
                env = edapThis.getEnv();

                // By default disable it for all environments
                edapPublic.console.disable();

                // Enable it only for certain environments if not overwritten by the cookie
                if (env === 'test' || env === 'stage' || env === 'dev') {
                    edapPublic.console.enable();
                }
            }

            if (configCookieData.hasOwnProperty('logLevel')) {
                edapPublic.console.setLogLevel(configCookieData.logLevel);
            }

            if (configCookieData.hasOwnProperty('logReplays')) {
                edapInternal.shouldLogReplayedEvents = (configCookieData.logReplays === 'on') ? true : false;
            }

            if (configCookieData.hasOwnProperty('historySize')) {
                edapInternal.history.setMaxEntries(asInteger(configCookieData.historySize));
            }

            if (configCookieData.hasOwnProperty('playbackSize')) {
                edapPublic.playback.setMaxLogEvents(asInteger(configCookieData.playbackSize));
            }
        };


        /**
         *  Attempts to create a new unique GUID.
         *
         *  @returns {Object} - rfc4122 version 4 compliant guid, or null if it cannot create a unique guid
         */
        edapInternal.getUniqUuid = function() {
            var maxUuidAttempts = 10,
                uuid = edapPublic.createUuid(),
                i;

            for (i = 0; i < maxUuidAttempts; i++) {
                if (!edapInternal.listeners.hasOwnProperty(uuid)) {
                    return uuid;
                }

                uuid = edapPublic.createUuid();
            }

            edapThis.error(new Error('could not generate a unique UUID'));

            return null;
        };


        /**
         *  Executes a listener with the passed in data
         *
         *  @private
         *  @param {String} [uuid] - rfc4122 version 4 compliant guid, must be registered via on() or once()
         *  @param {Object} [data] - data object to pass into the listener
         *  @returns {Doneable} - Resolves when the listeners callback has been resolved
         */
        edapInternal.executeListener = function(uuid, data) {
            var logName = 'executeListener';

            return new Doneable(function(done) {
                var isAsync = false,
                    uuidRecord,
                    err;

                function setAsync() {
                    isAsync = true;
                }

                try {
                    uuidRecord = edapInternal.listeners[uuid];
                    uuidRecord.func.call(edapThis, data, setAsync, done);
                    uuidRecord.executedCount++;

                    if (!isAsync) {
                        done();
                    }
                } catch (e) {
                    err = new Error(logName + '(): error caught in processing listener: ' + uuid + ' stacktrace:' + e.stack);
                    edapThis.error(err, data);
                    done();
                }
            }, {
                error: edapThis.error
            });
        };


        /**
         *  Builds the data object to be used in trigger(). It will extend optData over the ADL allowing anything
         *  in the optData to overwrite an ADL value.
         *
         *  @private
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [eventName] - name of the event to be added to the optData object
         *  @param {Object} [optData] - Priority data object that will be extended over the ADL
         *  @param {Object} [opts] - forceData: if set to true then optData will be cloned and returned, not extended over the ADL
         *  @returns {Object} - extended data object from the ADL and passed in optData param
         */
        edapInternal.buildTriggerData = function(eventName, optData, opts) {
            var clonedData;

            edapInternal.validateCondition(typeof eventName === 'string', 'buildTriggerData(): called without an eventName');

            optData = optData || {};
            opts = opts || {};

            if (opts.forceData) {
                return edapPublic.clone(optData);
            }

            clonedData = edapPublic.extend(edapThis.getDL(), optData);

            // Inject this directly into EDAP shrinkwrapped data
            clonedData.edapeventname = eventName;

            // 'onEventDataExtraction' Lifecycle hook, return just the clonedData value
            return edapPublic.lifecycle.execute('onEventDataExtraction', [eventName, clonedData, opts])[1];
        };


        /**
         *  Creates a listener in the EDAP internals
         *
         *  @private
         *  @param {Function} [cb] - Callback to use when creating the listener
         *  @returns {String} - UUID of the listener or null if no UUID can be generated
         */
        edapInternal.createListener = function(cb) {
            var uuid = edapInternal.getUniqUuid();

            if (uuid !== null) {
                // Store the callback in the listeners lookup table
                edapInternal.listeners[uuid] = {
                    func: cb,
                    executedCount: 0
                };
            }

            return uuid;
        };


        /**
         *  Removes listener from the EDAP internals
         *
         *  @private
         *  @param {String} [uuid] - UUID of the listener to remove
         */
        edapInternal.removeListener = function(uuid) {
            // If it doesn't exist then return as if we deleted it
            if (edapPublic.getListener(uuid) === null) {
                return;
            }

            // if it does exist then delete it
            delete edapInternal.listeners[uuid];
        };


        /**
         *  Removes listener from EDAP and any events that it was registered.
         *
         *  @private
         *  @param {String} [uuid] - UUID of the listener to remove
         */
        edapInternal.removeListenerFromEvents = function(uuid) {
            var logName = 'removeListenerFromEvents',
                eventsIndex,
                uuidIndex,
                eventsIndexLen,
                evtUuidlen,
                events,
                eventQueue,
                evt;

            // We don't return immediately if it isn't a listener because we want to do our best to make sure
            // everything is cleaned up properly. That way if the listener object is out-of-sync from the events
            // object then at least we will have made sure this uuid is removed from both.

            events = edapPublic.getEventNames();

            // Delete the Listener
            edapInternal.removeListener(uuid);

            // Find which event it was registered for and removed it from the list of listeners
            for (eventsIndex = 0, eventsIndexLen = events.length; eventsIndex < eventsIndexLen; eventsIndex++) {
                eventQueue = events[eventsIndex];
                evt = edapPublic.getEvent(eventQueue);
                for (uuidIndex = 0, evtUuidlen = evt.length; uuidIndex < evtUuidlen; uuidIndex++) {
                    if (evt[uuidIndex] === uuid) {
                        // NOTE: Splicing an array while looping over it is dangerous. This only works because we bail out of
                        //       the immediately after splicing the array. If this ever changes then this logic will need to be
                        //       modified to make sure we actually loop over what we think we loop over.
                        evt.splice(uuidIndex, 1);
                        edapInternal.logHistory([logName + '():', 'removed uuid', uuid, 'from', eventQueue, 'queue'].join(' '));
                        edapPublic.lifecycle.execute(onListenerRemovedHookName, [eventQueue, uuid]);
                        return;
                    }
                }
            }
        };


        /**
         *  Adds listeners UUIDs to an event so that when the event is trigger()'d the listener will be called
         *
         *  @private
         *  @param {String} [eventName] - name of event
         *  @param {String} [listenerUuid] - UUID of the listener to add
         */
        edapInternal.addListenerToEvent = function(eventName, listenerUuid) {
            var events = edapInternal.events,
                evt = edapPublic.getEvent(eventName);

            // Store the UUID of the callback with the associated event
            if (evt instanceof Array) {
                evt.push(listenerUuid);
            } else {
                events[eventName] = [listenerUuid];
            }
        };


        /**
         *  Used for defaulting undefined and null values to an object
         *
         *  @private
         *  @param {Any} [obj] - value to check if it is null/undefined
         *  @returns {Object} - Returns an object if the input value was null/undefined,
         *                      otherwise the original value
         */
        edapInternal.defaultToObj = function(obj) {
            if (obj === undefined || obj === null) {
                return {};
            }
            return obj;
        };


        /**
         *  Initializes the cached values needed to make UUIDv4 performant.
         *
         *  @private
         */
        edapInternal.initializeUuidGeneration = function() {
            var lut = edapInternal.hexLookupTable,
                lutLength = lut.length,
                win = edapPublic.getWindow(),
                i;

            for (i = 0; i < lutLength; i++) {
                lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
            }

            // Have to cache the pointers like this because of http://stackoverflow.com/questions/17899598/typeerror-this-is-not-a-date-object
            if (win.Date && typeof win.Date.now === 'function') {
                now = function() {
                    return win.Date.now();
                };
            } else {
                now = function() {
                    return (new win.Date()).getTime();
                };
            }

            hasPerformanceNow = (win.performance && typeof win.performance.now === 'function');
            winPerformance = hasPerformanceNow ? win.performance : null;
        };


        /**
         *  Lookup table used to map 0-255 to the hex values. This value is populated during
         *  EDAP initialization.
         *
         *  @private
         */
        edapInternal.hexLookupTable = new Array(256);


        /**
         *  Returns the Integer representation of a value, or throws an exception
         *
         *  @private
         *  @throws {TypeError} - val is not parseInt()'able (aka NaN)
         *  @returns {Number} - Integer representation of the input value
         */
        edapInternal.asInteger = function(val) {
            var ret = parseInt(val, 10);

            if (isNaN(ret)) {
                throw new TypeError(val + ' cannot be parseInt()\'d into a number');
            }

            return ret;
        };

        /**
         *
         * Public Methods
         *
         */


        /**
         *  Array of internal events that EDAP fires
         *
         *  @public
         */
        edapPublic.coreSupportedEvents = coreSupportedEvents;


        /**
         *  Helper function that will return if an eventName is used by the core EDAP system
         *
         *  @public
         *  @param {String} [eventName] - Name of the event
         *  @returns {Boolean} - if the eventName is in the coreSupportedEvents list
         */
        edapPublic.isCoreEdapEvent = function(eventName) {
            return edapPublic.coreSupportedEvents.indexOf(eventName) > -1;
        };


        /**
         *  Set an event name to the list of events that will NOT be logged to console
         *
         *  @public
         *  @param {String} [eventName] - Name of the event
         */
        edapPublic.addIgnoredConsoleEvent = function(eventName) {
            ignoredConsoleEvents[eventName] = true;
        };


        /**
         *  Remove an event name to the list of events that will NOT be logged to console
         *
         *  @public
         *  @param {String} [eventName] - Name of the event
         */
        edapPublic.removeIgnoredConsoleEvent = function(eventName) {
            delete ignoredConsoleEvents[eventName];
        };


        /**
         *  Helper function that will return if an eventName is supposed to be ignored
         *  when logging events to console
         *
         *  @public
         *  @param {String} [eventName] - Name of the event
         *  @returns {Boolean} - if the eventName is in the ignoredConsoleEvents list
         */
        edapPublic.isIgnoredConsoleEvent = function(eventName) {
            return ignoredConsoleEvents[eventName] === true;
        };


        /**
         *  Recursive clone to give you a deep copy of your Object.
         *
         *  @link https://lodash.com/docs#clone
         *  @public
         *  @param {*} [src] - Object to clone
         *  @returns {Object} - New deeply cloned object from the src.
         */
        edapPublic.clone = function(src) {
            return edapHelpers.clone(src);
        };

        /**
         *  Assigns own enumerable properties of source object(s) to the destination object for all destination properties that resolve to undefined.
         *  Once a property is set, additional values of the same property are ignored.
         *  A replacement for Lodash's _.defaults()
         *
         *  @param {Object} [destinationObj] - The destination object to merge options into and then return
         *  @param {Array} [sourceObjArr] - An array of options objects
         *  @returns {Object} - The merged options object
         */
        edapPublic.defaults = function(destinationObj, sourceObjArr) {
            return edapHelpers.defaults(destinationObj, sourceObjArr);
        };

        /**
         *  Iterates over own enumerable properties of an object invoking a function for each property.
         *  A replacement for Lodash's _.forOwn()
         *
         *  @param {Object} [obj] - The destination object to merge options into and then return
         *  @param {Function} [iteratee] - The function invoked per iteration
         */
        edapPublic.forOwn = function(obj, iteratee) {
            return edapHelpers.forOwn(obj, iteratee);
        };


        /**
         *  Will return a cloned and extended object that is assigned from left to right, last one wins
         *
         *  @link https://lodash.com/docs#assign
         *
         *  @example
         *  edap.public.extend({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
         *  returns: { 'user': 'fred', 'age': 40 }
         *
         *  @public
         *  @param {...Object} - Source objects that will be assigned from left to right, last one wins
         *  @returns {Object} - The destination object
         */
        edapPublic.extend = function() {
            var args = Array.prototype.slice.call(arguments),
                i,
                arg;

            args.unshift({});

            for (i = 0; i < args.length; i++) {
                for (arg in args[i]) {
                    if (args[i].hasOwnProperty(arg)) {
                        args[0][arg] = args[i][arg];
                    }
                }
            }

            return edapPublic.clone(args[0]);
        };


        /**
         *  Create a new UUIDv4
         *  This uses the ms since epoch and current nanoseconds on page to add additional entropy into
         *  the random values. Modified from http://stackoverflow.com/a/21963136.
         *  See jsfiddle link for performance comparisions the initial UUID generator and this
         *  one.
         *  @link http://jsfiddle.net/1hfx4qnh/6/
         *
         *  @public
         *  @returns {String} - rfc4122 version 4 compliant guid
         */
        edapPublic.createUuid = function() {
            var seed = now(),
                lut = edapInternal.hexLookupTable,
                d0,
                d1,
                d2,
                d3;

            if (hasPerformanceNow) {
                seed += winPerformance.now();
            }

            /* eslint-disable no-bitwise */

            d0 = (seed * Math.random()) | 0;
            d1 = (seed * Math.random()) | 0;
            d2 = (seed * Math.random()) | 0;
            d3 = (seed * Math.random()) | 0;

            return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
                lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
                lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
                lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];

            /* eslint-enable no-bitwise */
        };


        /**
         *  Abstraction around getting the window-level EDAP singleton
         *
         *  @public
         *  @returns {Object} - Returns the window EDAP singleton
         */
        edapPublic.getGlobal = function() {
            return edapHelpers.getEdapGlobal();
        };


        /**
         *  Abstraction around getting the EDAP global options
         *
         *  @public
         *  @returns {Object} - Returns the window EDAP singleton
         */
        edapPublic.getGlobalOptions = function() {
            return edapHelpers.getGlobalOptions();
        };


        /**
         *  ConsoleHelpers instance for logging to the console
         */
        edapPublic.console = new ConsoleHelpers();
        edapPublic.ConsoleHelpers = ConsoleHelpers;


        /**
         *  Gets a Listener object from the EDAP internals
         *
         *  @public
         *  @param {String} [uuid] - UUID of the listener
         *  @param {Object} - Listener object, or null if there is no listener with that UUID
         */
        edapPublic.getListener = function(uuid) {
            if (edapInternal.listeners.hasOwnProperty(uuid)) {
                return edapInternal.listeners[uuid];
            }

            return null;
        };


        /**
         *  Gets an Event object from the EDAP internals
         *
         *  @public
         *  @param {String} [eventName] - name of the Event
         *  @param {Array} - Event Array, or null if there is no event with that name
         */
        edapPublic.getEvent = function(eventName) {
            if (edapInternal.events.hasOwnProperty(eventName)) {
                return edapInternal.events[eventName];
            }

            return null;
        };


        /**
         *  Gets the list of Event names that have listeners registered
         *
         *  @public
         */
        edapPublic.getEventNames = function() {
            return Object.keys(edapInternal.events);
        };


        /**
         *  Gets the list of listener objects for a single Event
         *
         *  @public
         *  @param {String} [eventName] - Event to get the list of listeners
         *  @returns {Array} - List of Listener objects associated with an Event
         *                     or null if the Event does not exist
         */
        edapPublic.getListenersForEvent = function(eventName) {
            var retData = [],
                eventRef,
                i,
                len;

            eventRef = edapPublic.getEvent(eventName);

            if (eventRef === null) {
                return null;
            }

            for (i = 0, len = eventRef.length; i < len; i++) {
                retData.push(edapPublic.getListener(eventRef[i]));
            }

            return retData;
        };


        /**
         *  Getter for the window object, mainly for spy-based testing and abstraction
         *
         *  @public
         *  @returns {Object} - The window object
         */
        edapPublic.getWindow = function() {
            return edapHelpers.getWindow();
        };


        /**
         *  Playback instance that manages logging and replaying events
         *
         *  @public
         */
        edapPublic.playback = new Playback(edapThis);


        /**
         *  FeatureFlag constructor for creating new FeatureFlag objects
         *
         *  @public
         */
        edapPublic.FeatureFlag = FeatureFlag;


        /**
         *  Features object that provides access to any FeatureFlags loaded in EDAP
         *
         *  @public
         */
        edapPublic.features = new Features(edapThis);


        /**
         *  Lifecycle object that provides access to the lifecycle engine in EDAP
         *
         *  @public
         */
        edapPublic.lifecycle = new Lifecycle(supportedLifecycleHooks);


        /**
         *
         *  Core Methods
         *
         */


        /**
         *  Assign a callback to an event.
         *  Callbacks can be either synchronous or asynchronous. See examples for more info
         *
         *  NOTE: If you create an async callback you MUST be sure that the callback calls
         *        the setAsync() function in normal synchronous execution of the function, and
         *        guarentee that done() is always called at some point. Not calling done()
         *        will block the Edap.trigger Doneable from resolving and running any associated
         *        callbacks.
         *
         *  @example
         *  // Non-async callback function assigned to the 'myEvent' event
         *  var uuid = Edap.on('myEvent', function(data) {
         *      // do something when 'myEvent' is fired. You also have access to all the data!
         *  });
         *
         *  @example
         *  // Async callback function assigned to the 'myEvent' event
         *  // NOTE: It you are creating a sync callback you MUST
         *  var uuid = Edap.on('myEvent', function(data, setAsync, done) {
         *      setAsync();
         *      // Notice I assigned to .always() instead of .done() to guarentee done()
         *      // is called even if the GET request fails.
         *      $.get('/some/endpoint').always(done);
         *  });
         *
         *  @method
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [eventName] - Name of the event, cannot be a uuid
         *  @param {Function} [cb] - The callback to register with the event. See examples for more details
         *  @param {Object} [opts] - Supported options:
         *                            - logName: overrides the existing logName to put into Edap history
         *  @returns {String|null} - rfc4122 version 4 compliant guid or null if a guid could not be created
         */
        edapThis.on = function(eventName, cb, opts) {
            var uuid,
                logName,
                err;

            opts = opts || {};
            logName = opts.logName || 'on';

            edapInternal.logHistory(['Called', logName + '()', 'for event', eventName, 'with', JSON.stringify(opts)].join(' '));

            // Validate input parameters
            edapInternal.validateCondition(typeof eventName === 'string', logName + '(): eventName must be a string');
            edapInternal.validateCondition(!eventName.match(uuidRegex), logName + '(): eventName cannot be a uuid');
            edapInternal.validateCondition(typeof cb === 'function', logName + '(): cb must be a function');

            // Get the unique UUID
            uuid = edapInternal.createListener(cb);

            if (uuid === null) {
                err = new TypeError(logName + '(): cannot create UUID');
                edapThis.error(err);
                return null;
            }

            edapInternal.addListenerToEvent(eventName, uuid);

            edapInternal.logHistory([logName + '():', 'Added event listener for', eventName].join(' '));

            edapPublic.lifecycle.execute(onListenerAddedHookName, [eventName, uuid]);

            return uuid;
        };


        /**
         *  Removes a callback. See examples.
         *
         *  @example
         *  // Remove all the callbacks for a specific event
         *  Edap.off('myEvent');
         *
         *  @example
         *  Removes the uuid from being a callback
         *  Edap.off(uuid);
         *
         *  @method
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [eventNameOrUuid] - event name or uuid to remove
         */
        edapThis.off = function(eventNameOrUuid) {
            var logName = 'off',
                uuids,
                i,
                len;

            if (typeof eventNameOrUuid === 'string') {
                // Passed in a UUID
                if (eventNameOrUuid.match(uuidRegex)) {
                    edapInternal.logHistory(['Called', logName + '()', 'with uuid', eventNameOrUuid].join(' '));

                    edapInternal.removeListenerFromEvents(eventNameOrUuid);

                // Passed in an event name
                } else {
                    edapInternal.logHistory(['Called', logName + '()', 'with string', eventNameOrUuid].join(' '));

                    uuids = edapPublic.getEvent(eventNameOrUuid);

                    if (uuids !== null) {
                        // Raw access to the edapInternals.events so we can set the [] directly
                        edapInternal.events[eventNameOrUuid] = [];

                        // Make sure we trigger a "removedListener" event and remove the callback from the listeners hash
                        for (i = 0, len = uuids.length; i < len; i++) {
                            // while it is possible that something may be out-of-sync, we should always publish a "removed" message in an attempt to
                            // get everything else in sync. The intent is to delete a listener, so even if it doesn't currently exist it is still
                            // deleted after finishing this removeListener() call
                            edapInternal.removeListener(uuids[i]);

                            edapPublic.lifecycle.execute(onListenerRemovedHookName, [eventNameOrUuid, uuids[i]]);
                        }

                        edapInternal.logHistory([logName + '():', 'cleared all cbs for', eventNameOrUuid, 'event'].join(' '));
                    }
                }
            } else {
                edapInternal.logHistory(['Called', logName + '()', 'invalid'].join(' '));

                edapInternal.validateCondition(false, logName + '(): must be passed an event name string or a function');
            }

            return;
        };


        /**
         *  Sets a callback for an event that will only fire once. Supports all types of callbacks
         *  supported by on();
         *  @see this.on
         *
         *  @method
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [eventName] - Name of the event
         *  @param {Function} [cb] - The callback to register with the event. See on() examples for more details
         *  @param {Object} [opts] - Supported options: see on() options
         *  @returns {String} - rfc4122 version 4 compliant guid
         */
        edapThis.once = function(eventName, cb, opts) {
            var onUuid;

            // Remove the listener before executing the callback so that it is impossible to get in an infinite loop
            // if the callback triggers the same eventName again.
            function runOnce() {
                edapThis.off(onUuid);
                cb.apply(edapThis, arguments);
            }

            opts = opts || {};
            opts.logName = 'once';

            onUuid = edapThis.on(eventName, runOnce, opts);

            return onUuid;
        };


        /**
         *  Trigger an event and fire all the associated callbacks
         *
         *  @example
         *  // Firing an event with only the Data Layer being passed
         *  Edap.trigger('myEvent');
         *
         *  @example
         *  // Firing an event with event-specific data only the Data Layer being passed
         *  Edap.trigger('myEvent', {mydata1: 1, mydata2: 2});
         *
         *  @example
         *  // Sets a maxWaitTime of 4 seconds to finish processing all event listeners
         *  // related to the 'myEvent' event. Overwrites the default maxWaitTime in
         *  // edap.internal.config.maxWaitTime.
         *  Edap.trigger('myEvent', {mydata1: 1, mydata2: 2}, {maxWaitTime: 4});
         *
         *  @example
         *  // Firing an event and assigning a callback when all the event processing
         *  // has completed
         *  Edap.trigger('myEvent', {mydata1: 1, mydata2: 2}).then(function() {
         *      // do something now that all the event callbacks are done
         *  });
         *
         *  @method
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [eventName] - Name of the event, cannot trigger wildcard event explicitly
         *  @param {Object} [data] - Event-specific key/value pairs to be extended over the global Data Layer
         *  @param {Object} [opts] - Supported options:
         *                            - maxWaitTime: time in seconds to wait for callbacks to complete before calling the
         *                                           trigger complete callback. Overwrites the Edap default maxWaitTime of 2 seconds.
         *                            - forceData: when set to true the data passed into trigger is the data that will be passed to
         *                                         each listener. The data will not be extended over the ADL.
         *                            - playbackObj: The Playback object to use when logging listener execution. If this is set then
         *                                           trigger() will exclude any listener UUIDs that have already been called and add
         *                                           any new listener UUIDs to the list based, if there are any that have not been executed.
         *                                           This option is used when replaying events. The code assumes that by passing this object
         *                                           that you are attempting to replay the event. It is not a common option to be passed.
         *  @returns {Doneable} - Resolves when all the callbacks for the event are done
         */
        edapThis.trigger = function(eventName, data, opts) {
            var logName = 'trigger',
                waitTime = edapInternal.config.maxWaitTime,
                validOpts = ['maxWaitTime', 'forceData', 'playbackObj'],
                passedData = data,
                passedOptions = opts,
                shouldConsoleLog = true,
                isReplay,
                err;

            // Set opts to a default empy object if missing
            if (edapHelpers.isObject(opts)) {
                // Validate that only allowed options are passed in
                edapHelpers.forOwn(opts, function(value, key) {
                    if (validOpts.indexOf(key) === -1) {
                        err = new TypeError(logName + '(): called with invalid option: ' + key);
                    }
                });
            } else {
                if (opts !== null && opts !== undefined) {
                    err = new TypeError(logName + '(): opts must be an Object if defined');
                }
                opts = {};
            }

            // default data to an object so that there is a consistent contract with any lifecycle hooks
            data = edapInternal.defaultToObj(data);

            edapInternal.logHistory(['Called', logName + '()', 'for event', eventName, 'with data', JSON.stringify(passedData), 'with opts', JSON.stringify(passedOptions)].join(' '));

            // If there was an options validation error then throw it now that we have logged the history event
            if (err) {
                edapThis.error(err);
                throw err;
            }

            edapInternal.validateCondition(typeof eventName === 'string', logName + '(): eventName must be a string');
            edapInternal.validateCondition(typeof data === 'object' || data === null || typeof data === 'undefined', logName + '(): data must be an Object if defined');
            edapInternal.validateCondition(!eventName.match(/[*]$/), logName + '(): cannot trigger wildcard event explicitly ' + eventName);

            // 'onEventTrigger' Lifecycle hook
            edapPublic.lifecycle.execute('onEventTrigger', [eventName, data, opts]);

            // Cache if this trigger() contains a replay object
            isReplay = !!opts.playbackObj;

            // Don't log if this is an ignored console event or this is a replay'd trigger and we don't have force replay logging enable
            if (edapPublic.isIgnoredConsoleEvent(eventName) || (isReplay && !edapInternal.shouldLogReplayedEvents)) {
                shouldConsoleLog = false;
            }

            return new Doneable(function(done) {
                var listenerUuids = edapInternal.getCallbacks(eventName),
                    completeListeners = 0,
                    previouslyExecutedUUIDs = {},
                    playbackObj = null,
                    isPlaybackObjNull = true,
                    maxWaitTimeout,
                    numListeners,
                    clonedData,
                    i;

                function allListenersComplete() {
                    clearTimeout(maxWaitTimeout);

                    if (listenerUuids.length) {
                        edapInternal.logHistory(['Executed', listenerUuids.length, 'listeners total for event', eventName].join(' '));
                    }

                    // 'onEventComplete' Lifecycle hook
                    edapPublic.lifecycle.execute('onEventComplete', [eventName, clonedData, opts]);

                    done();
                }

                function listenerComplete() {
                    completeListeners++;
                    if (completeListeners === numListeners) {
                        allListenersComplete();
                    }
                }

                function displayLog(endingFn) {
                    if (shouldConsoleLog) {
                        edapPublic.console.startLog((isReplay ? '(replay) ' : '') + 'EDAP event triggered: ' + eventName);
                        edapPublic.console.log('Passed Data: ', passedData);
                        edapPublic.console.log('Options: ', passedOptions);
                        endingFn();
                    }
                }

                // If we are passed a playbackObj then let's assign it and extract the data needed
                if (opts.playbackObj) {
                    playbackObj = opts.playbackObj;
                    previouslyExecutedUUIDs = edapInternal.arrayToObject(playbackObj.executedListeners);
                }

                // Set this cached value so we don't have to do null checks all the time
                isPlaybackObjNull = (playbackObj === null);

                if (typeof opts.maxWaitTime === 'number') {
                    // Overwrite the default on a per-trigger basis
                    waitTime = opts.maxWaitTime;
                }

                // waitTime must be > 0 to assign the Timeout
                if (waitTime > 0) {
                    maxWaitTimeout = setTimeout(function() {
                        edapInternal.logHistory([logName + '()', waitTime + ' sec', 'timeout reached for event', eventName].join(' '));
                        allListenersComplete();
                    }, waitTime * 1000);
                }

                // If there are no callbacks then just return a done Doneable
                if (listenerUuids.length === 0) {
                    // Even though there are no listeners we still want to log the event in the playback log in case there are
                    // listeners if/when it is replay()'d later
                    if (isPlaybackObjNull) {
                        // Get our cloned data set. This is duplicated in a few spots so that we are only doing this expensive clone() operation
                        // when we absolutely have to. The code is a bit more complex, but for the sake of performance.
                        clonedData = edapInternal.buildTriggerData(eventName, data, opts);

                        playbackObj = edapPublic.playback.addEvent(eventName, clonedData);

                        displayLog(function() {
                            edapPublic.console.endLog('Shrinkwrapped Data (no callbacks registered) ', clonedData);
                        });
                    } else {
                        displayLog(function() {
                            edapPublic.console.endLog('Shrinkwrapped Data: skipped (no callbacks registered)');
                        });
                    }

                    allListenersComplete();
                    return;
                }

                // Get our cloned data set. This is duplicated in a few spots so that we are only doing this expensive clone() operation
                // when we absolutely have to. The code is a bit more complex, but for the sake of performance.
                clonedData = edapInternal.buildTriggerData(eventName, data, opts);

                // If we don't have a Playback object then get one now.
                if (isPlaybackObjNull) {
                    playbackObj = edapPublic.playback.addEvent(eventName, clonedData);
                }

                displayLog(function() {
                    edapPublic.console.endLog('Shrinkwrapped Data: ', clonedData);
                });

                // Now let's loop through the listeners and execute any that have not already been executed.
                for (i = 0, numListeners = listenerUuids.length; i < numListeners; i++) {
                    // Don't execute a listener that has already been executed. This only applies to playback scenarios.
                    if (!previouslyExecutedUUIDs.hasOwnProperty(listenerUuids[i])) {
                        // playbackObj === null would mean that playback was disabled
                        if (playbackObj !== null) {
                            playbackObj.executedListeners.push(listenerUuids[i]);
                        }

                        edapInternal.executeListener(listenerUuids[i], clonedData).then(listenerComplete);

                    // if it has already been executed then just log it as complete immediately
                    } else {
                        listenerComplete();
                    }
                }
            }, {
                error: function() {
                    if (shouldConsoleLog) {
                        edapPublic.console.endLog('Error Caught');
                    }
                    edapThis.error(err);
                }
            });
        };


        /**
         *  Error logger.
         *  All log entries will be available in Edap.logs.error
         *
         *  @method
         *  @param {Error|String} [err] - If a String is passed then it will be used to instantiate a new Error.
         *                                If an instance of Error is passed then it will be pushed as is.
         *  @param {Object} [optAdl] - Optional ADL to associate with the edap.error event that is triggered instead
         *                             of the normal way of passing the pages ADL. This is very useful for maintaining
         *                             the state of the error for trigger-based errors and aides in debugging. "logmessage"
         *                             will be added regardless if you use this field or not.
         * @param {Object} [errorOpts] - Error options to allow only console error logging if need be
         */
        edapThis.error = function(err, optAdl, errorOpts) {
            var savedLogLevel = edapPublic.console.getLogLevel(),
                errorOptions = errorOpts || {},
                errorLogMessageField = 'errorlogmessage',
                triggerOpts = null,
                eventData,
                newErr,
                errStr;

            if (!err) {
                return;
            }

            try {
                if (err instanceof Error) {
                    newErr = err;
                } else {
                    newErr = new Error(err);
                }

                // Now build the errStr to send in edap.error event
                if (typeof newErr.stack === 'string') {
                    errStr = newErr.stack;
                } else {
                    errStr = newErr.toString();
                }
            } catch (e) {
                newErr = err.toString();
                errStr = newErr;
            }

            // Log the error as a real console.error log (when applicable)
            edapPublic.console.setLogLevel('error');
            edapPublic.console.log('EDAP error: ' + errStr);
            edapPublic.console.setLogLevel(savedLogLevel);

            // Save the error to our internal log
            edapThis.logs.error.push(newErr);

            // Let's make sure we don't cause an infinite error loop here
            if (edapInternal.inError === false && !errorOptions.logErrorOnly) {
                edapInternal.inError = true;

                eventData = {};

                // If we have an optional ADL then we need to use that instead of create our own
                // when we trigger the edap.error event
                if (optAdl) {
                    eventData = edapPublic.clone(optAdl);

                    // We need to keep our messages backwards compatible so keep the "edapeventname"
                    // property matching the actual event, but in this case we will add "erroredapeventname"
                    // that was the original event name
                    eventData.erroredapeventname = eventData.edapeventname;
                    eventData.edapeventname = edapError;

                    triggerOpts = {
                        forceData: true
                    };
                }

                // Add the error message to the eventData
                eventData[errorLogMessageField] = errStr;

                edapThis.trigger(edapError, eventData, triggerOpts).then(function() {
                    edapInternal.inError = false;
                });
            }
        };


        /**
         *  Used to manage the race condition of calling edap functions when edap is loaded async
         *
         *  @example
         *  // Snippet that shows how to use the push mechanism to get an instance of edap in an async-safe manner
         *  window.edap = window.edap || [];
         *  window.edap.push(function(edap) {
         *      edap.on('that.cool.event', function(data) {
         *          //do something cool!
         *      });
         *  });
         *
         *  @example
         *  // Snippet that shows how to use the push mechanism's convenience function to call through to `trigger` in an async-safe manner
         *  window.edap.push({
         *      name: 'that.cool.event',
         *      data: {'data1': 'value1'},
         *      options: {'maxWaitTime': true}
         *  });
         *
         *  @method
         *  @param {Function} [arg] - One of two things:
         *                              1) A function that will be passed the edap instance as an argument
         *                              2) An object with the following properties (which correspond to the arguments of `trigger`) that will be passed as the arguments to a `trigger` call:
         *                                  - name: The name of the edap event to trigger
         *                                  - data: An optional data object to be passed with the event
         *                                  - options: An optional set of options to be used when triggering the event (see the `trigger` documentation for specifics)
         */
        edapThis.push = function(arg) {
            var logName = 'push',
                err;

            edapInternal.logHistory(['Called', logName + '()'].join(' '));

            edapInternal.validateCondition(arguments.length === 1, logName + '(): function takes one argument');
            edapInternal.validateCondition(typeof arg === 'function' || typeof arg === 'object', logName + '(): arg must be a Function or an Object');

            if (typeof arg === 'function') {
                try {
                    arg.call(edapThis, edapThis);
                } catch (e) {
                    err = new Error(logName + '(): error caught in executing function: ' + JSON.stringify(arg) + ' stacktrace:' + e.stack);
                    edapThis.error(err);
                }
            } else {
                edapInternal.validateCondition(typeof arg.name === 'string', logName + '(): passed object must have a "name" property with a string value');
                edapThis.trigger(arg.name, arg.data, arg.options);
            }
        };


        /**
         *  Get a info on a single scope or all scopes
         *
         *  @method
         *  @param {String} [optScopeName] - optional scope name to get
         *  @returns {Object} - if optScopeName is passed then it will return the scope info for that scope or
         *                      null if that scope name does not exist,
         *                      otherwise it will return object of all scopes
         */
        edapThis.getScopeInfo = function(optScopeName) {
            var logName = 'getScopeList';

            edapInternal.logHistory(['Called', logName + '()'].join(' '));

            if (typeof optScopeName === 'string') {
                return edapInternal.scopes[optScopeName] || null;
            }

            return edapInternal.scopes;
        };


        /**
         *  Get the scope-specific data for a scope
         *
         *  @method
         *  @throws {TypeError} - Parameters do not pass validation
         *  @param {String} [scopeName] - optional scope name to get
         *  @returns {Object} - Data object for a scope or null
         */
        edapThis.getScopeData = function(scopeName) {
            var scopeInfo;

            edapInternal.validateCondition(typeof scopeName === 'string', 'getScopeData(): scopeName was not a string');

            scopeInfo = edapThis.getScopeInfo(scopeName);

            if (scopeInfo !== null) {
                return scopeInfo.data;
            }

            return null;
        };


        /**
         *  Creates a scope (or context) within Edap that provides 2 things:
         *      1. Guaranteed unique context names. This can be used to prevent modules from registering
         *         their event listeners multiple times.
         *      2. Provides Scope.prototype.unregister() that will unregister any listeners that were
         *         set through the Scope. The purpose would be to limit the amount of application logic
         *         needed to cleanup any module-specific listeners when the module is destoyed.
         *      3. Provides Scope.prototype.destroy() to remove a scope
         *      4. Provides Scope.prototype.getData() as a scope-specific data store
         *
         *  This proxies all the Edap methods and features so it has access to all the same methods.
         *
         *  @example
         *  // simple example of all the exposed methods of a Scope
         *  var myScope = new Edap.Scope('myScopeName');
         *  var onUuid = myScope.on('test', function(data){...});
         *  myScope.once('test', function(data){...});
         *  myScope.trigger('myEvent',{testData: true});
         *  myScope.off(onUuid);
         *  myScope.log('myScopeName just logged a msg');
         *  myScope.error('myScopeName just logged a error');
         *  myScope.getScopeData().myDataEl = 1;
         *  myScope.unregister();
         *  myScope.destroy();
         *
         *  @constructor
         *  @throws {TypeError} - when not called with "new" or invalid name argument
         *  @returns {Edap.Scope} - this Edap.Scope instance
         */
        edapThis.Scope = function(name) {
            var scope = this,
                removeHook;

            edapInternal.validateCondition(scope !== edapThis, 'Edap.Scope must be called with the "new" keyword');
            edapInternal.validateCondition(typeof name === 'string' && name.length > 0, 'name must be a non-zero length string');
            edapInternal.validateCondition(!edapInternal.scopes.hasOwnProperty(name) || edapInternal.scopes[name] === undefined, name + ' scope already registered');

            edapInternal.scopes[name] = {
                instance: scope,
                data: {}
            };

            // This loops over all the edap top-level properties and sets them to this scope's properties (proxies then through the scope)
            edapHelpers.forOwn(edapThis, function(value, propName) {
                scope[propName] = edapThis[propName];
            });

            // This is overwritting the proxied edap.on method so that we can hook into when a new listener is created through this
            // scope and keep track of it accordingly
            scope.on = function(eventName) {
                var uuid = edapThis.on.apply(edapThis, arguments);

                if (uuid !== null) {
                    scope.uuids[uuid] = true;
                    edapInternal.logHistory(['Scope', scope.name, 'registered new callback for event', eventName, 'uuid', uuid].join(' '));
                }

                return uuid;
            };

            /**
             *  Calls edap.off() for all event listeners registered through this scope (scope.on())
             *
             *  @method
             */
            scope.unregister = function() {
                edapInternal.logHistory(['Called unregister() for Scope', scope.name].join(' '));

                edapHelpers.forOwn(scope.uuids, function(value, uuid) {
                    edapThis.off(uuid);
                    delete scope.uuids[uuid];
                });
            };

            /**
             *  Destroys this scope instance. It does so in the following way:
             *    1. Unregisters all event listeners on()'d by this scope
             *    2. Deletes all non-function properties of this scope
             *    3. Sets all function properties to this scope to an exception throwing function
             *    4. Sets the scope to undefined in the EDAP internal scopes list
             *
             *  @method
             */
            scope.destroy = function() {
                var oldName = scope.name,
                    deadFunc = function() {
                        throw new Error('Attempting to access destroyed edap scope ' + oldName);
                    };

                edapInternal.logHistory(['Called destroy() for Scope', scope.name].join(' '));

                scope.unregister();
                edapPublic.lifecycle.unregister(removeHook);

                // Replace scope methods with the dead function and delete other properties
                edapHelpers.forOwn(scope, function(value, prop) {
                    if (typeof scope[prop] === 'function') {
                        scope[prop] = deadFunc;
                    } else {
                        delete scope[prop];
                    }
                });

                edapInternal.scopes[oldName] = undefined;
            };


            /**
             *  Gets the data object for this scope.
             *  The same as calling:
             *    edap.getScopeData(scope.name)
             *
             *  @method
             */
            scope.getData = function() {
                return edapThis.getScopeData(scope.name);
            };

            scope.name = name;
            scope.uuids = {};

            // Listen for removed uuids and remove then from our internal uuids
            removeHook = edapPublic.lifecycle.register(onListenerRemovedHookName, function(eventId, uuid) {
                if (scope.uuids[uuid]) {
                    delete scope.uuids[uuid];
                    edapInternal.logHistory(['Scope', scope.name, 'removed callback uuid', uuid].join(' '));
                }
            });

            return scope;
        };


        /**
         *  Abstraction around getting the global Data Layer
         *
         *  @throws {TypeError} - dl is not a function or a string
         *  @throws {Error} - dl does not exist
         *  @returns {Object} - Returns the ADL.
         */
         /* eslint-disable consistent-return */
        edapThis.getDL = function() {
            var win = edapPublic.getWindow(),
                dl = edapPublic.getGlobalOptions().dataLayerName;

            if (typeof dl === 'function') {
                return dl();
            } else if (typeof dl === 'string') {
                if (!edapHelpers.has(win, dl)) {
                    win[dl] = {};
                }
                return win[dl];
            }

            edapThis.error(new TypeError('edapOptions.dataLayerName was neither function nor string'));
        };

        /**
         *  Getter for the current environment (production/stage/test)
         *
         *  @param {Object} [optAdl] - Optional ADL object to use instead of the page ADL
         *  @returns {String} - (optAdl or DL).appenvironment value. Defaults to 'unknown'
         */
        edapThis.getEnv = function(optAdl) {
            var dl;

            if (edapHelpers.isObject(optAdl)) {
                dl = optAdl;
            } else {
                dl = edapThis.getDL();
            }

            return dl.appenvironment || 'unknown';
        };


        // Constructor code

        // Create our 'init' mark in our eventLog
        edapPublic.playback.setMark('init');

        // Cache the global options for legacy reasons
        edapThis.globalOptions = edapPublic.getGlobalOptions();

        // Disable Playback at startup if set globally
        if (edapThis.globalOptions.skipPlayback === true) {
            edapPublic.playback.disable();
        }

        // Make sure the initial data structure is setup
        edapInternal.reset();

        edapThis.on(edapReset, function() {
            edapInternal.reset();
        });

        // Initialize for the cookie to get logging and other configs setup
        edapInternal.setupFromCookie();

        // Sets up a listener in case someone sets a cookie and doesn't want to reload the page
        edapThis.on(edapLoadCookie, function() {
            edapInternal.setupFromCookie();
        });

        // Listen to the flush event to flush the persistently stored cmds
        edapThis.on(edapFlush, function(data, async, done) {
            async();

            // Every flush we will also re-parse and load the logging config from the cookie
            edapInternal.setupFromCookie();

            if (edapInternal.savedCmds instanceof Array) {
                edapInternal.flushAsyncCommands(edapInternal.savedCmds);
            }

            edapInternal.savedCmds = null; // Clean up this memory
            edapInternal.processStoredCmds().then(done);
        });

        // Save any aysnc-queued commands before we squash it
        edapInternal.savedCmds = edapPublic.getGlobal();

        return edapThis;
    }

    return new Edap();
});

define('domhelpers',['edap'], function(edap) {
    'use strict';

    var helpers = {
        /**
         *  Getter for window
         *
         *  @returns {Object} - Returns the window object
         */
        getWindow: function() {
            return window;
        },

        /**
         *  Getter for window.screen
         *
         *  @returns {Object} - Returns the window.screen object
         */
        getScreen: function() {
            return this.getWindow().screen || {};
        },

        /**
         * Getter for the current edap-integrations version
         *
         * @return {String} The edap-integrations version or '-1'
         */
        getEdapIntegrationsVersion: function() {
            return edap.integrationsVersion || '-1';
        },


        /**
         *  Getter for window.document
         *
         *  @returns {Object} - Returns the window.document object
         */
        getDocument: function() {
            return document;
        },


        /**
         *  Getter for window.document.referrer
         *
         *  @returns {Object} - Returns the window.document.referrer
         */
        getDocumentReferrer: function() {
            return this.getDocument().referrer;
        },


        /**
         * Helper function to determine if the referrer matches the current domain
         *
         * @return {Boolean} `true` if there is a referrer set AND that referrer does not match the current domain, `false otherwise`
         */
        isCrossDomainReferral: function() {
            var referrer = this.getDocumentReferrer(),
                currentDomainRegex = new RegExp('^' + this.getLocationOrigin() + '/');

            return !!(referrer && referrer.match(currentDomainRegex) === null);
        },


        /**
         *  Getter for window.document.cookie
         *
         *  @returns {Object} - Returns the window.document.cookie object
         */
        getDocumentCookie: function() {
            return document.cookie;
        },


        /**
         *  Setter for window.document.cookie
         *
         *  @param {String} [cookieStr] - Coorectly formatted cookie string to be added as a cookie
         */
        setDocumentCookie: function(cookieStr) {
            document.cookie = cookieStr;
        },


        /**
         *  Getter for window.document.location
         *
         *  @returns {Object} - Returns the window.document.location object
         */
        getLocation: function() {
            return this.getDocument().location;
        },


        /**
         *  Getter for window.document.location.href
         *
         *  @returns {String} - Returns the window.document.location.href string
         */
        getHref: function() {
            return window.document.location.href;
        },


        /**
         *  Getter for window.document.location.protocol
         *
         *  @returns {Object} - Returns the window.document.location.protocol object
         */
        getLocationProtocol: function() {
            return window.document.location.protocol;
        },


        /**
         *  Getter for window.document.location.hostname
         *
         *  @returns {String} - Returns the window.document.location.hostname string
         */
        getHostname: function() {
            return window.document.location.hostname;
        },


        /**
         *  Getter for window.document.location.pathname
         *
         *  @returns {String} - Returns the window.document.location.pathname string
         */
        getPathname: function() {
            return window.document.location.pathname;
        },


        /**
         *  Getter for window.document.location.search
         *
         *  @returns {String} - Returns the window.document.location.search string
         */
        getSearch: function() {
            return window.document.location.search;
        },


        /**
         * Getter for the path and search strings concatenated together
         *
         * @return {String} - Returns the window.document.location pathname and search concatenated
         */
        getPage: function() {
            return helpers.getPathname() + helpers.getSearch();
        },


        /**
         * Getter for the protocol and hostname of the current page
         * NOTE: This value is being computed instead of using document.location.origin due to IE
         *       compatibility issues
         *
         * @return {String} - Returns the window.document.location.origin-like value
         */
        getLocationOrigin: function() {
            return helpers.getLocationProtocol() + '//' + helpers.getHostname();
        },


        /**
         *  Getter for window.navigator
         *
         *  @returns {Object} - Returns the window.navigator object
         */
        getNavigator: function() {
            return window.navigator;
        },


        /**
         * Adds the specified `callbackFunction` as an event listener for `eventName`
         *
         * @param {String} eventName - The event name to listen for
         * @param {Function} callbackFunction - What to do when the event occurs
         */
        addWindowEventListener: function(eventName, callbackFunction) {
            window.addEventListener(eventName, callbackFunction);
        },


        /**
         * Removes the specified `callbackFunction` as an event listener for `eventName`
         *
         * @param {String} eventName - The event name to remove listener for
         * @param {Function} callbackFunction - Function to remove for `eventName`
         */
        removeWindowEventListener: function(eventName, callbackFunction) {
            window.removeEventListener(eventName, callbackFunction);
        },


        /**
         *  Returns the number of milliseconds since 1 January 1970 00:00:00 UTC (Epoch)
         *
         *  @returns {Number} - Returns the number of milliseconds since Epoch
         */
        getMsFromEpoch: function() {
            if (typeof window.Date.now === 'function') {
                return Date.now();
            }
            return (new Date()).getTime();
        },


        /**
         *  Dynamically injects a script before the first script tag on a page.
         *
         *  @example
         *    loadScript('//foo.com/path/to/script.js', 'my-script-load-id');
         *
         *  @param {String} [url] - a fully qualified or protocol-less url to a script. If it is a
         *                          protocol-less url then it will prefix the pages protocol onto the url.
         *  @param {String} [id] - the script element id to set
         *  @returns {Boolean} - if the script tag was added or not (based on if the id already exists)
         */
        loadScript: function(url, id) {
            var doc = this.getDocument(),
                node = doc.getElementsByTagName('script')[0],
                script = doc.createElement('script');

            if (typeof id === 'string' && id.length > 0) {
                // Bail out if the element already exists on the page
                if (doc.getElementById(id) !== null) {
                    return false;
                }

                script.id = id;
            }

            script.async = true;
            script.type = 'text/javascript';

            // If the url doesn't start with '//' then we will assume it is full qualified. Otherwise
            // we'll prefix the url with the current pages protocol (http: or https:).
            if (url.indexOf('//') === 0) {
                script.src = (this.getLocation().protocol === 'https:' ? 'https:' : 'http:') + url;
            } else {
                script.src = url;
            }
            node.parentNode.insertBefore(script, node);

            return true;
        },


        /**
         *  Dynamically injects a set of scripts onto the page
         *
         *  @example
         *    loadScriptMulti(['//foo.com/path/to/script1.js', '//foo.com/path/to/script2.js', ...]);
         *
         *  @param {Array} [urls] - a list of fully qualified or protocol-less urls to scripts. If it is a
         *                          protocol-less url then it will prefix the pages protocol onto the url.
         *  @returns {Boolean} - true if all the script tags were added or false if not
         */
        loadScriptMulti: function(urls) {
            var allSuccessful = true,
                successful,
                i,
                len;

            if (!(urls instanceof Array)) {
                return allSuccessful;
            }

            for (i = 0, len = urls.length; i < len; i++) {
                successful = helpers.loadScript(urls[i]);
                allSuccessful = allSuccessful && successful;
            }

            return allSuccessful;
        },


        /**
         *  Send an image request
         *
         *  @example
         *    getImage('//foo.com/path/to/img.png');
         *
         *  @param {String} [url] - image url
         *  @param {Function} [cb] - Callback with the url passed as the only parameter
         */
        getImage: function(url, cb) {
            new Image().src = url;
            if (typeof cb === 'function') {
                cb(url);
            }
        },


        /**
         *  Gets the contents of a cookie
         *  Algorithm borrowed from https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript/25490531#25490531
         *
         *  @example
         *    getCookie('mycookie');
         *
         *  @param {String} [name] - name of the cookie
         *  @returns {Object} - The String cookie data or null
         */
        getCookie: function(name) {
            var defaultValue = null,
                cookies,
                cookieParts;

            try {
                cookies = this.getDocumentCookie();
                cookieParts = cookies.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
                return cookieParts ? cookieParts.pop() : defaultValue;
            } catch (err) {
                edap.error(err);
            }

            return defaultValue;
        },


        /**
         *  Sets a cookie
         *
         *  @example
         *    // sets a "mycookie" with value "1234" on "homeaway.com" for 2 hours
         *    setCookie('mycookie', '1234', 'homeaway.com', 120);
         *
         *  @param {String} [name] - name of the cookie
         *  @param {String} [value] - value of the cookie
         *  @param {String} [hostname] - domain of the cookie
         *  @param {Number} [minutes] - minutes until cookie expires
         */
        setCookie: function(name, value, hostname, minutes) {
            var expires = '',
                date = new Date(),
                expiresMinutes;

            try {
                expiresMinutes = minutes * 60 * 1000;

                date.setTime(date.getTime() + expiresMinutes);

                if (typeof minutes === 'number') {
                    // If minutes is less than 0 then they are trying to remove a cookie and we set max-age as well.
                    if (expiresMinutes <= 0) {
                        expires = '; max-age=0';
                    }
                    expires += '; expires=' + date.toUTCString();
                }

                this.setDocumentCookie(name + '=' + value + expires + '; path=/; domain=' + hostname + ';');
            } catch (err) {
                edap.error(err);
            }
        },


        /**
         *  Removes a cookie
         *
         *  @example
         *    removeCookie('mycookie', 'homeaway.com');
         *
         *  @example
         *    removeCookie('mycookie');
         *
         *  @param {String} [name] - name of the cookie
         *  @param {String} [hostname] - domain of the cookie
         */
        removeCookie: function(name, optHostname) {
            if (!optHostname) {
                optHostname = this.getHostname();
            }

            // Hard coded to 1 day ago in minutes (1440 minutes)
            this.setCookie(name, '', optHostname, -1440);
        },


        /**
         *  Gets the value of a query string parameter
         *
         *  @example
         *    var param = getSearchParam('k_clickid');
         *
         *  @param {String} [name] - name of the query string parameter
         *  @returns {Object} - The String param value or null
         */
        getSearchParam: function(name) {
            var nameEQ = name + '=',
                searchStr,
                params,
                i,
                p;

            try {
                // strip the initial ? and unencode
                searchStr = this.getSearch().replace('?', '');

                params = searchStr.split('&');

                for (i = 0; i < params.length; i++) {
                    p = decodeURIComponent(params[i]);

                    if (p.indexOf(nameEQ) === 0) {
                        return p.substring(nameEQ.length, p.length);
                    }
                }
            } catch (err) {
                edap.error(err);
            }
            return null;
        },

        /**
         * Gets the width of the screen
         *
         * @returns {Object} - The total width of the screen
         */
        getScreenWidth: function() {
            return this.getScreen().width;
        },

        /**
         * Gets the height of the screen
         *
         * @returns {Object} - The total height of the screen
         */
        getScreenHeight: function() {
            return this.getScreen().height;
        },

        /**
         * Gets the width of the view port to determine the media type
         *
         * @returns {Object} - The inner width of a window's content area
         */
        getViewportWidth: function() {
            return this.getWindow().innerWidth
                || this.getDocument().documentElement.clientWidth
                || this.getDocument().getElementsByTagName('body')[0].clientWidth;
        },

        /**
         * Gets the height of the view port
         *
         * @returns {Object} - The inner height of a window's content area
         */
        getViewportHeight: function() {
            return this.getWindow().innerHeight
                || this.getDocument().documentElement.clientHeight      // IE6 in standards compliant mode
                || this.getDocument().getElementsByTagName('body')[0].clientHeight;     // Older versions of IE
        },

        /**
         *  Gets the media query size (mqsize) of the page
         *
         *  Use the width of the browser to determine which mqsize was used for the page
         *
         *  @returns {String} - String representing the media query size:
         *      lg - Large devices, width >= 1200px
         *      md - Medium devices, width >= 992px
         *      sm - Small devices, 768px <= width < 992px
         *      xs - Extra small devices, width < 768px
         *      -1 - Error, no size determined
         */
        getMQSize: function() {
            var mqSize = '-1',
                x;

            try {
                x = this.getViewportWidth();

                if (typeof x === 'number') {
                    if (x < 768) {
                        mqSize = 'xs';
                    } else if (x < 992) {
                        mqSize = 'sm';
                    } else if (x < 1200) {
                        mqSize = 'md';
                    } else {
                        mqSize = 'lg';
                    }
                }
            } catch (e) {
                edap.error(e);
            } finally {
                return mqSize;
            }
        },

        /**
         *  Gets the user's preferred language from the browser
         *
         *  @returns {String} - the language tag
         */
        getPreferredLanguage: function() {
            var nav = this.getNavigator(),
                preferredlanguage = '-1';

            // nav.userLanguage for IE and nav.language for all others
            if (nav.language || nav.userLanguage) {
                preferredlanguage = nav.language || nav.userLanguage;
            }

            return preferredlanguage;
        }
    };

    return helpers;
});

define('debughelpers',['domhelpers'], function(domHelpers) {
    'use strict';

    var helpers = {

        /**
         * Gets the EDAP debug cookie name
         *
         * The cookie's value should be of the form
         *   "integrationName=true|otherIntegrationName=false|aThirdIntegrationName=true"
         *
         * @example "ua=true|hadoop=false"
         *
         * @return {String} The name of the EDAP debug cookie
         */
        getDebugCookieName: function() {
            return 'edapDebug';
        },

        /**
         * Determines whether a given integration has been cookied for debug module
         *
         * @param  {String} integrationName The name of the EDAP integration to check debug status form
         * @return {Boolean}                true if debug mode is enabled, false otherwise (disabled or no cookie found)
         */
        isInDebugMode: function(integrationName) {
            var debugCookieName = helpers.getDebugCookieName(),
                debugCookie = domHelpers.getCookie(debugCookieName) || '',
                searchString = integrationName + '=true';

            return debugCookie.indexOf(searchString) !== -1;
        }
    };

    return helpers;
});

define('adlhelpers',['edap'], function(edap) {
    'use strict';

    function ADLHelpers(adlData) {
        /**
         *  Getter for an ADL property or the entire ADL
         *
         *  @example
         *    // gets a single ADL value
         *    var lid = adl.get('listingid');
         *
         *  @example
         *    // gets the entire ADL
         *    var adlData = adl.get();
         *
         *  @param {Object} [key] - String key name for a single key, or undefined for the entire ADL
         *  @returns {Object} - Returns the this.adl[key] value
         */
        this.get = function(key) {
            if (key === undefined) {
                return this.adl;
            }

            return this.adl[key];
        };


        /**
         * Getter for an ADL property that also checks if it is Set
         *
         * @param  {string} key The key to get a value format
         * @return {*}          The ADL value if it is set or undefined
         */
        this.isSetGet = function(key) {
            if (this.isSet(key)) {
                return this.get(key);
            }

            return undefined;
        };


        /**
         * Sets a property in the ADL if not already set and passes the shouldSet() checks
         *
         * @param  {String} key   The key to set a value for if not already set
         * @param  {*}      value The value to set if there isn't a value for key yet
         */
        this.setIfNotSet = function(key, value) {
            if (!this.isSet(key) && this.shouldSet(value)) {
                this.set(key, '' + value);
            }
        };


        /**
         * Sets a property in the ADL if it passes the shouldSet() checks
         *
         * @param  {String} key   The key to set a value for
         * @param  {*}      value The value to set
         */
        this.setIfShouldSet = function(key, value) {
            if (this.shouldSet(value)) {
                this.set(key, '' + value);
            }
        };


        /**
         *  Special getter for the 'publicuuid' value
         *
         *  @returns {Object} - Returns correct publicuuid value based on multiple values
         *  TECHDEBT: This function shouldn't exist, but until we use publicuuid everywhere we need a fallback
         */
        this.getPublicUUID = function() {
            if (this.isSet('publicuuid')) {
                return this.get('publicuuid');
            } else if (this.isSet('guid')) {
                return this.get('guid');
            }

            return '-1';
        };


        /**
         *  Special getter for the 'listingids' value
         *
         *  @returns {Object} - Returns correct listingids value based on multiple values
         *  TECHDEBT: This can be removed if/when we move everyone to ADL.listingids for flexibility
         */
        this.getListingIds = function() {
            if (this.isSet('eventlistingids')) {
                return this.get('eventlistingids');
            } else if (this.isSet('listingids')) {
                return this.get('listingids');
            } else if (this.isSet('listingid')) {
                return this.get('listingid');
            }

            return '-1';
        };


        /**
         *  Setter for an ADL property
         *
         *  @param {String} [key] - ADL key name to set
         *  @param {String} [value] - ADL value to set
         *  @returns {Boolean} - Returns if the value was set or not
         */
        this.set = function(key, value) {
            if (typeof key !== 'string' || typeof value !== 'string') {
                edap.error('Attempting to set ADL key/value with non-strings: ' + key + ', ' + value);
                return false;
            }

            this.adl[key] = value;
            return true;
        };


        /**
         *  Determines if a value is correct and "settable"
         *
         *  @param {String} [val] - The value to check
         *  @returns {Boolean} - Returns if the value is settable or not
         */
        this.shouldSet = function(val) {
            return (val !== undefined && val !== null && val !== '-1');
        };


        /**
         *  Determines if a key is set in the ADL
         *
         *  @param {String} [key] - The ADL key name to check
         *  @returns {Boolean} - Returns if the value is set or not
         */
        this.isSet = function(key) {
            return this.shouldSet(this.adl[key]);
        };


        /**
         *  Determines if an ADL value is Boolean/String true
         *
         *  @param {String} [key] - The ADL key name to check
         *  @returns {Boolean} - Returns if the value is true or not
         */
        this.isTrue = function(key) {
            return !!this.adl[key] && this.adl[key].toString && typeof this.adl[key].toString === 'function' && this.adl[key].toString() === 'true';
        };


        /**
         *  Determines if an ADL value is Boolean/String false
         *
         *  @param {String} [key] - The ADL key name to check
         *  @returns {Boolean} - Returns if the value is false or not
         */
        this.isFalse = function(key) {
            return this.adl[key] !== undefined && this.adl[key].toString && typeof this.adl[key].toString === 'function' && this.adl[key].toString() === 'false';
        };

        /**
         *  Constructor
         */

        // Useful to be able to pass the "ADL" in the case of EDAP event listeners
        if (adlData !== null && typeof adlData === 'object') {
            this.adl = adlData;

        // default to getting the global ADL from EDAP
        } else {
            this.adl = edap.getDL();
        }

        return this;
    }


    return ADLHelpers;
});

define('data-enrichment/pageid-helper',[
    'adlhelpers',
    'domhelpers',
    'edap'
], function(ADL, domHelpers, edap) {
    'use strict';

    function PageIdHelper() {
        var adl = new ADL(),
            storedIdKey = 'parentPageviewId',
            sessionStorageName = 'sessionStorage',
            localStorageName = 'localStorage',
            integrationName = 'hadoop',
            missingVal = '-1';

        /**
         * Getter for the parentPageviewIdObj object stored in the EDAP scope data
         *
         * Should have two properties:
         *  id - the parent pageview ID
         *  sessionid - the session ID for which id is relevant
         *
         * @return {Object} - The parentPageviewIdObj object from the EDAP scope data
         */
        function getParentPageviewIdObj() {
            return edap.getScopeData(integrationName).parentPageviewIdObj || {};
        }

        /**
         * Setter for the parentPageviewIdObj object stored in the EDAP scope data
         *
         * Should have two properties:
         *  id - the parent pageview ID
         *  sessionid - the session ID for which id is relevant
         *
         * @param {Object} newObj - Object to set as parentPageviewIdObj in EDAP scope data
         */
        function setParentPageviewIdObj(newObj) {
            edap.getScopeData(integrationName).parentPageviewIdObj = newObj;
        }

       /**
        *  Gets the data associated with the key in storage.
        *
        *  @param {String} key - The key the data is associated with*
        *  @param {Object} storageOpts - Options for configuring the storage engine
        *  @returns {Object} - The data object from storage associated with the key, or null
        *                      if the key is missing or an error occurs in decoding the data
        */
        this.getData = function(key, storageOpts) {
            var logger = edap.internal.getPersistentLogger();
            return logger.get(key, storageOpts);
        };


        /**
         * Gets data in the scope of the current tab
         *
         * @param {String} key - The key to store the data under
         * @returns {Object} - The data object from storage associated with the key, or null
         *                      if the key is missing or an error occurs in decoding the data
         */
        this.getTabSpecificData = function(key) {
            return this.getData(key, {
                storages: sessionStorageName
            });
        };


        /**
         * Gets data from cross-tab context
         *
         * @param {String} key - The key to store the data under
         * @returns {Object} - The data object from storage associated with the key, or null
         *                      if the key is missing or an error occurs in decoding the data
         */
        this.getCrossTabData = function(key) {
            return this.getData(key, {
                storages: localStorageName
            });
        };


        /**
         * Gets data from the scope of the current tab, then fall back to cross-tab if necessary
         *
         * @param {String} key - The key to store the data under
         * @returns {Object} - The data object from storage associated with the key, or null
         *                      if the key is missing or an error occurs in decoding the data
         */
        this.getDataWithFallback = function(key) {
            var data = this.getData(key, {
                storages: sessionStorageName
            });
            if (!data) {
                data = this.getData(key, {
                    storages: localStorageName
                });
            }
            return data;
        };


       /**
        * Sets a key-value pair in storage
        *
        * @param {String} key - The key to store the data under
        * @param {Object} value - The value to store at `key`
        * @param {Object} storageOpts - Options to pass about how to persist the data
        * @returns {Boolean} - true if the data was set, false if it was not
        */
        this.setData = function(key, value, storageOpts) {
            var logger = edap.internal.getPersistentLogger();
            return logger.set(key, value, storageOpts);
        };


        /**
         * Sets data in the scope of the current tab
         *
         * @param {String} key - The key to store the data under
         * @param {Object} value - The value to store at `key`
         */
        this.setTabSpecificData = function(key, value) {
            this.setData(key, value, {
                storages: sessionStorageName
            });
        };


        /**
         * Sets data for cross-tab use
         *
         * @param {String} key - The key to store the data under
         * @param {Object} value - The value to store at `key`
         */
        this.setCrossTabData = function(key, value) {
            this.setData(key, value, {
                storages: localStorageName
            });
        };


        /**
         * Encapsulates logic of fallback for determining session ID
         *
         * @param  {Object} data - The ADL Helpers data object to use for this session ID
         * @return {String} - The session ID
         */
        this.getSessionId = function(data) {
            // Fallback order: ADL.sessionid, 'has' cookie, '-1'
            var id;

            if (data.isSet('sessionid')) {
                return data.get('sessionid');
            }

            id = domHelpers.getCookie('has');

            if (data.shouldSet(id)) {
                return id;
            }

            return missingVal;
        };


        /**
         * Determines whether we should consider two session IDs to be a match
         *
         * @param  {String} id1 - The first session ID to compare
         * @param  {String} id2 - The second session ID to compare
         * @return {Boolean} - Whether the IDs were considdered to be a match
         */
        this.sessionIdsMatch = function(id1, id2) {
            return adl.shouldSet(id1) && adl.shouldSet(id2) && id1 === id2;
        };


        /**
        * Stores the current pageview ID
        *
        * @param {Object} data - The ADL Helpers data object to use
        */
        this.storeCurrentPageviewId = function(data) {
            var that = this,
                pageviewId = edap['public'].createUuid(),
                objToStore;

            // The currently stored pageview ID is the parent pageview ID. Before overwriting it,
            // we need to grab it for use with any events on this page.
            that.cacheParentPageviewId(pageviewId, data);

            // Write the current page's currentpageviewid to storage for use as the next page's parent
            // Need both tab-specific and cross-tab to support opening new tabs
            objToStore = {
                parentpageviewid: pageviewId,
                sessionid: that.getSessionId(data)
            };
            that.setTabSpecificData(storedIdKey, objToStore);
            that.setCrossTabData(storedIdKey, objToStore);

            // Set up an event listener for window focus to save the focused window's IDs to storage where they can be read by other tabs
            that.trackCurrentWindowIds();
        };


        /**
        * Retrieves and caches the parent pageview ID
        *
        * @param {String} pageviewId - The current pageview id from the ADL or auto-filled
        * @param {Object} data - The ADL Helpers data object to use
        */
        this.cacheParentPageviewId = function(pageviewId, data) {
            var that = this,
                idObj = that.getDataWithFallback(storedIdKey) || {},
                currentSessionId = that.getSessionId(data);

            if (!that.sessionIdsMatch(idObj.sessionid, currentSessionId)) {
                idObj.parentpageviewid = missingVal;
            }

            idObj.sessionid = currentSessionId;
            idObj.currentpageviewid = pageviewId;

            setParentPageviewIdObj(idObj);
        };


        /**
         * Initializes an event listener to set the currently focused tab's parent object into cross-tab storage
         */
        this.trackCurrentWindowIds = function() {
            var that = this,
                currentCrossTabStoredObj = that.getCrossTabData(storedIdKey),
                focusEventName = 'focus',
                currentTabSpecificStoredObj;

            // on focus, store focused window's stored ids from session storage into localStorage as well
            // so we can retieve it if someone opens a new tab
            function syncStorages() {
                currentTabSpecificStoredObj = that.getTabSpecificData(storedIdKey);
                that.setCrossTabData(storedIdKey, currentTabSpecificStoredObj);
            }

            // initialize our localStorage object for the case where new tabs are opened at the beginning of a
            // session without bluring/refocusing the current window/tab
            if (currentCrossTabStoredObj === null) {
                syncStorages();
            }

            // We don't want this added multiple times in a SPA - unregister before re-adding
            domHelpers.removeWindowEventListener(focusEventName, syncStorages);
            domHelpers.addWindowEventListener(focusEventName, syncStorages);
        };


        /**
        * Getter for the parent pageview ID
        * Checks that the ID is for the current session
        *
        * @param {Object} data - The ADL Helpers data object to use
        * @return {String} - The pageview ID of the previous page
        */
        this.getParentPageviewId = function(data) {
            var that = this,
                currentSessionId = that.getSessionId(data),
                parentPageviewIdObj = getParentPageviewIdObj();

            if (!that.sessionIdsMatch(parentPageviewIdObj.sessionid, currentSessionId)) {
                parentPageviewIdObj.parentpageviewid = missingVal;
            }

            return parentPageviewIdObj.parentpageviewid;
        };


        /**
        * Getter for the current pageview ID
        *
        * @return {String} - The pageview ID of the previous page
        */
        this.getCurrentPageviewId = function() {
            var parentPageviewIdObj = getParentPageviewIdObj();

            return parentPageviewIdObj.currentpageviewid;
        };
    }

    return new PageIdHelper();
});

define('data-enrichment/inauth-helper',['domhelpers'], function(domHelpers) {
    'use strict';

    function InAuthHelper() {
        var cachedInAuthId = null,
            inAuthCookieName = 'IAID';

        /**
         * Gets the InAuth ID from cache or defaults to trying to find it via cookie
         *
         * @returns {String} - The InAuth ID
         */
        this.getId = function() {
            if (cachedInAuthId !== null) {
                return cachedInAuthId;
            }

            cachedInAuthId = domHelpers.getCookie(inAuthCookieName);

            return cachedInAuthId;
        };

        /**
         * Reset the cached InAuth Id
         */
        this.resetCache = function() {
            cachedInAuthId = null;
        };
    }

    return new InAuthHelper();
});

define('data-enrichment/hooks/global',[
    'adlhelpers',
    'domhelpers',
    'data-enrichment/pageid-helper',
    'data-enrichment/inauth-helper'
], function(ADL, domHelpers, pageIdHelper, inAuthHelper) {
    'use strict';

    function setupHooks(edap) {
        edap['public'].lifecycle.register('onEventDataExtraction', function(eventName, data, opts) {
            var adl = new ADL(data),
                setIfShouldSet = adl.setIfShouldSet; // for da minificationz

            // on pageviews, we should store the pageview ID so it's available as the previous pageview ID on the next page
            if (eventName === 'pageview') {
                pageIdHelper.storeCurrentPageviewId(adl);
            }

            setIfShouldSet.apply(adl, ['pagehref', domHelpers.getHref()]);
            setIfShouldSet.apply(adl, ['edapintegrationsversion', domHelpers.getEdapIntegrationsVersion()]);
            setIfShouldSet.apply(adl, ['clienttimestamp', domHelpers.getMsFromEpoch()]);
            setIfShouldSet.apply(adl, ['edapeventid', edap['public'].createUuid()]);
            setIfShouldSet.apply(adl, ['currentpageviewid', pageIdHelper.getCurrentPageviewId()]);
            setIfShouldSet.apply(adl, ['parentpageviewid', pageIdHelper.getParentPageviewId(adl)]);
            setIfShouldSet.apply(adl, ['inauthid', inAuthHelper.getId()]);
            setIfShouldSet.apply(adl, ['screenwidth', domHelpers.getScreenWidth()]);
            setIfShouldSet.apply(adl, ['screenheight', domHelpers.getScreenHeight()]);
            setIfShouldSet.apply(adl, ['viewportwidth', domHelpers.getViewportWidth()]);
            setIfShouldSet.apply(adl, ['viewportheight', domHelpers.getViewportHeight()]);
            setIfShouldSet.apply(adl, ['mqsize', domHelpers.getMQSize()]);
            setIfShouldSet.apply(adl, ['clienttype', 'web']);
            setIfShouldSet.apply(adl, ['referralchange', domHelpers.isCrossDomainReferral()]);
            setIfShouldSet.apply(adl, ['preferredlanguage', domHelpers.getPreferredLanguage()]);

            return [eventName, data, opts];
        });
    }

    return {
        setupHooks: setupHooks
    };
});

define('data-enrichment/register-data-enrichment-hooks',[
    'data-enrichment/hooks/global'
], function() {
    'use strict';

    var hooks = arguments,
        i;

    function setupHooks(edap) {
        for (i = 0; i < hooks.length; i++) {
            hooks[i].setupHooks(edap);
        }
    }

    return {
        setupHooks: setupHooks
    };
});

define('data-enrichment/edap-data-enrichment-integration',[
    'edap',
    'data-enrichment/register-data-enrichment-hooks'
], function(edap, hooks) {
    'use strict';

    var moduleName = 'data-enrichment',
        myEdap = new edap.Scope(moduleName);

    /**
     *  Main init() for the hadoop integration. It kicks off registering all the hooks.
     *
     *  @returns {Object} - EDAP instance to make this chainable
     */
    function init() {
        hooks.setupHooks(myEdap);

        return edap;
    }

    return {
        init: init
    };
});

define('ua/ua-config',[], function() {
    'use strict';

    return {

        /**
         *  The EDAP Scope name of the UA module
         */
        edapScopeName: 'ua',


        /**
         *  The <script> id to use when loading the UA script
         */
        scriptId: 'edap-ua',


        /**
         *  The Universal Analytics global namespace (ex. window.ua) that UA exposes
         */
        uaNS: window.edapOptions.uaNS || 'ua',


        /**
         * The name for our UA tracker (which will also prefix all `ua(...)` calls)
         */
        uaTrackerName: window.edapOptions.ns,


        /**
         * The URL to the Universal Analytics script
         */
        uaScriptUrl: '//www.google-analytics.com/analytics.js',


        /**
         * The URL to the Universal Analytics debug script
         */
        uaDebugScriptUrl: '//www.google-analytics.com/analytics_debug.js',


        /**
         *  The Universal Analytics cookie name
         */
        uaCookieName: '_ga',


        /**
         *  Cross-domain tracking query parameter
         */
        uaCrossDomainParam: '_haga',


        /**
         *  The persistent cookie name for entry info
         */
        entryInfoCookie: '__utmuaepi',


        /**
         *  The order of the cookie data in the entryInfoCookie
         */
        entryInfoCookieFormat: ['entrypagename', 'entrypagetype'],


        /**
         * The maximum number of bytes allowed in a UA Custom Dimension
         */
        maxDimensionBytes: 150,


        /**
         *  Config of monikerbrand/analyticsbrand to config data per brand.
         *
         *  Config data format is:
         *    [UA ProfileId, Cookie Domain, Cookie Path, Profile Regex, Profile Regex Weight, Skip Profile Regex]
         *
         *  UA ProfileId - The UA profile id, ex. 'UA-22402634-2'
         *  Cookie Domain - The Cookie domain to use for the UA cookie. If null, then it will use the current hostname.
         *  Cookie Path - Almost always "/", unless your site segments UA profiles on different paths.
         *                ex. bedandbreakfast.com/fr is tracked by a different profile that bedandbreakfast/de
         *  Profile Regex - Only to be used if the Cookie Domain cannot be used to differentitate profiles. Should
         *                  be setup to match the entire ^ to $ path including query params
         *  Profile Weight - Only to be used if the Profile Regex is used. This overrides the Cookie Domain default
         *                   weight based on the number of "." segments. Weight is used to determine the most specific
         *                   profile matching an href and ultimately the highest weight wins. If two profiles match
         *                   and have the same weight then an error will be thrown, so adjust your Profile Regex
         *                   accordingly.
         *  Skip Profile Regex - Use this for sites that do not have a unique href that can be matched via regex. This site will
         *                       not be processed in "getMonikerBrandByHref" and can only be set using ADL.analyticsbrand. Currently
         *                       this option is used for the hasp_(v12|escapia) sites since they have some weird URLs.
         *
         *  NOTE: At least one of Cookie Domain or Profile Regex must be set to a non-null in order to properly match a site.
         */
        supportedSites: {
            abritel: ['UA-1010473-2', 'abritel.fr', '/', null, null],
            admin_homeaway_us: ['UA-750552-20', null, '/', /^https?:[/][/]admin[^.]*[.]homeaway[.]com(:\d+)?[/]?.*$/, 3],
            asia_homeaway_us: ['UA-750552-15', null, '/', /^https?:[/][/]asia[^.]*[.]homeaway[.]com(:\d+)?[/]?.*$/, 3],
            bookabach: ['UA-616929-17', null, '/', /^https?:[/][/](www[.])?([^.]*[.])?bookabach[.](local|dev|co[.]nz)(:\d+)?[/]?.*$/, 3],
            bnb: ['UA-210916-1', 'bedandbreakfast.com', '/', null, null],
            bnb_de: ['UA-210916-24', 'de.bedandbreakfast.com', '/', null, null],
            bnb_es: ['UA-210916-15', 'es.bedandbreakfast.com', '/', null, null],
            bnb_fr: ['UA-210916-14', 'fr.bedandbreakfast.com', '/', null, null],
            bnb_it: ['UA-210916-16', 'it.bedandbreakfast.com', '/', null, null],
            expedia_abritel: ['UA-1010473-7', null, '/', /^https?:[/][/]expedia[^.]*[.]abritel[.]fr(:\d+)?[/]?.*$/, 3],
            expedia_homeaway_de: ['UA-695211-4', null, '/', /^https?:[/][/]expedia[^.]*[.]fewo-direkt[.]de(:\d+)?[/]?.*$/, 3],
            expedia_homeaway_it: ['UA-6702181-3', null, '/', /^https?:[/][/]expedia[^.]*[.]homeaway[.]it(:\d+)?[/]?.*$/, 3],
            expedia_homeaway_us: ['UA-750552-12', null, '/', /^https?:[/][/]expedia[^.]*[.]homeaway[.]com(:\d+)?[/]?.*$/, 3],
            expediagroup: ['UA-143562396-1', 'expediagroup.com', '/', null, null],
            hasp_escapia: ['UA-72367836-1', null, '/', null, null, true], // hasp has weird URLs per environment so default cookie hostname and skip regex
            hasp_v12: ['UA-72367836-2', null, '/', null, null, true], // hasp has weird URLs per environment so default cookie hostname and skip regex
            homeaway_ar: ['UA-26926207-8', 'homeaway.com.ar', '/', null, null],
            homeaway_asia: ['UA-26926207-8', 'homeaway.asia', '/', null, null],
            homeaway_at: ['UA-25375606-1', 'homeaway.at', '/', null, null],
            homeaway_au: ['UA-20666200-1', 'homeaway.com.au', '/', null, null],
            homeaway_br: ['UA-16267529-1', 'aluguetemporada.com.br', '/', null, null],
            homeaway_ca: ['UA-20662353-1', 'homeaway.ca', '/', null, null],
            homeaway_cafr: ['UA-20659398-1', 'fr.homeaway.ca', '/', null, null],
            homeaway_cl: ['UA-26926207-8', 'homeaway.cl', '/', null, null],
            homeaway_cn: ['UA-26926207-8', 'homeaway.com.cn', '/', null, null],
            homeaway_co: ['UA-26926207-8', 'homeaway.com.co', '/', null, null],
            homeaway_de: ['UA-695211-1', 'fewo-direkt.de', '/', null, null],
            homeaway_dk: ['UA-6698428-1', 'homeaway.dk', '/', null, null],
            homeaway_ec: ['UA-26926207-8', 'homeaway.ec', '/', null, null],
            homeaway_es: ['UA-6515617-1', 'homeaway.es', '/', null, null],
            homeaway_fi: ['UA-8405990-1', 'homeaway.fi', '/', null, null],
            homeaway_gr: ['UA-57529940-1', 'homeaway.gr', '/', null, null],
            homeaway_hk: ['UA-26926207-8', 'homeaway.hk', '/', null, null],
            homeaway_id: ['UA-26926207-8', 'homeaway.co.id', '/', null, null],
            homeaway_in: ['UA-26926207-8', 'homeaway.co.in', '/', null, null],
            homeaway_it: ['UA-6702181-1', 'homeaway.it', '/', null, null],
            homeaway_jp: ['UA-26926207-8', 'homeaway.jp', '/', null, null],
            homeaway_kr: ['UA-26926207-8', 'homeaway.co.kr', '/', null, null],
            homeaway_lk: ['UA-26926207-8', 'homeaway.lk', '/', null, null],
            homeaway_mx: ['UA-20659393-1', 'homeaway.com.mx', '/', null, null],
            homeaway_my: ['UA-26926207-8', 'homeaway.com.my', '/', null, null],
            homeaway_nl: ['UA-6702415-1', 'homeaway.nl', '/', null, null],
            homeaway_nz: ['UA-35336958-1', 'homeaway.co.nz', '/', null, null],
            homeaway_no: ['UA-6737728-1', 'homeaway.no', '/', null, null],
            homeaway_pe: ['UA-26926207-8', 'homeaway.com.pe', '/', null, null],
            homeaway_ph: ['UA-26926207-8', 'homeaway.com.ph', '/', null, null],
            homeaway_pl: ['UA-62763815-1', 'homeaway.pl', '/', null, null],
            homeaway_pt: ['UA-6698180-1', 'homeaway.pt', '/', null, null],
            homeaway_ru: ['UA-26926207-8', 'homeaway.ru', '/', null, null],
            homeaway_se: ['UA-6698412-1', 'homeaway.se', '/', null, null],
            homeaway_sg: ['UA-26926207-8', 'homeaway.com.sg', '/', null, null],
            homeaway_th: ['UA-26926207-8', 'homeaway.co.th', '/', null, null],
            homeaway_tw: ['UA-26926207-8', 'homeaway.tw', '/', null, null],
            homeaway_uk: ['UA-5649527-1', 'homeaway.co.uk', '/', null, null],
            homeaway_us: ['UA-750552-1', 'homeaway.com', '/', null, null],
            homeaway_uy: ['UA-26926207-8', 'homeaway.com.uy', '/', null, null],
            homeaway_vn: ['UA-26926207-8', 'homeaway.com.vn', '/', null, null],
            homelidays_es: ['UA-10200033-4', 'homelidays.es', '/', null, null],
            homelidays_fr: ['UA-394012-1', 'homelidays.com', '/', null, null],
            homelidays_it: ['UA-394012-1', 'homelidays.it', '/', null, null],
            odhr: ['UA-3854735-1', 'ownersdirect.co.uk', '/', null, null],
            rezovation: ['UA-210916-3', 'rezovation.com', '/', null, null],
            stayz: ['UA-6596349-1', 'stayz.com.au', '/', null, null],
            toprural: ['UA-17472105-1', 'toprural.com', '/', null, null],
            toprural_cat: ['UA-17472502-1', 'toprural.cat', '/', null, null],
            toprural_fr: ['UA-17471817-1', 'toprural.fr', '/', null, null],
            toprural_it: ['UA-17471658-1', 'toprural.it', '/', null, null],
            toprural_pt: ['UA-17471555-1', 'toprural.pt', '/', null, null],
            travelmob: ['UA-26926207-8', 'travelmob.com', '/', null, null],
            vr: ['UA-2376682-1', 'vacationrentals.com', '/', null, null],
            vrbo: ['UA-188611-1', 'vrbo.com', '/', null, null],

            // add these for local development - don't route to a UA profile
            localhost: ['DEV', 'localhost', '/', null, null],
            '0.0.0.0': ['DEV', '0.0.0.0', '/', null, null],
            '127.0.0.1': ['DEV', '127.0.0.1', '/', null, null],
            github_pages: ['DEV', null, '/', /^(https?:[/][/])?github\.[\w]+\.com\/pages.*$/i, 1],
            homeaway_machine_name: ['DEV', null, '/', /^(https?:[/][/])?ha(00)?(\d{4})(\.[\w]+\.internal)?(:\d+)?[/]?.*$/i, 1],
            homeaway_machine_serial_number: ['DEV', null, '/', /^(https?:[/][/])?C02.*(\.[\w]+\.internal)?(:\d+)?[/]?.*$/i, 1]
        },


        /**
         *  ADL.pagename to VPV mapping
         */
        pagenameToVPV: {
            'ha: addto: add-on': '/cart/addto/add-on',
            'ha: addto: confirm': '/cart/addto/confirm',
            'ha: addto: cross sell': '/cart/addto/cross-sell',
            'ha: addto: payment': '/cart/addto/payment',
            'ha: addto: search position': '/cart/addto/search-position',
            'ha: addto: select subscription to upgrade': '/cart/addto/select-subscription-to-upgrade',
            'ha: list your property: add-on': '/cart/signup/add-on',
            'ha: list your property: confirm': '/cart/signup/confirm',
            'ha: list your property: cross sell': '/cart/signup/cross-sell',
            'ha: list your property: get help learn more': '/cart/signup/get-help-learn-more',
            'ha: list your property: get help referral': '/cart/signup/get-help-referral',
            'ha: list your property: payment': '/cart/signup/payment',
            'ha: list your property: pm admin tool': '/cart/signup/pm-admin-tool',
            'ha: list your property: pm directory entry': '/cart/signup/pm-directory-entry',
            'ha: list your property: ppb learn more': '/cart/signup/ppb-learn-more',
            'ha: list your property: ppb registration form': '/cart/signup/ppb-registration-form',
            'ha: list your property: pps learn more': '/cart/signup/pps-learn-more',
            'ha: list your property: pps registration form': '/cart/signup/pps-registration-form',
            'ha: list your property: register': '/cart/signup/register',
            'ha: list your property: search position': '/cart/signup/search-position',
            'ha: new property: add-on': '/cart/new-property/add-on',
            'ha: new property: confirm': '/cart/new-property/confirm',
            'ha: new property: cross sell': '/cart/new-property/cross-sell',
            'ha: new property: cyp': '/cart/new-property/cyp',
            'ha: new property: payment': '/cart/new-property/payment',
            'ha: new property: search position': '/cart/new-property/search-position',
            'ha: one step renewal: confirm': '/cart/one-step-renewal/confirm',
            'ha: one step renewal: payment': '/cart/one-step-renewal/payment',
            'ha: ppb new property: account info': '/cart/ppb-new-property/account-info',
            'ha: ppb new property:register': '/cart/ppb-new-property/register',
            'ha: ppb new property:rental policy': '/cart/ppb-new-property/rental-policy',
            'ha: ppb renewal: account info': '/cart/ppb-renewal/account-info',
            'ha: ppb renewal: cyp': '/cart/ppb-renewal/cyp',
            'ha: ppb renewal:register': '/cart/ppb-renewal/register',
            'ha: ppb renewal:rental policy': '/cart/ppb-renewal/rental-policy',
            'ha: ppb signup: account info': '/cart/ppb-signup/account-info',
            'ha: ppb signup: basic listing description': '/cart/ppb-signup/basic-listing-description',
            'ha: ppb signup: basic listing photos': '/cart/ppb-signup/basic-listing-photos',
            'ha: ppb signup: lyp': '/cart/ppb-signup/lyp',
            'ha: ppb signup:listingbuilder where': '/cart/ppb-signup/listingbuilder-where',
            'ha: ppb signup:register': '/cart/ppb-signup/register',
            'ha: ppb signup:rental policy': '/cart/ppb-signup/rental-policy',
            'ha: renewal: add-on': '/cart/renewal/add-on',
            'ha: renewal: confirm': '/cart/renewal/confirm',
            'ha: renewal: cross sell': '/cart/renewal/cross-sell',
            'ha: renewal: payment': '/cart/renewal/payment',
            'ha: renewal: search position': '/cart/renewal/search-position',
            'ha: renewal: select listings to renew': '/cart/renewal/select-listings-to-renew',
            'ha: special offer: confirm': '/cart/special-offer/confirm',
            'ha: special offer: payment': '/cart/special-offer/payment',
            'haolb : traveler checkout page': '/traveler/booking/checkout',
            'haolb : traveler confirmation page': '/traveler/booking/confirmation',
            'haolb : traveler payment page': '/traveler/booking/payment',
            'haolb : traveler rules policies page': '/traveler/booking/rulespolicies',
            'haolb : traveler trip protection page': '/traveler/booking/tripprotection',
            'owner login': '/owner/login/login',
            'payment: offline traveler checkout page': '/traveler/bookingpayment/offlinecheckout',
            'payment: offline traveler payments confirmation page': '/traveler/bookingpayment/offlineconfirmation',
            'payment: traveler payments confirmation page': '/traveler/bookingpayment/confirmation',
            'payment: traveler rules policies page': '/traveler/bookingpayment/rulespolicies',
            'payment: traveler trip protection page': '/traveler/bookingpayment/tripprotection',
            'reviews:submitted': '/traveler/review/submitted',
            'reviews:write': '/traveler/review/write',
            'traveler login': '/traveler/login/login',
            'traveler payment protection confirmation': '/traveler/paymentprotection/confirmation',
            'traveler payment protection form': '/traveler/paymentprotection/form',
            'vas: traveler checkout page': '/traveler/bookingvas/checkout',
            'vas: traveler confirmation page': '/traveler/bookingvas/confirmation',
            // TECHDEBT: This is the old Reviews pagename that can be removed once the new Review app goes live
            'write review': '/traveler/review/writereview'
        },


        /**
         *  Object of VPV's that are programmatically set
         */
        staticVPVs: {
            'inquirymodal': '/traveler/property/contactownermodal',
            'bookingmodal': '/traveler/property/bookingmodal',
            'quoteattempt': '/traveler/property/quoteattempt',
            'quotesuccess': '/traveler/property/quotesuccess',
            'quotefailure': '/traveler/property/quotefailure',
            'reviewsubmit': '/traveler/review/submitreview',
            'owner registration': '/owner/cart/registration',
            'inquiry confirmation': '/traveler/inquiry/submitted',
            'booking confirmation': '/traveler/booking/success'
        },


        /**
         *  Custom Dimension extractor config. In the format:
         *    dimensionName : extractor
         *
         *  dimensionName - Either a name or an integer. If it is an integer then it is assumed to be shorthand
         *                  for a Custom Dimension. If it is a string then it is assumed to be a UA parameter name.
         *  extractor - Can be either a String or a Function. If it is a String then it is assumed to be an
         *              ADL property, and it will be set if the ADL.isSet(key) return true.
         *              If it is a Function then the value will be set if ADL.isSet() of the return value of the function
         *              return true. The function prototype should look like:
         *                function(adl, ua, tracker) {...}
         *
         *              adl - ADLHelpers instance of the ADL data
         *              ua - UA-Wrapper instance
         *              tracker - UA tracker instance (for getting UA-specific data)
         */
        dimensionExtractors: {
            appName: 'appname',
            appVersion: 'appversion',
            1: function(adl, ua, tracker) {
                return ua.extractors.getVisitorId(adl, ua, tracker);
            },
            2: 'pagetype',
            3: 'pagename',
            4: 'geonode',
            5: function(adl, ua, tracker) {
                return ua.extractors.getEntryPageName(adl, ua, tracker);
            },
            6: 'visitortype',
            7: function(adl, ua, tracker) {
                return ua.extractors.getBrand(adl, ua, tracker);
            },
            8: function(adl, ua, tracker) {
                return ua.extractors.getUrl(adl, ua, tracker);
            },
            9: function(adl, ua, tracker) {
                return ua.extractors.getPPC(adl, ua, tracker);
            },
            // 10: open
            11: 'geonodelevel',
            12: 'inquiryid',
            13: 'eventquoteid', // note: This is not defined in the ADL (but should be in trigger data object)
            14: 'propertyid',
            // 15: open
            16: function(adl) {
                return adl.getListingIds();
            },
            17: 'reservationid',
            // 18: merchandizing based on AdSense click
            19: function(adl, ua, tracker) {
                return ua.extractors.getICID(adl, ua, tracker);
            },
            20: function(adl, ua, tracker) {
                return ua.extractors.getEntryPageType(adl, ua, tracker);
            },
            // 21: Canonical ????
            // 22: Lead ID ????
            23: 'registrationtype',
            24: function(adl, ua, tracker) {
                return ua.extractors.getSearchTerm(adl, ua, tracker);
            },
            25: 'numresults',
            26: 'publicuuid',
            27: function(adl, ua, tracker) {
                return ua.extractors.getCalendarLastUpdated(adl, ua, tracker);
            },
            // 28: Set in ua.getProctorDimension()
            29: 'searchviewtopdp',
            // 30: Set in ua.getProctorDimension()
            // 31: Not set
            32: 'searchtype',
            33: 'sort',
            34: 'sortproctor',
            35: function(adl, ua, tracker) {
                return ua.extractors.getPDPEntryDate(adl, ua, tracker);
            },
            // 36: Jahia/Marketing Optimizely Tests
            // 37: Ecommerce Optimizely Tests
            // 38: Set in ua.getProctorDimension()
            // 39: Cart Opimizely Tests
            40: 'ownerpublicuuid',
            41: 'searchview',
            42: 'inquirydetails',
            43: 'testattributes',
            // 44: Set in ua.getProctorDimension()
            // 45: Traveler Optimizely Tests
            // 46: Set in ua.getProctorDimension()
            // 47: Cart Optimizely Tests
            // 48: Set in ua.getProctorDimension()
            // 49: Dash Optimizely Tests
            // 50: Jahia Optimizely Tests

            // Property Details breakouts
            51: 'item1',  // Listing type ('cross sold', 'supersized', ...)
            52: 'propertytype',
            53: 'onlinepayments',
            54: 'translated',
            55: 'numreviews',
            56: 'multiunit',
            57: 'item2',
            58: 'responsivenesstime',
            59: 'responsivenessrate',
            60: 'item4',  // Owner Type
            61: 'item3', // PPS/PPB/PPL
            62: 'pmid',
            63: 'servicefee',

            81: function(adl, ua, tracker) {
                return ua.extractors.getICID(adl, ua, tracker);
            },
            82: function(adl, ua) {
                return ua.extractors.getEDAPIntegrationsVersion(adl, ua);
            },
            83: 'lengthofstay',
            84: 'paymentmethod',
            85: function(adl, ua) {
                return ua.extractors.getTripDates(adl);
            },
            86: 'refinebucket',
            87: 'refinevalue',
            88: function(adl, ua) {
                return ua.extractors.getRangeSet(adl, ua, 'minsleeps', 'maxsleeps');
            },
            89: function(adl, ua) {
                return ua.extractors.getRangeSet(adl, ua, 'minprice', 'maxprice');
            },
            90: function(adl, ua) {
                return ua.extractors.getRangeSet(adl, ua, 'minbeds', 'maxbeds');
            },
            91: function(adl, ua) {
                return ua.extractors.getRangeSet(adl, ua, 'minbaths', 'maxbaths');
            },
            92: 'locationtype',
            93: 'lbsuuid',
            94: function(adl, ua) {
                return ua.extractors.getHaVisitorID();
            },
            95: function(adl, ua) {
                return ua.extractors.getHaSessionID();
            },
            // 96: Set in ua.getProctorDimension()
            97: 'proctor', // page-level proctor variable
            98: 'paymentsplit',
            // 99: Set in ua.getProctorDimension()
            100: 'mpaasregion',
            101: function(adl, ua) {
                return ua.extractors.getNumGuests(adl);
            },
            // 102: Set in ua.getProctorDimension()
            106: 'hearttype',
            107: 'heartid',
            108: 'ownertype',
            109: 'edapeventid',
            110: 'edapeventname',
            111: 'currentpageviewid',
            112: 'parentpageviewid',
            113: 'displayprice',
            114: 'fullorderrentalrate',
            115: 'displayquotetotal',
            116: 'partnerfeesamount',
            117: 'numpartnerfees',
            118: 'servicefeeamount',
            119: 'ordertax',
            120: 'rdd',
            121: 'pdp',
            122: function(adl, ua) {
                return ua.extractors.getCurrency(adl);
            }
        }

    };
});

define('ua/dimension-extractors',[
    'domhelpers',
    'adlhelpers'
], function(domHelpers, ADL) {
    'use strict';

    function Extractors() {
        /**
         *  Extracts the contents of the UA Entry Info cookie into an object
         *
         *  @example
         *    extractors.parseEntryInfoCookie(ua);
         *
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {Object} - Object of cookie data based on the uaConfig.entryInfoCookieFormat
         */
        this.parseEntryInfoCookie = function(ua) {
            var uaConfig = ua.getConfig(),
                cookieData = domHelpers.getCookie(uaConfig.entryInfoCookie),
                cookieFormat = uaConfig.entryInfoCookieFormat,
                retData = {},
                win = domHelpers.getWindow(),
                splitData,
                tmpVal,
                i,
                len;

            if (cookieData === null) {
                splitData = [];
            } else {
                splitData = cookieData.split(':');
            }

            for (i = 0, len = cookieFormat.length; i < len; i++) {
                tmpVal = splitData[i];

                if (tmpVal === undefined) {
                    tmpVal = '-1';
                }

                retData[cookieFormat[i]] = win.decodeURIComponent(tmpVal);
            }

            return retData;
        };


        /**
         *  Updates the UA Entry Info cookie. Has a hard coded 30 minutes (session) timeout
         *
         *  @example
         *    extractors.updateValueEntryInfoCookie(ua, {entrypagename: 'testpage'}, 'homeaway.com');
         *
         *  @param {Object} [ua] - UA-wrapper object
         *  @param {Object} [data] - Cookie data object to set based on updateValueEntryInfoCookie
         *  @param {Stirng} [hostname] - Hostname of cookie
         */
        this.updateValueEntryInfoCookie = function(ua, data, hostname) {
            var uaConfig = ua.getConfig(),
                cookieData = this.parseEntryInfoCookie(ua),
                cookieFormat = uaConfig.entryInfoCookieFormat,
                win = domHelpers.getWindow(),
                cookieArr = [],
                tmpVal,
                i,
                len;

            for (i = 0, len = cookieFormat.length; i < len; i++) {
                tmpVal = data[cookieFormat[i]];

                if (data[cookieFormat[i]] !== undefined) {
                    tmpVal = data[cookieFormat[i]];
                } else if (cookieData[cookieFormat[i]]) {
                    tmpVal = cookieData[cookieFormat[i]];
                }

                if (tmpVal === undefined) {
                    tmpVal = '-1';
                }

                cookieArr.push(win.encodeURIComponent(tmpVal));
            }

            domHelpers.setCookie(uaConfig.entryInfoCookie, cookieArr.join(':'), hostname, 30);
        };


        /**
         *  Extractor for the UA visitorid/clientid
         *
         *  @example
         *    var cid = extractors.getVisitorId(new ADL({}), ua, tracker);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @param {Object} [tracker] - UA Tracker
         *  @returns {String} - first segmenet of the UA clientid
         */
        this.getVisitorId = function(adl, ua, tracker) {
            var cid = tracker.get('clientId'),
                retval;

            if (cid) {
                retval = cid;
            } else {
                ua.uaEdap.error('could not get UA clientid, skipping...');
                retval = '-1';
            }

            return retval;
        };


        /**
         *  Extractor for the Entry Page Name
         *
         *  @example
         *    var ep = extractors.getEntryPageName(new ADL({}), ua, tracker);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {String} - the entry page name
         */
        this.getEntryPageName = function(adl, ua) {
            var cookieData = this.parseEntryInfoCookie(ua),
                profileData = ua.getUAProfileData(),
                profileCookieDomain = profileData[1],
                ep;

            ep = cookieData.entrypagename;

            if (ep === '-1') {
                ep = adl.get('pagename');
                this.updateValueEntryInfoCookie(ua, {entrypagename: ep}, profileCookieDomain);
            } else {
                this.updateValueEntryInfoCookie(ua, {entrypagename: ep}, profileCookieDomain);
            }

            return ep;
        };


        /**
         *  Extractor for the Entry Page Type
         *
         *  @example
         *    var ept = extractors.getEntryPageType(new ADL({}), ua);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {String} - the entry page type
         */
        this.getEntryPageType = function(adl, ua) {
            var cookieData = this.parseEntryInfoCookie(ua),
                profileData = ua.getUAProfileData(),
                profileCookieDomain = profileData[1],
                ept;

            ept = cookieData.entrypagetype;

            if (ept === '-1') {
                ept = adl.get('pagetype');
                this.updateValueEntryInfoCookie(ua, {entrypagetype: ept}, profileCookieDomain);
            } else {
                this.updateValueEntryInfoCookie(ua, {entrypagetype: ept}, profileCookieDomain);
            }

            return ept;
        };


        /**
         *  Extractor for Brand
         *
         *  @example
         *    var brand = extractors.getBrand(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - the brand
         */
        this.getBrand = function(adl) {
            if (adl.isSet('monikerbrand')) {
                return adl.get('monikerbrand');
            } else if (adl.isSet('brand')) {
                return adl.get('brand');
            }

            return '-1';
        };


        /**
         *  Extractor for the url
         *
         *  @example
         *    var href = extractors.getUrl(new ADL({}), ua);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {String} - the url
         */
        this.getUrl = function(adl, ua) {
            var href = '-1';

            try {
                href = domHelpers.getPage();
            } catch (err) {
                ua.uaEdap.error('Error when extracting UA url: ' + err.message);
            } finally {
                return href;
            }
        };


        /**
         *  Extractor for the Search Term
         *
         *  @example
         *    var searchterm = extractors.getSearchTerm(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - Search term based on the ADL
         */
        this.getSearchTerm = function(adl) {
            if (adl.isSet('searchterm')) {
                return adl.get('searchterm');

            // TECHDEBT: GT sets ADl.keywords right now, should be removed when they set ADL.searchterm correctly
            } else if (adl.isSet('keywords')) {
                return adl.get('keywords');
            }

            return '-1';
        };


        /**
         *  Extractor for the "CalendarLastUpdated" value
         *
         *  @example
         *    var calendarlastupdated = extractors.getCalendarLastUpdated(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - "CalendarLastUpdated" value based on the ADL
         */
        this.getCalendarLastUpdated = function(adl) {
            if (adl.isSet('calendarlastupdated')) {
                return adl.get('calendarlastupdated');

            // TECHDEBT: GT sets ADl.calendarupdated right now, should be removed when they set ADL.calendarlastupdated correctly
            } else if (adl.isSet('calendarupdated')) {
                return adl.get('calendarupdated');
            }

            return '-1';
        };


        /**
         *  Extractor for the "getPDPEntryDate" value
         *
         *  @example
         *    var pdpentrydate = extractors.getPDPEntryDate(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - "getPDPEntryDate" value based on the ADL
         */
        this.getPDPEntryDate = function(adl) {
            var startDate,
                endDate;

            if (adl.get('pagetype') === 'property') {
                startDate = adl.get('startdate');
                endDate = adl.get('enddate');

                return ((typeof startDate === 'string' && startDate.length > 0) &&
                        (typeof endDate === 'string' && endDate.length > 0)) ? 'dates on PDP' : 'no dates';
            }

            return '-1';
        };


        /**
         *  Extractor for proctor logging (both the value to log and where to log it)
         *  Will return "-1" for the dimension and/or proctor string if the values aren't recognized/valid
         *  This will keep them from being written to any of the visit-scoped proctor custom dimensions
         *
         *  @example
         *    var proctorDataStruct = extractors.getProctorDimension(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {Array} - [{String} dimensionId, {String} proctorTestString]
         */
        this.getProctorDimension = function(adl) { // eslint-disable-line complexity
            // disabled eslint complexity rather than refactoring since sharding out proctor data is TECHDEBT
            var proctor = adl.get('proctor'),
                pageAdl = new ADL(),
                retData;

            if (proctor === undefined || proctor === null || proctor === '') {
                proctor = '-1';
            }

            // TECHDEBT: get pagetype from the page's ADL rather than the event data because of the overridden pagetype on VPVs
            switch (pageAdl.get('pagetype')) {
                case 'booking':
                case 'booking payment':
                    retData = ['48', proctor];
                    break;

                case 'cart':
                    retData = ['30', proctor];
                    break;

                case 'travelerdash':
                    retData = ['96', proctor];
                    break;

                case 'home':
                    retData = ['99', proctor];
                    break;

                case 'lyp':
                    retData = ['46', proctor];
                    break;

                case 'ownerdash':
                    if (adl.get('appname') === 'global-dashboard-ui') {
                        retData = ['44', proctor];
                    } else {
                        retData = ['28', proctor];
                    }
                    break;

                case 'search landing page':
                    if (adl.get('appname') === 'landingpageapp') {
                        retData = ['102', proctor];
                    } else {
                        // NOTE: node-slp will be getting on proctor at some point, don't want them clobbering landingpageapp
                        retData = ['-1', '-1'];
                    }
                    break;

                case 'search':
                case 'property':
                case 'inquiry':
                case 'inquiry confirmation': // TECHDEBT: This isn't in the spec but people use it ¯\_(ツ)_/¯
                    retData = ['38', proctor];
                    break;

                default:
                    retData = ['-1', '-1'];
            }

            return retData;
        };


        /**
         *  Extractor for ppc ids
         *
         *  @example
         *    var ppc = extractors.getPPC(new ADL({}), ua, tracker);
         *
         *  @returns {String} - PPC ID
         */
        this.getPPC = function() {
            var val = domHelpers.getSearchParam('k_clickid');

            return val || '-1';
        };


        /**
         *  Extractor for ICID vals
         *
         *  @example
         *    var icid = extractors.getICID(new ADL({}), ua, tracker);
         *
         *  @returns {String} - ICIC value
         */
        this.getICID = function() {
            var val = domHelpers.getSearchParam('icid');

            return val || '-1';
        };


        /**
         *  Extractor for the EDAP-Integrations Version
         *
         *  @example
         *    var eiVersion = extractors.getEDAPIntegrationsVersion(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - the EDAP-Integrations version or 'unknown'
         */
        this.getEDAPIntegrationsVersion = function(adl) {
            var version = domHelpers.getEdapIntegrationsVersion();

            if (adl.shouldSet(version)) {
                return version;
            }

            return 'unknown';
        };


        /**
         *  Extractor for the Trip Dates
         *
         *  @example
         *    var tripDates = extractors.getTripDates(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - the Trip Dates string in the format "ADL.eventstartdate,ADL.eventenddate"
         *                      or "ADL.startdate,ADL.enddate". If both values are missing, a "-1" is returned
         */
        this.getTripDates = function(adl) {
            var startDate = 'startdate',
                endDate = 'enddate',
                eventStartDate = 'event' + startDate,
                eventEndDate = 'event' + endDate,
                datesStr = '-1',
                dates;

            if (adl.isSet(eventStartDate) && adl.isSet(eventEndDate)) {
                dates = [
                    adl.get(eventStartDate),
                    adl.get(eventEndDate)
                ];
            } else if (adl.isSet(startDate) && adl.isSet(endDate)) {
                dates = [
                    adl.get(startDate),
                    adl.get(endDate)
                ];
            }

            if (dates) {
                datesStr = dates.join(',');
            }

            return datesStr;
        };


        /**
         * Gets the string for number of guests
         *
         * Format: numadults,numchildren,numinfants,withpets
         * Any of those values will be replaced by "-1" if missing
         *
         * @param  {Object} adl ADLHelper instance
         * @return {String}     The comma-delimited string for number of guests
         */
        this.getNumGuests = function(adl) {
            var defaultValue = '-1';

            function defaultToMinusOne(val) {
                if (val === undefined) {
                    return defaultValue;
                }
                return val;
            }

            return [
                defaultToMinusOne(adl.isSetGet('numadults')),
                defaultToMinusOne(adl.isSetGet('numchildren')),
                defaultToMinusOne(adl.isSetGet('numinfants')),
                defaultToMinusOne(adl.isSetGet('withpets'))
            ].join(',');
        };


        /**
         *  Abstract extractor that will return a value in the form:
         *      "ADL.minKey,ADL.maxKey"
         *   where missing values are set as a "-1" and if both values are missing then
         *   it returns a "-1"
         *
         *  @example
         *    var searchGuests = extractors.getRangeSet(new ADL({}), ua, 'minsleeps', 'maxsleeps');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @param {String} [minKey] - Minimum (left side) ADL key to lookup
         *  @param {String} [maxKey] - Maximum (right side) ADL key to lookup
         *  @returns {String} - comma-delimited list of "ADL.minKey,ADL.maxKey"
         *                      Missing values are set as a "-1", if both values are missing then this
         *                      will return "-1";
         */
        this.getRangeSet = function(adl, ua, minKey, maxKey) {
            var defaultValue = '-1',
                minVal,
                maxVal;

            if (!minKey || !maxKey) {
                ua.uaEdap.error('getRangeSet: Incorrect min/maxKey parameters: minKey:"' + minKey + '" maxKey:"' + maxKey + '"');
                return defaultValue;
            }

            // If either is set then we need to return a value
            if (adl.isSet(minKey) || adl.isSet(maxKey)) {
                minVal = (adl.isSetGet(minKey) === undefined ? defaultValue : adl.get(minKey));
                maxVal = (adl.isSetGet(maxKey) === undefined ? defaultValue : adl.get(maxKey));
                return minVal + ',' + maxVal;
            }

            return defaultValue;
        };


        /**
         * Gets the HomeAway visitor ID from the 'hav' cookie
         *
         * @return {String} The HA Visitor ID
         */
        this.getHaVisitorID = function() {
            return domHelpers.getCookie('hav') || '-1';
        };

        /**
         * Gets the HomeAway session ID from the 'has' cookie
         *
         * @return {String} The HA session ID
         */
        this.getHaSessionID = function() {
            return domHelpers.getCookie('has') || '-1';
        };

        /**
         *  Extractor for currency
         *
         *  @example
         *    var currency = extractors.getCurrency(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - The currency code
         */
        this.getCurrency = function(adl) {
            if (adl.isSet('eventquotecurrency')) {
                return adl.get('eventquotecurrency');
            } else if (adl.isSet('currency')) {
                return adl.get('currency');
            }

            return '-1';
        };
    }

    return new Extractors();
});

define('ua/ua-wrapper',[
    'edap',
    'adlhelpers',
    'domhelpers',
    'doneable',
    'debughelpers',
    'ua/dimension-extractors',
    'ua/ua-config',
    'edaphelpers'
], function(edap, ADL, domHelpers, Doneable, debugHelpers, extractors, uaConfig, edapHelpers) {
    'use strict';

    function UA() {
        var uaTracker;

        /**
         *  The Custom Dimesnion extractor functions object
         */
        this.extractors = extractors;


        /**
         *  The UA Scope Edap object
         *
         *  Defaulted to edap and the ua scope is set up in init()
         */
        this.uaEdap = edap;


        /**
         *  The global ADL object
         */
        this.globalADL = new ADL();


        /**
         *  Extracts the clientId from a UA "_ga" cookie value
         *
         *  @example
         *      var _ga = 'GA1.3.1240662337.1454057530';
         *      var clientId = parseClientIdFromUACookie(_ga);
         *      clientId === '1240662337.1454057530' //true
         *
         *  @param {String} [cookie] - UA cookie value (ex. 'GA1.3.1240662337.1454057530')
         *  @returns {String} - Client ID extracted from the UA cookie. (ex. '1240662337.1454057530') or null
         */
        this.parseClientIdFromUACookie = function(cookie) {
            var cookieParts;

            // Cookie has to be a string, otherwise we can't parse the clientId from it
            if (typeof cookie !== 'string') {
                return null;
            }

            cookieParts = cookie.split('.');

            // Validate the cookie format before we extract the clientId
            if (cookieParts.length !== 4 || cookie.indexOf('GA') !== 0) {
                this.uaEdap.error('Unrecognized UA cookie format: ' + cookie);
                return null;
            }

            // Return the clientId
            return [cookieParts[2], cookieParts[3]].join('.');
        };


        /**
         *  Created a log entry into the EDAP UA Scope Data object for debugging UA actions
         *
         *  @example
         *    ua.logUAAction('Event', ['send', 'event', 'category', 'action', 'label', value]);
         *
         *  @param {String} [type] - The type of UA action to log
         *  @param {Object} [data] - Any associated data to log
         */
        this.logUAAction = function(type, data) {
            var dataLog;

            if (this.uaEdap === null) {
                edap.error('Could not log UA event: ' + [type, data].join(','));
                return;
            }

            dataLog = this.uaEdap.getData();

            dataLog.uaevents = dataLog.uaevents || [];
            dataLog.uaevents.push([type, data]);
        };


        /**
         *  Wrapper for making the Custom Dimension string
         *
         *  @example
         *    var dim = ua.dimName(1);
         *
         *  @param {Number} [id] - The numeric ID of a Custom Dimension
         *  @returns {String} - Any associated data to log
         */
        this.dimName = function(id) {
            return 'dimension' + id;
        };


        /**
         *  Helper function for determining whether a value should be a "dimension" or just
         *  a passthrough.
         *
         *  @example
         *    var dim = ua.dimName(1);  // dim='dimension1'
         *    var dim = ua.dimName('appName');  // dim='appName'
         *
         *  @param {Object} [id] - Value to check if it should be a dimension
         *  @returns {Object} - If the value is parseInt()-able then it is considered a "dimension"
         *                      otherwise it will just return the same value
         */
        this.determineDimName = function(id) {
            var numId = parseInt(id, 10);

            // If you pass through a non-number-like value then just return it
            if (isNaN(numId)) {
                return id;
            }

            return this.dimName(numId);
        };


        /**
         *  Wrapper for making the Custom Metric string
         *
         *  @example
         *    var metric = ua.metricName(1);
         *
         *  @param {Number} [id] - The numberic ID of a Custom Metric
         *  @returns {String} - Any associated data to log
         */
        this.metricName = function(id) {
            return 'metric' + id;
        };


        /**
         *  Getter for the ua-config module data
         *
         *  @example
         *    var sid = ua.getConfig();
         *
         *  @returns {Object} - Config data object
         */
        this.getConfig = function() {
            return uaConfig;
        };


        /**
         *  Getter for the global UA instance
         *
         *  @example
         *    var ua = ua.getUA();
         *
         *  @returns {Object} - Global UA instance
         */
        this.getUA = function() {
            return domHelpers.getWindow()[this.getConfig().uaNS];
        };


        /**
         * Truncates an ASCII/UTF-8 string to a given number of bytes
         *
         * truncation algorithm based on:
         * http://stackoverflow.com/questions/1515884/using-javascript-to-truncate-text-to-a-certain-size-8-kb
         *
         * @param  {String} str The string to truncate
         * @param  {Number} n   The number of bytes to truncate to
         * @return {String}     The truncated version of str
         */
        this.truncateDimensionByUTF8Bytes = function(str, n) {
            var found = false,
                strBytes,
                res = str;

            function toBytesUTF8(chars) {
                return unescape(encodeURIComponent(chars));
            }
            function fromBytesUTF8(bytes) {
                return decodeURIComponent(escape(bytes));
            }

            strBytes = toBytesUTF8(str).substring(0, n);

            // short-circut if the original string is good
            if (strBytes.length < n) {
                return str;
            }

            while (!found) {
                try {
                    res = fromBytesUTF8(strBytes);

                    // will only get here if no URIError from dividing chars
                    found = true;
                } catch (e) {
                }
                strBytes = strBytes.substring(0, strBytes.length - 1);
            }

            return res;
        };


        /**
         * Handles prefixing the name of the UA function with the correct tracker name
         *
         * @param  {String} uaFuncName The UA function we want to call on the UA object (e.g. "send", "set", etc.)
         * @return {String}            The UA function name prefixed by the tracker name
         */
        this.buildUaFunctionName = function(uaFuncName) {
            return [
                this.getConfig().uaTrackerName,
                uaFuncName
            ].join('.');
        };


        /**
         * Logs an error message for truncated custom dimensions
         *
         * @param  {Array} truncationsObjs An array of objects containing truncation info with keys 'dimName', 'originalValue', and 'truncatedValue'
         */
        this.logTruncationErrors = function(truncationsObjs) {
            var config = this.getConfig(),
                maxDimensionBytes = config.maxDimensionBytes,
                skipDimensions = {
                    'dimension8': true,
                    'dimension97': true // FIXME: this should be removed when we get rid of the split proctor vars
                },
                truncatedDimensions = [],
                currentDim,
                i;

            for (i = 0; i < truncationsObjs.length; i++) {
                currentDim = truncationsObjs[i].dimName;

                // don't log truncation of the URL or the second proctor dimension
                if (!skipDimensions[currentDim]) {
                    truncatedDimensions.push(currentDim);
                }
            }

            // log any errors we found
            if (truncatedDimensions.length > 0) {
                this.uaEdap.error([
                    'UA: the following Custom Dimensions were truncated because they were longer than ',
                    maxDimensionBytes,
                    ' bytes: ',
                    truncatedDimensions.join(', '),
                    ' (see http://h.a/edapdimensionmapping for more info)'
                ].join(''));
            }
        };


        /**
         *  Setter for a UA Custom Dimension
         *
         *  @example
         *    var ua = ua.setUADimension('dimension1', '1234');
         *
         *  @example
         *    var ua = ua.setUADimension(2, '123456');
         *
         *  @params {Object} [key] - String or Number of the dimension
         *  @params {String} [value] - Value to assign to the key
         */
        this.setUADimension = function(key, value) {
            var config = this.getConfig(),
                maxDimensionBytes = config.maxDimensionBytes;

            if (typeof key === 'number') {
                key = this.dimName(key);
            }

            value = this.truncateDimensionByUTF8Bytes(value, maxDimensionBytes);

            this.setUAParam(key, value);
        };


        /**
         *  Setter for a UA Custom Dimensions (bulk setting)
         *
         *  @example
         *    var ua = ua.setUADimensions({1: 'bob', 2: 'fred'});
         *
         *  @params {Object} [dimMap] - Key/Value object of dimension -> value
         */
        this.setUADimensions = function(dimMap) {
            var dimKey;

            for (dimKey in dimMap) {
                /* istanbul ignore else  */
                if (dimMap.hasOwnProperty(dimKey)) {
                    // In an object all the keys will be a string so parseInt it to see if it should be an int
                    if (!isNaN(parseInt(dimKey, 10))) {
                        dimKey = parseInt(dimKey, 10);
                    }
                    this.setUADimension(dimKey, dimMap[dimKey]);
                }
            }
        };


        /**
         *  Setter for any parameter on the UA object
         *
         *  @example
         *    var ua = ua.setUAParam('appversion', '1.2.3');
         *
         *  @params {String} [key] - Name of the parameter
         *  @params {String} [value] - Value to assign to the key
         */
        this.setUAParam = function(key, value) {
            var ua = this.getUA();

            ua(this.buildUaFunctionName('set'), key, value);
        };


        /**
         *  Loads a UA plugin
         *
         *  @example
         *    ua.loadPligin('displayfeatures');
         *
         *  @param {*} [arguments] - arguments to be apply()'d to ua require function
         */
        this.loadPlugin = function() {
            var data = [this.buildUaFunctionName('require')],
                ua = this.getUA(),
                i,
                len;

            for (i = 0, len = arguments.length; i < len; i++) {
                data.push(arguments[i]);
            }

            ua.apply(ua, data);
        };


        /**
         *  Inserts the Universal Analytics script into the DOM
         *  It will not insert the script twice as it is using the DomHelpers.loadScript()
         *
         *  @example
         *    var wasScriptLoaded = ua.dropScript();
         *
         *  @returns {Boolean} - if the script was inserted of not
         */
        this.dropScript = function() {
            var that = this,
                conf = that.getConfig(),
                win = domHelpers.getWindow(),
                uaScriptToLoad = conf.uaScriptUrl,
                loadTimestamp;

            // If debugging is enabled then we should load the debug script
            if (debugHelpers.isInDebugMode(conf.edapScopeName)) {
                uaScriptToLoad = conf.uaDebugScriptUrl;
            }

            win.GoogleAnalyticsObject = conf.uaNS;
            win[conf.uaNS] = that.getUA() || function() {
                (win[conf.uaNS].q = that.getUA().q || []).push(arguments);
            };
            win[conf.uaNS].l = 1 * new Date();

            that.uaEdap.trigger('ua.load');
            loadTimestamp = domHelpers.getMsFromEpoch();

            win[conf.uaNS](function() {
                var currentTimestamp = domHelpers.getMsFromEpoch(),
                    loadtime = (currentTimestamp - loadTimestamp);

                that.uaEdap.trigger('ua.did.load', {
                    loadtime: '' + loadtime
                });
            });

            // Insert the script into the DOM
            return domHelpers.loadScript(uaScriptToLoad, conf.scriptId);
        };


        /**
         *  UA-specific "extend"-like function when it comes to options on a "send" command.
         *  Mostly it just makes sure that all the keys in defaultOpts are copied into passedOpts.
         *  The only special case is hitCallback and there is logic to make sure that the
         *  defaultOpts.hitCallback is always called event if there is already a passedOpts.hitCallback.
         *
         *  @example
         *    var defaultOpts = {
         *          nonInteraction: true,
         *          hitCallback: function() {}
         *        },
         *        passedOpts = {
         *          metric1: 1,
         *          hitCallback: function() {}
         *        }
         *    var mergedOpts = ua.mergeOptions(defaultOpts, passedOpts);
         *
         *  @param {Object} [defaultOpts] - Options to make sure exist in the return value
         *  @param {Object} [passedOpts] - Existing options that defaultOpts are merged into
         *  @returns {Object} - The final listed of merged options
         */
        this.mergeOptions = function(defaultOpts, passedOpts) {
            var that = this,
                passedHitCallback,
                i;

            // This is dynamically building the hitCallback function in order to closure in the original
            // callback function pointer as it loops over all the options. This is a bit of overkill since
            // this function will only be run once when the key is "hitCallback", but this will shut up ESLint.
            function saveHitCallback(callback) {
                return function() {
                    try {
                        callback.apply(callback);
                    } catch (err) {
                        that.uaEdap.error(err);
                    } finally {
                        defaultOpts.hitCallback();
                    }
                };
            }

            // Loop through the default opts and set them if not already set.
            for (i in defaultOpts) {
                /* istanbul ignore else  */
                if (defaultOpts.hasOwnProperty(i)) {
                    if (passedOpts.hasOwnProperty(i)) {
                        // If we get a hitCallback set then we should execute it and then execute our defaultOpts.hitCallback
                        if (i === 'hitCallback' && typeof passedOpts[i] === 'function') {
                            passedHitCallback = passedOpts[i];

                            passedOpts[i] = saveHitCallback(passedHitCallback);
                        }
                    } else {
                        passedOpts[i] = defaultOpts[i];
                    }
                }
            }

            return passedOpts;
        };


        /**
         * Handles extracting custom dimensions into event-level options for local CD override
         *
         * @param  {Object} [adlData]    - The data to use for dimensions
         * @param  {Object} [opts]       - The options object to override
         * @param  {Object} [configOpts] - Config options for how to send a hit
         *         skipExtractDimensions - true if we should *not* re-evalutate Custom Dimensions for this event
         * @param  {Object} [tracker]    - The UA tracker object
         * @return {Object}              - The modified opts object
         */
        this.setDimensionsInOpts = function(adlData, opts, configOpts, tracker) {
            var that = this,
                adl,
                dimensions;

            if (adlData) {
                adl = new ADL(adlData);

                configOpts = configOpts || {};

                // set 'page' in the opts if we have an override
                opts.page = that.getPageUrl(adl);

                // setup the Custom Dimensions if we have data and don't have event CDs disabled
                if (!configOpts.skipExtractDimensions) {
                    dimensions = that.buildCustomDimensions(adl, tracker);

                    opts = that.mergeOptions(opts, dimensions);
                }
            }

            return opts;
        };


        /**
         *  Calls a function with the UA 'tracker' parameter
         *  The initial call will get the tracker asynchronously and cache it. Subsequent calls will occur synchronously.
         *
         *  @example
         *    function funcNeedsTracker(tracker) {...}
         *    ua.callWithTracker(funcNeedsTracker);
         *
         *  @param {Function} [cb] - callback to be called within the UA closure. It will be passed a single UA tracker parameter
         */
        this.callWithTracker = function(cb) {
            var that = this,
                ua = that.getUA(),
                trackerName = that.getConfig().uaTrackerName;

            if (!uaTracker) {
                ua.apply(that, [function() {
                    // ua and window.ua are NOT the same here
                    uaTracker = that.getUA().getByName(trackerName);

                    cb(uaTracker);
                }]);
            } else {
                cb(uaTracker);
            }
        };


        /**
         * Resets the cached UA tracker object to undefined
         */
        this.resetTrackerCache = function() {
            uaTracker = undefined;
        };


        /**
         *  Checks required fields for ua functions. Otherwise, these would silently fail unless using the debug script
         *
         *  @param  {String} uaHitType - The UA hit type (e.g. event, timing) that we're checking for
         *  @param  {Object} fieldsObj - Key/value pairs of a field name and its given value
         *  @return {Boolean} - True if all keys pass validation, false otherwise
         */
        this.checkUaHitFields = function(uaHitType, fieldsObj) {
            var that = this,
                currentVal,
                key;

            for (key in fieldsObj) {
                /* istanbul ignore else */
                if (fieldsObj.hasOwnProperty(key)) {
                    currentVal = fieldsObj[key];

                    // validate that any values for UA's 'value' field are numeric (could be string or number)
                    // otherwise, check that the values are strings
                    if (key === 'value') {
                        if (isNaN(parseFloat(currentVal, 10))) {
                            that.uaEdap.error('UA ' + uaHitType + ' requires ' + key + ' to be numeric');
                            return false;
                        }
                    } else if (typeof currentVal !== 'string') {
                        that.uaEdap.error('UA ' + uaHitType + ' requires ' + key + ' to be defined string');
                        return false;
                    }
                }
            }

            return true;
        };


        /**
         *  Sends a UA event with options and overridden Custom Dimensions
         *
         *  @example
         *    var sendEventDoneable = ua.sendEvent('myCategory', 'myAction', 'myLabel', mValue, opts);
         *
         *  @param {String} [category] - category to send for this event
         *  @param {String} [action] - action to send for this event
         *  @param {String} [label] - label to send for this event
         *  @param {Number} [value] - numeric value to send for this event
         *  @param {Object} [uaOpts] - UA options that can be set when when sending an event
         *                           note: setting any dimension values will override anything extracted from adlData
         *  @param {Object} [adlData] - ADL data to be used to fill the Custom Dimensions
         *  @param {Object} [configOpts] - config options for how to send the event
         *         skipExtractDimensions - true if we should *not* re-evalutate Custom Dimensions for this event
         *  @returns {Doneable} - Doneable object that will be resolve()'d when hitCallback is triggered
         */
        this.sendEvent = function(category, action, label, value, uaOpts, adlData, configOpts) {
            var that = this;

            function sendUaEvent(tracker) {
                return new Doneable(function(done) {
                    var sendData = [
                            that.buildUaFunctionName('send'),
                            'event',
                            category,
                            action,
                            label,
                            value
                        ],
                        ua = that.getUA(),
                        defaultOpts = {
                            'nonInteraction': true,
                            'hitCallback': function() {
                                done();
                            }
                        },
                        opts = defaultOpts;

                    opts = that.setDimensionsInOpts(adlData, opts, configOpts, tracker);

                    // finally, apply any passed-in opts overrides
                    if (typeof uaOpts === 'object') {
                        opts = that.mergeOptions(opts, uaOpts);
                    }

                    sendData.push(opts);

                    ua.apply(ua, sendData);

                    that.logUAAction('Event', sendData);
                }, {
                    error: function(err) {
                        that.uaEdap.error(err);
                    }
                });
            }

            return new Doneable(function(done) {
                that.checkUaHitFields('event', {
                    category: category,
                    action: action
                });

                that.callWithTracker(function(tracker) {
                    sendUaEvent(tracker).then(done);
                });
            }, {
                error: function(err) {
                    that.uaEdap.error(err);
                }
            });
        };


        /**
         *  Sends a UA Pageview
         *
         *  @example
         *    var sendPageviewDoneable = ua.sendPageview(window.analyticsdatalayer, opts);
         *
         *  @param {Object} [adlData] - ADL data to be used to fill the Custom Dimensions
         *  @param {Object} [uaOpts] - UA options that can be set when when sending a pageview
         *  @param {Object} [configOpts] - config options for how to send the pageview
         *         skipGlobalExtractDimensions - true if we should not call the global "set" for Custom Dimensions
         *                                       Dimensions will still be evaluated based on adlData for this hit,
         *                                       which is useful for in-page VPVs.
         *         pagetypeOverride            - String to override "pagetype" with
         *         pageurlOverride             - URL to override "pageurl" (and the resulting pageview's "page" value) with
         *  @returns {Doneable} - Doneable object that will be resolve()'d when hitCallback is triggered
         */
        this.sendPageview = function(adlData, uaOpts, configOpts) {
            var that = this;

            return new Doneable(function(done) {
                that.callWithTracker(function(tracker) {
                    var sendData = [
                            that.buildUaFunctionName('send'),
                            'pageview'
                        ],
                        ua = that.getUA(),
                        defaultOpts = {
                            'hitCallback': function() {
                                done();
                            }
                        },
                        opts = defaultOpts,
                        adl,
                        dimensions,
                        pageUrl;

                    configOpts = configOpts || {};

                    // Set the ADL variable for this pageview
                    adlData = adlData || that.globalADL.get();

                    // clone so we can modify without changing the data object that gets passed to other EDAP listeners
                    adlData = edapHelpers.clone(adlData);
                    adl = new ADL(adlData);

                    if (configOpts.pagetypeOverride) {
                        adl.set('pagetype', configOpts.pagetypeOverride);
                    }

                    if (configOpts.pageurlOverride) {
                        adl.set('pageurl', configOpts.pageurlOverride);
                    }

                    pageUrl = that.getPageUrl(adl);

                    sendData.push(pageUrl);

                    // Setup the Custom Dimensions - put them into opts if option is set, otherwise "set" them by default
                    dimensions = that.buildCustomDimensions(adl, tracker, {
                        // on real pageview (not VPVs) log an error if we have to truncate any dimensions
                        shouldLogTruncation: !configOpts.skipGlobalExtractDimensions
                    });
                    if (configOpts.skipGlobalExtractDimensions) {
                        opts = that.mergeOptions(opts, dimensions);
                    } else {
                        that.setUADimensions(dimensions);
                    }

                    if (typeof uaOpts === 'object') {
                        opts = that.mergeOptions(opts, uaOpts);
                    }

                    sendData.push(opts);

                    // Send the pageview
                    ua.apply(ua, sendData);

                    // Add a debug log
                    that.logUAAction('Pageview', sendData);
                });
            }, {
                error: function(err) {
                    that.uaEdap.error(err);
                }
            });
        };


        /**
         * DRY function to build interaction VPV pagetype in cases where there isn't preexisting special logic (such as "booking")
         *
         * @param  {String} pagetype The original pagetype of the page
         * @return {String}          The pagetype to be used on an interaction VPV
         */
        this.buildInteractionVpvPagetype = function(pagetype) {
            return pagetype + ' (vpv)';
        };


        /**
         * Thin wrapper for sendPageview that sets options for in-page interaction VPVs
         *
         * @param  {Object} [data] - The ADL data to be used for filling in custom dimensions
         * @param  {Object} [vpvUrl] - The url to send for this interaction pageview
         * @param  {Object} [vpvPagetype] - The pagetype to override for this interaction pageview
         * @param  {Object} [uaOpts] - UA options that can be set for a pageview (e.g. dimensions, hitCallback, etc.)
         * @return {Doneable} - Doneable returned from sendPageview() - will be resolve()'d when the pageview's hitCallback is triggered
         */
        this.sendInteractionPageview = function(data, vpvUrl, vpvPagetype, uaOpts) {
            return this.sendPageview(
                data,
                uaOpts,
                {
                    pageurlOverride: vpvUrl,
                    pagetypeOverride: vpvPagetype,
                    skipGlobalExtractDimensions: true
                }
            );
        };


        /**
         *  Sends a UA Timing event
         *
         *  @example
         *    var sendTimingDoneable = ua.sendTiming('myCategory', 'timingName', 100, 'myLabel', opts);
         *
         *  @param {String} [category] - category to send for this event
         *  @param {String} [name] - action to send for this event
         *  @param {Number} [value] - time in ms for this event
         *  @param {String} [label] - label to send for this event
         *  @param {Object} [opts] - UA options that can be set when when sending an event
         *  @param {Object} [adlData] - data for Custom Dimensions
         *  @param {Object} [configOpts] - config options for how to send the event
         *         skipExtractDimensions - true if we should *not* re-evalutate Custom Dimensions for this timing event
         *  @returns {Doneable} - Doneable object that will be resolve()'d when hitCallback is triggered
         */
        this.sendTiming = function(category, name, value, label, opts, adlData, configOpts) {
            var that = this;

            return new Doneable(function(done) {
                that.checkUaHitFields('timing', {
                    category: category,
                    name: name,
                    value: value
                });

                that.callWithTracker(function(tracker) {
                    var sendData = [
                            that.buildUaFunctionName('send'),
                            'timing',
                            category,
                            name,
                            value,
                            label
                        ],
                        ua = that.getUA(),
                        defaultOpts = {
                            'nonInteraction': true,
                            'hitCallback': function() {
                                done();
                            }
                        };

                    if (typeof opts !== 'object') {
                        opts = defaultOpts;
                    } else {
                        opts = that.mergeOptions(defaultOpts, opts);
                    }

                    opts = that.setDimensionsInOpts(adlData, opts, configOpts, tracker);

                    sendData.push(opts);

                    ua.apply(ua, sendData);

                    that.logUAAction('Timing', sendData);
                });
            }, {
                error: function(err) {
                    that.uaEdap.error(err);
                }
            });
        };


        /**
         *  Sends a UA Social event
         *
         *  @example
         *    var sendSocialDoneable = ua.sendSocial('facebook', 'like', 'myTarget', opts);
         *
         *  @param {String} [network] - social network to send for this event
         *  @param {String} [action] - action to send for this event
         *  @param {String} [target] - target to send for this event
         *  @param {Object} [opts] - UA options that can be set when when sending an event
         *  @returns {Doneable} - Doneable object that will be resolve()'d when hitCallback is triggered
         */
        this.sendSocial = function(network, action, target, opts) {
            var that = this;

            return new Doneable(function(done) {
                var sendData = [
                        that.buildUaFunctionName('send'),
                        'social',
                        network,
                        action,
                        target
                    ],
                    ua = that.getUA(),
                    defaultOpts = {
                        'nonInteraction': true,
                        'hitCallback': function() {
                            done();
                        }
                    };

                if (typeof opts !== 'object') {
                    sendData.push(defaultOpts);
                } else {
                    sendData.push(that.mergeOptions(defaultOpts, opts));
                }

                ua.apply(ua, sendData);

                that.logUAAction('Social', sendData);
            }, {
                error: function(err) {
                    that.uaEdap.error(err);
                }
            });
        };


        /**
         *  Sends a UA Exception event
         *
         *  @example
         *    var sendExceptionDoneable = ua.sendException(description, isFatal, opts);
         *
         *  @param {String} [description] - description of exception
         *  @param {Boolean} [isFatal] - if the exception was a fatal error
         *  @param {Object} [opts] - UA options that can be set when when sending an event
         *  @returns {Doneable} - Doneable object that will be resolve()'d when hitCallback is triggered
         */
        this.sendException = function(description, isFatal, opts) {
            var that = this;

            return new Doneable(function(done) {
                var sendData = [
                        that.buildUaFunctionName('send'),
                        'exception'
                    ],
                    ua = that.getUA(),
                    defaultOpts = {
                        'exDescription': description,
                        'exFatal': !!isFatal,
                        'nonInteraction': true,
                        'hitCallback': function() {
                            done();
                        }
                    };

                if (typeof opts !== 'object') {
                    sendData.push(defaultOpts);
                } else {
                    sendData.push(that.mergeOptions(defaultOpts, opts));
                }

                ua.apply(ua, sendData);

                that.logUAAction('Exception', sendData);
            }, {
                error: function(err) {
                    that.uaEdap.error(err);
                }
            });
        };


        /**
         *  Adds a UA Ecommerce Transaction
         *
         *  @example
         *      ua.addEcommTransaction('12345', 'Homeaway', '123.33', '33.00', '1.23');
         *
         *  @param {String} [id] - ID of the Ecommerce transaction
         *  @param {String} [affiliation] - What this Ecommerce transaction is affilated with
         *  @param {String} [total] - Total price including shippig and tax
         *  @param {String} [shipping] - Shipping cost for this transaction
         *  @param {String} [tax] - Taxes for this transaction
         */
        this.addEcommTransaction = function(id, affiliation, total, shipping, tax) {
            var ua = this.getUA(),
                transData = {
                    id: id,
                    affiliation: (affiliation || undefined),
                    revenue: (total || undefined),
                    shipping: (shipping || undefined),
                    tax: (tax || undefined)
                };

            ua(this.buildUaFunctionName('ecommerce:addTransaction'), transData);

            this.logUAAction('Ecomm:addTransaction', transData);
        };


        /**
         *  Adds a UA Ecommerce Item
         *
         *  @example
         *      ua.addEcommItem('12345', 'PDP', 'PDP_2', 'VAS', '123.33', '1');
         *
         *  @param {String} [id] - ID of the Ecommerce transaction
         *  @param {String} [name] - Name of the item being added
         *  @param {String} [sku] - SKU of the item being added
         *  @param {String} [category] - Category of the item being added
         *  @param {String} [price] - Price per unit of the item being added
         *  @param {String} [quantity] - Quantity of items
         */
        this.addEcommItem = function(id, name, sku, category, price, quantity) {
            var ua = this.getUA(),
                itemData = {
                    id: id,
                    name: name,
                    sku: (sku || undefined),
                    category: (category || undefined),
                    price: (price || undefined),
                    quantity: (quantity || undefined)
                };

            ua(this.buildUaFunctionName('ecommerce:addItem'), itemData);

            this.logUAAction('Ecomm:addItem', itemData);
        };

        /**
         *  Clears ecommerce cart
         *
         *  @example
         *    ua.clearEcommCart();
         */
        this.clearEcommCart = function() {
            var ua = this.getUA();

            ua(this.buildUaFunctionName('ecommerce:clear'));

            this.logUAAction('Ecomm:clearCart');
        };

        /**
         *  Sends a UA Ecommerce transaction
         *
         *  Note: There is a business logic interface function defined in ecomm.js
         *
         *  @example
         *      ua.sendEcomm();
         *
         *  @param {Object} [opts] - UA options that can be set when when sending an event
         *  @returns {Doneable} - Doneable object that will be resolve()'d when hitCallback is triggered
         */
        this.sendEcomm = function(opts) {
            var that = this;

            return new Doneable(function(done) {
                var sendData = [that.buildUaFunctionName('ecommerce:send')],
                    ua = that.getUA(),
                    defaultOpts = {
                        'nonInteraction': true,
                        'hitCallback': function() {
                            done();
                        }
                    };

                if (typeof opts !== 'object') {
                    sendData.push(defaultOpts);
                } else {
                    sendData.push(that.mergeOptions(defaultOpts, opts));
                }

                ua.apply(ua, sendData);

                that.logUAAction('Ecomm:Send', sendData);
            }, {
                error: function(err) {
                    that.uaEdap.error(err);
                }
            });
        };


        /**
         *  Gets the UA profile data for a site based on the href of the page
         *
         *  @example
         *      var profileData = ua.getUAProfileData();
         *
         *  @returns {Array} - in the format: [UA ProfileId, Cookie Domain, Cookie Path, Profile Regex, Profile Regex Weight]
         */
        this.getUAProfileData = function() {
            var config = this.getConfig(),
                adl = new ADL(),
                appName = adl.get('appname'),
                luxuryParentMonikers = {
                    luxury_us: 'homeaway_us',
                    luxury_uk: 'homeaway_uk',
                    luxury_de: 'homeaway_de'
                },
                profileName,
                profileData,
                errStr;

            // If they have set the ADL.analyticsbrand then we should honor it, if it is valid
            if (adl.isSet('analyticsbrand') && config.supportedSites[adl.get('analyticsbrand')]) {
                profileName = adl.get('analyticsbrand');
            }

            // We special case this since we can't use the url to determine the profile name
            if (appName === 'ums-cas') {
                // if ADL.analyticsbrand was set
                if (profileName === undefined) {
                    profileName = adl.get('monikerbrand');
                }

                // if we're on a luxury site, use the parent site's monikerbrand instead
                if (luxuryParentMonikers[profileName]) {
                    profileName = luxuryParentMonikers[profileName];
                }

                profileData = config.supportedSites[profileName];

                if (profileData !== undefined) {
                    // Override some of the data for CAS
                    profileData[1] = domHelpers.getHostname();
                    profileData[2] = '/';
                } else {
                    profileName = '';
                }

            // All other brands we should extract the profilename based on the href
            } else {
                // if ADL.analyticsbrand was set
                if (profileName === undefined) {
                    profileName = this.getMonikerBrandByHref(domHelpers.getHref());
                }

                profileData = config.supportedSites[profileName];

                // Sometimes we need to set the cookie domain at runtime (ex. expedia-stage.homeaway.com)
                if (profileData instanceof Array && profileData[1] === null) {
                    profileData[1] = domHelpers.getHostname();
                }
            }

            if (profileName === '') {
                errStr = 'UA init: Cannot find matching profile name';
                this.uaEdap.error(errStr);

                return null;
            }

            return profileData;
        };


        /**
         *  Builds the standardized Regex and Regex Weight used in getMonikerBrandByHref()
         *
         *  @example
         *      var siteRegexInfo = ua.buildSiteRegex(['UA-123', 'homeaway.com', '/', null, null]);
         *
         *  @param {Array} [siteData] - in the format: [UA ProfileId, Cookie Domain, Cookie Path, Profile Regex, Profile Regex Weight]
         *  @returns {Object} - in the format: [profileRegExp, profileWeight] or null
         */
        this.buildSiteRegex = function(siteData) {
            var COOKIE_DOMAIN_IDX = 1,
                PROFILE_REGEX_IDX = 3,
                PROFILE_REGEX_WEIGHT_IDX = 4,
                PROFILE_SKIP = 5,
                profileRegExpStr,
                profileRegExp,
                profileWeight,
                domainParts,
                errStr;

            if (!(siteData instanceof Array)) {
                errStr = 'UA buildSiteRegex is expecting an array';
                this.uaEdap.error(errStr);
                return null;
            }

            // If this profile is marked as a skip then we can't build a regex and we should just return null.
            if (siteData[PROFILE_SKIP]) {
                return null;
            }

            if (siteData[PROFILE_REGEX_IDX] === null) {
                if (siteData[COOKIE_DOMAIN_IDX] !== null) {
                    profileRegExpStr = siteData[COOKIE_DOMAIN_IDX];
                    profileRegExpStr = profileRegExpStr.replace(/[.]/gi, '[.]');
                    profileRegExp = new RegExp('^https?:[/][/]([^/]+[.])?' + profileRegExpStr + '(:\\d+)?([/].*$|$)');

                // If we don't have a domain and a regex then we can't build the Regex
                } else {
                    errStr = 'UA buildSiteRegex: cannot build regex since domain and regex are null';
                    this.uaEdap.error(errStr);
                    return null;
                }
            } else {
                profileRegExp = siteData[PROFILE_REGEX_IDX];
            }

            if (siteData[PROFILE_REGEX_WEIGHT_IDX] === null) {
                domainParts = siteData[COOKIE_DOMAIN_IDX].split('.');
                profileWeight = domainParts.length;
            } else {
                profileWeight = siteData[PROFILE_REGEX_WEIGHT_IDX];
            }

            return [profileRegExp, profileWeight];
        };


        /**
         *  Gets the moniker_brand-esque value from the href
         *
         *  @example
         *      var analyticsBrand = ua.getMonikerBrandByHref();
         *
         *  @param {String} [href] - The href to be used to determine the analytics brand
         *  @returns {String} - analytics brand string based on the href
         */
        this.getMonikerBrandByHref = function(href) {
            var sites = this.getConfig().supportedSites,
                matchedSite = '',
                matchedSiteWeight = 0,
                i,
                siteRegexData,
                errStr;

            for (i in sites) {
                /* istanbul ignore else  */
                if (sites.hasOwnProperty(i)) {
                    siteRegexData = this.buildSiteRegex(sites[i]);

                    if (siteRegexData !== null && href.match(siteRegexData[0]) !== null) {
                        if (siteRegexData[1] > matchedSiteWeight) {
                            matchedSiteWeight = siteRegexData[1];
                            matchedSite = i;
                        } else if (siteRegexData[1] === matchedSiteWeight) {
                            errStr = 'UA getMonikerBrandByHref: ' + href + ' matched ' + matchedSite + ' and ' + i;
                            this.uaEdap.error(errStr);
                            return '';
                        }
                    }
                }
            }

            return matchedSite;
        };


        /**
         * Get the appropriate 'page' value for a UA hit
         *
         * @param  {ADLHelpers} [adl] - ADLHelpers instance to be used to determine 'page' URL
         * @return {String} - The 'page' URL for the hit or null if there should be no override
         */
        this.getPageUrl = function(adl) {
            var that = this,
                config = that.getConfig(),
                pageUrl = null,
                pagename;

            // Extract/Normalize the pagename
            pagename = adl.get('pagename');
            if (typeof pagename === 'string') {
                pagename = pagename.toLowerCase();
            }

            // Setting the pageview URL in order of preference:
            //  1. ADL.pageurl
            //  2. VPV based on pagename
            //  3. domHelpers.getPage() - the path and query string of document.location
            if (adl.isSet('pageurl')) {
                pageUrl = that.vpvizePath(adl.get('pageurl'));
            } else if (pagename && config.pagenameToVPV.hasOwnProperty(pagename)) {
                pageUrl = that.vpvizePath(config.pagenameToVPV[pagename]);
            } else {
                pageUrl = domHelpers.getPage();
            }

            return pageUrl;
        };


        /**
         *  VPV-izes a path url... aka, adds a VPV prefix to all VPV paths
         *
         *  @example
         *    var vpvpath = ua.vpvizePath('/gd/rm/messages');
         *
         *  @param {String} [path] - Pathname to prepend the VPV prefix
         *  @returns {Object} - The VPV-ized pathname or null
         */
        this.vpvizePath = function(path) {
            var vpvPrefix = '/vpv',
                ret = path;

            if (typeof path === 'string') {
                if (path.indexOf(vpvPrefix + '/') === 0) {
                    ret = path;
                } else if (path.indexOf('/') === 0) {
                    ret = vpvPrefix + path;
                } else {
                    ret = vpvPrefix + '/' + path;
                }

                return ret;
            }

            return null;
        };


        /**
         *  Sets the global UA Custom Dimensions
         *
         *  @example
         *      ua.buildCustomDimensions(window.analyticsdatalayer);
         *
         *  @param {ADLHelpers} [adl] - ADLHelpers instance to be used to set the Custom Dimensions
         *  @param {Object} [tracker] - UA tracker object
         *  @param {Object} [opts]    - Options for building CDs
         *         shouldLogTruncation - true if we should log an error for truncated dimension values
         *  @returns {Object} - Key:Value pairs of the format {dimensionX: valueX, dimensionY, valueY, ...}
         */
        this.buildCustomDimensions = function(adl, tracker, opts) {
            var that = this,
                conf = that.getConfig(),
                dex = conf.dimensionExtractors,
                truncatedDimensions = [], // will push objects with dimension name, original value, and truncated value
                retDims = {},
                dim,
                value;

            function setDim(dimensionNum, dimensionVal) {
                var dimensionName = that.determineDimName(dimensionNum),
                    val = that.truncateDimensionByUTF8Bytes(dimensionVal, conf.maxDimensionBytes);

                if (val !== dimensionVal) {
                    truncatedDimensions.push({
                        dimName: dimensionName,
                        originalValue: dimensionVal,
                        truncatedValue: val
                    });
                }

                retDims[dimensionName] = val;
            }

            opts = opts || {};

            if (!(adl instanceof ADL)) {
                that.uaEdap.error('buildCustomDimensions: called without ADL instance');
                return retDims;
            }

            if (typeof tracker !== 'object') {
                that.uaEdap.error('buildCustomDimensions: called without tracker');
                return retDims;
            }

            for (dim in dex) {
                /* istanbul ignore else  */
                if (dex.hasOwnProperty(dim)) {
                    value = that.getDimensionValue(dim, adl, tracker);

                    if (adl.shouldSet(value)) {
                        setDim(dim, value);
                    }
                }
            }

            // Assign the Proctor Test data to the correct Dimension
            // dim is of the format [CD # to use, ADL.proctor string]
            dim = this.extractors.getProctorDimension(adl);
            if (adl.shouldSet(dim[1])) {
                setDim(dim[0], dim[1]);
            }

            if (opts.shouldLogTruncation) {
                that.logTruncationErrors(truncatedDimensions);
            }

            return retDims;
        };


        /**
         * Use the dimension extractor to get the value for a given dimension
         *
         * @param  {Number}     dimNum  The dimension to determine the value for
         * @param  {ADLHelpers} [adl]   ADLHelpers instance to be used to set the Custom Dimensions
         * @param  {Object} [tracker]   UA tracker object
         * @return {String}             The value for the passed dimesnion slot
         */
        this.getDimensionValue = function(dimNum, adl, tracker) {
            var conf = this.getConfig(),
                dex = conf.dimensionExtractors,
                ext = dex[dimNum],
                extType = typeof ext,
                ret;

            if (dex.hasOwnProperty(dimNum)) {
                if (extType === 'string') {
                    ret = adl.get(ext);
                } else if (extType === 'function') {
                    ret = ext.apply(this, [adl, this, tracker]);

                // log an EDAP error, but don't throw a real error so that *some* data may get sent
                } else {
                    this.uaEdap.error('getDimensionValue: unexpected type "' + extType + '" for dimension ' + dimNum);
                }
            } else {
                this.uaEdap.error('getDimensionValue: attempted to lookup a dimension not present in the UA config');
            }

            if (ret !== null && ret !== undefined && typeof ret.toString === 'function') {
                ret = ret.toString();
            }

            return ret;
        };

        /**
         * Checks to see if this is an existing or new user based on existence of
         * the UA ("_ga") cookie and does the following:
         *     - sets property 'isNewUser' in the UA scope data
         *     - returns the whether this is a new user
         *
         * @return {Boolean} true if new user (no cookie), false otherwise
         */
        this.checkIfNewUser = function() {
            var config = this.getConfig(),
                uaCookieName = config.uaCookieName,
                uaScopeNamespace = config.edapScopeName,
                uaCookie = domHelpers.getCookie(uaCookieName),
                scopeData = edap.getScopeData(uaScopeNamespace);

            scopeData.isNewUser = (uaCookie === null);

            return scopeData.isNewUser;
        };

        /**
         *  Initializes the UA interface wrapper
         *
         *  @example
         *      ua.init();
         *
         *  @return {Boolean} - true if UA was successfully initted, false otherwise
         */
        this.init = function() {
            var uaScope = edap.getScopeInfo()[this.getConfig().edapScopeName],
                config = this.getConfig(),
                uaInitData = {},
                retVal = false,
                clientId,
                profileData,
                ua;

            if (uaScope) {
                // Store the UA EDAP scope
                this.uaEdap = uaScope.instance;
            } else {
                edap.error('Could not find UA EDAP Scope... aborting UA init()');
                return retVal;
            }

            profileData = this.getUAProfileData();

            // If we can't find the profile then we don't init UA
            if (profileData === null) {
                // no need to log this error since getUAProfileData() already did
                return retVal;
            }

            // If the profile is for local development, don't init UA
            if (profileData[0] === 'DEV') {
                return retVal;
            }

            // Add the analytics.js script and setup the 'ua' namespace
            this.dropScript();

            // Have to initialize AFTER dropScript() since it does the globals setup
            ua = this.getUA();

            if (!ua) {
                this.uaEdap.error('Cannot init UA: Unable to get UA instance');
                return retVal;
            }
            retVal = true;

            // Pull the cross domain query param and try to parse it as a UA cookie in order to set the clientID
            // for cross-domain tracking of user and sessions.
            clientId = this.parseClientIdFromUACookie(domHelpers.getSearchParam(config.uaCrossDomainParam));

            // Setup the UA instance data
            uaInitData = {
                'cookieDomain': profileData[1],
                'cookiePath': profileData[2]
            };

            // If we have were passed a clientId then we need to assign it as the UA clientId
            if (typeof clientId === 'string') {
                uaInitData.clientId = clientId;
            }

            // If the page has a publicUUID then we set it as the UA userid for cross device tracking
            // NOTE: This relies on the ADL.publicuuid being set in the source by the server. If an app dynamically sets this there is a potential for a race condition.
            if (this.globalADL.isSet('publicuuid')) {
                uaInitData.userId = this.globalADL.get('publicuuid');
            }

            uaInitData.name = config.uaTrackerName;

            uaInitData.trackingId = profileData[0];

            // Create the UA tracker
            ua('create', uaInitData);

            this.setUAParam('transport', 'beacon');

            // Enable GDN Display Features tracking
            this.loadPlugin('displayfeatures');

            return retVal;
        };
    }

    return new UA();
});

define('ua/ecomm',['ua/ua-wrapper'], function(ua) {
    'use strict';

    var hasLoadedUAEcommPlugin = false,
        retObj = {};

    function checkRequredValues(data) {
        var requiredFields = [
                'productid',
                'productname',
                'productcategory',
                'productquantity',
                'productprice',
                // 'ordertax', not strictly required since we default to 0
                'ordertotal',
                'orderid',
                'paymentmethod'],
            i,
            val;

        for (i = 0; i < requiredFields.length; i++) {
            val = data[requiredFields[i]];

            if (val === undefined || val === null) {
                return false;
            }
        }

        return true;
    }

    function checkArraysEqualLength() {
        var arrs = arguments,
            i,
            len;

        // this is safe since this is a private function
        len = arrs[0].length;

        for (i = 0; i < arrs.length; i++) {
            if (arrs[i].length !== len) {
                return false;
            }
        }

        return true;
    }

    function loadPlugin() {
        if (!retObj.uaEcommPluginLoaded()) {
            ua.loadPlugin('ecommerce');
            hasLoadedUAEcommPlugin = true;
        }
    }

    retObj.trackEcommerce = function trackEcommerce(data) {
        var splitRegex = /[,;]/,
            productids,
            productnames,
            productcategories,
            productquantities,
            productprices,
            ordertax,
            ordertotal,
            orderid,
            paymentmethod,
            i;

        data = data || {};

        // set orderid if it is missing but another recognized value is present
        if (!data.orderid || data.orderid === '-1') {
            data.orderid = data.reservationid || data.bookingid;
        }

        // check required values
        if (!checkRequredValues(data)) {
            return null;
        }

        // now that we are good to fill in vars, do it
        productids = data.productid.split(splitRegex);
        productnames = data.productname.split(splitRegex);
        productcategories = data.productcategory.split(splitRegex);
        productquantities = data.productquantity.split(splitRegex);
        productprices = data.productprice.split(splitRegex);
        ordertax = typeof data.ordertax !== 'undefined' ? data.ordertax : 0;
        ordertotal = data.ordertotal;
        orderid = data.orderid;
        paymentmethod = data.paymentmethod;

        // check that arrays are all same length
        if (!checkArraysEqualLength(productids,
                productnames,
                productcategories,
                productquantities,
                productprices)) {
            return null;
        }

        loadPlugin();

        // make sure we start with a clean slate
        ua.clearEcommCart();

        ua.addEcommTransaction(orderid, paymentmethod, ordertotal, undefined, ordertax);

        for (i = 0; i < productids.length; i++) {
            ua.addEcommItem(orderid, productnames[i], productids[i],
                productcategories[i], productprices[i], productquantities[i]);
        }

        // returns a Doneable so pass that through
        return ua.sendEcomm();
    };

    retObj.uaEcommPluginLoaded = function uaEcommPluginLoaded() {
        return hasLoadedUAEcommPlugin;
    };

    return retObj;
});

define('ua/listeners/cart',[
    'ua/ua-wrapper',
    'ua/ecomm',
    'ua/ua-config',
    'doneable',
    'adlhelpers'
], function(ua, ecomm, config, Doneable, ADL) {
    'use strict';

    /**
     * EVENTS:
     *  owner.registration.submit
     *  cart.signup.submit
     *  cart.newsubscription.submit
     *  cart.addto.submit
     *  cart.renew.submit
     *  cart.specialoffer.submit
     *
     */
    function setupListeners(edap) {
        var confStr = 'confirm';

        edap.on('owner.registration.submit', function(data, setAsync, done) {
            var vpv = config.staticVPVs['owner registration'],
                opts = {},
                adl = new ADL(data);

            setAsync();

            // custom metric 11
            opts[ua.metricName(11)] = 1;

            Doneable.all([
                ua.sendInteractionPageview(
                    data,
                    vpv,
                    ua.buildInteractionVpvPagetype(data.pagetype)
                ),
                ua.sendEvent(
                    'registration',
                    'owner registration',
                    adl.getPublicUUID(),
                    undefined,
                    opts,
                    data
                )
            ]).then(done);
        });

        edap.on('cart.signup.submit', function(data, setAsync, done) {
            var opts = {};

            setAsync();

            // custom metric 12
            opts[ua.metricName(12)] = 1;

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'signup cart',
                    confStr,
                    data.orderid,
                    undefined,
                    opts,
                    data
                )
            ]).then(done);
        });

        edap.on('cart.newsubscription.submit', function(data, setAsync, done) {
            var opts = {};

            setAsync();

            // custom metric 12
            opts[ua.metricName(12)] = 1;

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'newproperty cart',
                    confStr,
                    data.orderid,
                    undefined,
                    opts,
                    data
                )
            ]).then(done);
        });

        edap.on('cart.addto.submit', function(data, setAsync, done) {
            setAsync();

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'addto cart',
                    confStr,
                    data.orderid,
                    undefined,
                    undefined,
                    data
                )
            ]).then(done);
        });

        edap.on('cart.renew.submit', function(data, setAsync, done) {
            setAsync();

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'renewal cart',
                    confStr,
                    data.orderid,
                    undefined,
                    undefined,
                    data
                )
            ]).then(done);
        });

        edap.on('cart.specialoffer.submit', function(data, setAsync, done) {
            setAsync();

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'specialoffer cart',
                    confStr,
                    data.orderid,
                    undefined,
                    undefined,
                    data
                )
            ]).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/flsp',['ua/ua-wrapper'], function(ua) {
    'use strict';

    /**
     * EVENTS:
     *  featuredlisting.click
     *  similarproperty.click
     *
     */
    function setupListeners(edap) {
        edap.on('featuredlisting.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'merchandising',
                'featured listing',
                data.eventlistingids,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('similarproperty.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'merchandising',
                'similar property',
                data.eventlistingids,
                undefined,
                undefined,
                data
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/identity',[
    'ua/ua-wrapper',
    'adlhelpers'
], function(ua, ADL) {
    'use strict';

    /*
     * EVENTS:
     *
     * user.account.created
     * login.attempt
     * login.success
     * login.failure
     *
     */
    function setupListeners(edap) {
        var loginStr = 'login';

        function loginEventCallback(data, setAsync, done) {
            var adl = new ADL(data),
                defaultStr = '-1',
                logintype = adl.get('logintype') || defaultStr,
                loginsource = adl.get('loginsource') || defaultStr;

            setAsync();

            ua.sendEvent(
                loginStr,
                adl.get('edapeventname').replace('.', ' '),
                logintype + ':' + loginsource,
                undefined,
                undefined,
                data
            ).then(done);
        }

        edap.on('user.account.created', function(data, setAsync, done) {
            var adl = new ADL(data),
                unknownStr = 'unknown',
                defaultStr = 'default',
                userType = adl.isSetGet('newusertype') || unknownStr,
                stubOrFullVals = {
                    true: 'stub account',
                    false: 'full account',
                    default: unknownStr
                },
                marketingOptOutVals = {
                    true: 'remarketing opt-out',
                    false: 'no remarketing opt-out',
                    default: 'remarketing opt-out not presented'
                },
                stubOrFull,
                marketingOptOut;

            stubOrFull = stubOrFullVals[(adl.isSetGet('stubaccount') || defaultStr)];
            marketingOptOut = marketingOptOutVals[(adl.isSetGet('marketingoptout') || defaultStr)];

            if (userType === unknownStr) {
                edap.error('\'user.account.created\' triggered without \'newusertype\' property set');
            }

            setAsync();

            ua.sendEvent(
                'account creation',
                userType,
                [stubOrFull, marketingOptOut].join(':'),
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('login.attempt', loginEventCallback);

        edap.on('login.success', loginEventCallback);

        edap.on('login.failure', loginEventCallback);
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/partner-conversion',[
    'ua/ua-wrapper',
    'adlhelpers'
], function(ua, ADL) {
    'use strict';

    /*
     * EVENTS:
     *
     * user.account.created
     * listing.onboarding.started
     * listing.onboarding.submit
     * owner.lyp.click
     *
     */
    function setupListeners(edap) {
        var unknownStr = 'unknown';

        edap.on('listing.onboarding.started', function(data, setAsync, done) {
            var adl = new ADL(data),
                newSupplierVals = {
                    true: 'new supplier',
                    false: 'existing supplier',
                    default: unknownStr
                },
                newSupplier;

            newSupplier = newSupplierVals[(adl.isSetGet('newsupplier') || 'default')];

            if (newSupplier === unknownStr) {
                edap.error('\'listing.onboarding.started\' triggered without \'newsupplier\' property set');
            }

            setAsync();

            ua.sendEvent(
                'supplier onboarding',
                'started',
                newSupplier,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('listing.onboarding.submit', function(data, setAsync, done) {
            var adl = new ADL(data),
                newSupplierVals = {
                    true: 'new supplier',
                    false: 'existing supplier',
                    default: unknownStr
                },
                newSupplier;

            newSupplier = newSupplierVals[(adl.isSetGet('newsupplier') || 'default')];

            if (newSupplier === unknownStr) {
                edap.error('\'listing.onboarding.submit\' triggered without \'newsupplier\' property set');
            }

            setAsync();

            ua.sendEvent(
                'supplier onboarding completion',
                newSupplier,
                undefined,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('owner.lyp.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'supplier onboarding',
                'lyp module clicked',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/ppb',['ua/ua-wrapper'], function(ua) {
    'use strict';

    /**
     * EVENTS:
     *  ppb.signup.submit
     *  ppb.newproperty.submit
     *  ppb.renewal.submit
     *
     */
    function setupListeners(edap) {
        var category = 'ppb',
            label = 'completion';

        edap.on('ppb.signup.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'signup',
                label,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('ppb.newproperty.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'new property',
                label,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('ppb.renewal.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'renewal',
                label,
                undefined,
                undefined,
                data
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/quote',[
    'ua/ua-wrapper',
    'ua/ua-config',
    'adlhelpers',
    'domhelpers',
    'edaphelpers'
], function(ua, config, ADL, domHelpers, edapHelpers) {
    'use strict';

    /**
     * EVENTS:
     *  quote.attempt
     *  quote.success
     *  quote.failure
     *
     */
    function setupListeners(edap) {
        function trackQuote(data, quoteType, done) {
            // copy data obj since we don't want the following changes affecting other EDAP listeners
            var dataCopy = edapHelpers.clone(data);

            // Override pagetype, pagename, pageurl for all of these on the VPV for historical reasons
            // We do this to make sure only 1 PV has a pagetype='property' for reporting
            if (dataCopy.pagetype === 'property') {
                dataCopy.pagetype = 'booking';
                dataCopy.pagename = 'traveler ' + quoteType;
                dataCopy.pageurl = config.staticVPVs[quoteType];
            } else {
                dataCopy.pagetype = dataCopy.pagetype + ' ' + quoteType;
                dataCopy.pagename = dataCopy.pagename + ' ' + quoteType;
                dataCopy.pageurl = domHelpers.getPage() + '/' + quoteType;
            }

            ua.sendInteractionPageview(dataCopy, dataCopy.pageurl).then(done); // don't need to pass pagetype since we set it above
        }

        edap.on('quote.attempt', function(data, setAsync, done) {
            setAsync();

            trackQuote(data, 'quoteattempt', done);
        });

        edap.on('quote.success', function(data, setAsync, done) {
            setAsync();

            trackQuote(data, 'quotesuccess', done);
        });

        edap.on('quote.failure', function(data, setAsync, done) {
            setAsync();

            trackQuote(data, 'quotefailure', done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/rm',['ua/ua-wrapper', 'adlhelpers'], function(ua, ADL) {
    'use strict';

    /**
     * EVENTS:
     *  conversation.message.send
     *  quote.send
     *  payment.request.submit
     *  payment.refund.submit
     *  reservation.accept.submit
     *  reservation.decline.submit
     *  reservation.cancellation.submit
     *  payment.cancel.submit
     *  payment.resend.submit
     *  calendar.add.submit
     *  calendar.uptodate.submit
     *  reservation.edit.submit
     *  payment.markpaid.submit
     *  claim.damage.click
     *  claim.eclaim.click
     *
     */
    function setupListeners(edap) {
        var category = 'owner activity';

        function getId(data) {
            var adl = new ADL(data),
                retVal,
                reservationid = adl.get('reservationid'),
                inquiryid = adl.get('inquiryid');

            if (adl.shouldSet(reservationid)) {
                retVal = reservationid;
            } else if (adl.shouldSet(inquiryid)) {
                retVal = inquiryid;
            } else {
                retVal = '-1';
            }

            return retVal;
        }

        edap.on('conversation.message.send', function(data, setAsync, done) {
            // don't want to send owner event for traveler dashboard
            // TECHDEBT: this should probably be combined with the handler from traveler-activity.js
            if (data.pagetype === 'ownerdash') {
                setAsync();

                ua.sendEvent(category, 'message sent', getId(data)).then(done);
            }
        });

        edap.on('quote.send', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'send quote', data.inquiryid).then(done);
        });

        edap.on('payment.request.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'attach payment request', data.eventquoteid).then(done);
        });

        edap.on('payment.refund.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'refund payment', data.quotepaymentscheduleid).then(done);
        });

        edap.on('reservation.accept.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'accept booking request', data.reservationid).then(done);
        });

        edap.on('reservation.cancellation.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'cancellation sent',
                undefined,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('reservation.decline.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'decline booking request', data.reservationid).then(done);
        });

        edap.on('payment.cancel.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'cancel payment request', data.quotepaymentscheduleid).then(done);
        });

        edap.on('payment.resend.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'resend payment request', data.quotepaymentscheduleid).then(done);
        });

        edap.on('calendar.add.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'add to calendar', getId(data) + ',' + data.reservationstatus).then(done);
        });

        edap.on('calendar.uptodate.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'calendar up to date').then(done);
        });

        edap.on('reservation.edit.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'edit booking request').then(done);
        });

        edap.on('payment.markpaid.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(category, 'mark as paid').then(done);
        });

        edap.on('payments.onboarding.submit', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            if (data.pagename === 'dash:settings:ownerpayments') {
                ua.sendEvent(category, 'onboard for offline payments', adl.getPublicUUID()).then(done);
            } else {
                done();
            }
        });

        edap.on('claim.damage.click', function(data, setAsync, done) {
            var adl = new ADL(data);

            if (adl.isSet('reservationid')) {
                setAsync();
                ua.sendEvent(category, 'claim damage', adl.get('reservationid')).then(done);
            } else {
                ua.uaEdap.error('claim.damage.click missing reservationid property', data);
            }
        });

        edap.on('claim.eclaim.click', function(data, setAsync, done) {
            var adl = new ADL(data);

            if (adl.isSet('reservationid')) {
                setAsync();
                ua.sendEvent(category, 'csa eclaims', adl.get('reservationid')).then(done);
            } else {
                ua.uaEdap.error('claim.eclaim.click missing reservationid property', data);
            }
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/search',['adlhelpers', 'ua/ua-wrapper'], function(ADL, ua) {
    'use strict';

    /**
     * EVENTS:
     *  search.submit
     *  dated.search.submit
     *  search.hit.click
     *  search.map.property.click
     *  search.map.zoom
     *  search.map.move
     *  typeahead.query
     */
    function setupListeners(edap) {
        edap.on('search.submit', function(data, setAsync, done) {
            var dataAdl = new ADL(data),
                label,
                opts = {};

            setAsync();

            // custom metric 3
            opts[ua.metricName(3)] = 1;

            label = dataAdl.isSetGet('searchterm') || dataAdl.isSetGet('geonode') || dataAdl.isSetGet('keyword');

            ua.sendEvent(
                'search',
                'dateless onsite search',
                label,
                undefined,
                opts,
                data
            ).then(done);
        });

        edap.on('dated.search.submit', function(data, setAsync, done) {
            var dataAdl = new ADL(data),
                label,
                opts = {};

            setAsync();

            // custom metric 5
            opts[ua.metricName(5)] = 1;

            label = dataAdl.isSetGet('searchterm') || dataAdl.isSetGet('geonode') || dataAdl.isSetGet('keyword');

            ua.sendEvent(
                'search',
                'dated onsite search',
                label,
                undefined,
                opts,
                data
            ).then(done);
        });

        edap.on('typeahead.query', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'typeahead',
                'typeahead query',
                data.matchtype,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('search.hit.click', function(data, setAsync, done) {
            var label;

            setAsync();

            label = data.actionlocation + ': ' + data.badges;

            ua.sendEvent(
                'search',
                'search hit click',
                label,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('search.map.property.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'pdp preview',
                'click',
                data.eventlistingids,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('search.map.zoom', function(data, setAsync, done) {
            var label;

            setAsync();

            label = 'zoom ' + (data.zoomtype);

            ua.sendEvent(
                'search',
                'map',
                label,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('search.map.move', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'search',
                'map',
                'move',
                undefined,
                undefined,
                data
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/component-interaction',['adlhelpers', 'ua/ua-wrapper'], function(ADL, ua) {
    'use strict';

    /**
     * EVENTS:
     *  page.module.view
     *  property.click
     *  refinement.click
     *  search.link.click
     *  destination.link.click
     */
    function setupListeners(edap) {
        var category = 'component interaction';

        edap.on('page.module.view', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'module view',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('property.tile.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'property tile click',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('refinement.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'refinement click',
                data.eventrefinements,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('search.link.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'search link click',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('destination.link.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'destination link click',
                [data.eventlbsuuid, data.actionlocation].join(':'),
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('region.link.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'region link click',
                [data.eventlbsuuid, data.actionlocation].join(':'),
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('recentactivity.continue.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'recentactivity continue click',
                data.eventlbsuuid,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('recentactivity.view', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'recentactivity view',
                data.eventsearchterm,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('recentactivity.viewall.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                category,
                'recentactivity viewall click',
                [data.eventrequestmarker, data.actionlocation].join(':'),
                undefined,
                undefined,
                data
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/social',[
    'ua/ua-wrapper',
    'domhelpers',
    'doneable',
    'adlhelpers'
], function(ua, domhelpers, Doneable, ADL) {
    'use strict';

    /**
     * EVENTS:
     *  social.list.reveal
     *  social.facebook.like
     *  social.facebook.share
     *  social.google.plus1
     *  social.pinterest.pin
     *  social.twitter.tweet
     *  social.email.click
     *  social.email.sent
     *
     */
    function setupListeners(edap) {
        var cat = 'social';

        /**
         * Gets the label to use for social events
         *
         * @param  {Object} adl The ADL object for the event's data
         * @return {String}     The event label to use
         */
        function getSocialEventLabel(adl) {
            // for historical reasons the property page gets the listing ID sent
            if (adl.get('pagetype') === 'property') {
                return adl.getListingIds();
            }

            return domhelpers.getHref();
        }

        edap.on('social.list.reveal', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent('traveler activity', 'share clicked', adl.getPublicUUID()).then(done);
        });

        edap.on('social.email.click', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent('traveler activity', 'share email clicked', adl.getPublicUUID()).then(done);
        });

        edap.on('social.email.sent', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent('traveler activity', 'share email sent', adl.getPublicUUID()).then(done);
        });

        edap.on('social.facebook.like', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            if (data.actionstate === 'on') {
                Doneable.all([
                    ua.sendEvent(cat, 'facebook like', getSocialEventLabel(adl)),
                    ua.sendSocial('facebook', 'like', domhelpers.getHref())
                ]).then(done);
            } else if (data.actionstate === 'off') {
                Doneable.all([
                    ua.sendEvent(cat, 'facebook unlike', getSocialEventLabel(adl)),
                    ua.sendSocial('facebook', 'unlike', domhelpers.getHref())
                ]).then(done);
            }
        });

        edap.on('social.facebook.share', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            Doneable.all([
                ua.sendEvent(cat, 'facebook share', getSocialEventLabel(adl)),
                ua.sendSocial('facebook', 'share', domhelpers.getHref())
            ]).then(done);
        });

        edap.on('social.google.plus1', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            Doneable.all([
                ua.sendEvent(cat, 'google plus', getSocialEventLabel(adl)),
                ua.sendSocial('google', 'plus1', domhelpers.getHref())
            ]).then(done);
        });

        edap.on('social.pinterest.pin', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            Doneable.all([
                ua.sendEvent(cat, 'pinterest', getSocialEventLabel(adl)),
                ua.sendSocial('pinterest', 'pin', domhelpers.getHref())
            ]).then(done);
        });

        edap.on('social.twitter.tweet', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            Doneable.all([
                ua.sendEvent(cat, 'tweet', getSocialEventLabel(adl)),
                ua.sendSocial('twitter', 'tweet', domhelpers.getHref())
            ]).then(done);
        });

        edap.on('social.linkedin.share', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            Doneable.all([
                ua.sendEvent(cat, 'linkedin share', getSocialEventLabel(adl)),
                ua.sendSocial('linkedin', 'share', domhelpers.getHref())
            ]).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/software',['ua/ua-wrapper'], function(ua) {
    'use strict';

    /*
     * COREUI-474
     *
     * EVENTS:
     *  software.search.submit
     *  software.provider.click
     */
    function setupListeners(edap) {
        var adl = edap.getDL();

        if (adl.pagetype === 'marketing' && adl.pagename === 'pmsc') {
            edap.on('software.search.submit', function(data) {
                ua.sendEvent('owner activity', 'software search', data.eventlabel || 'undefined');
            });

            edap.on('software.provider.click', function(data) {
                ua.sendEvent('owner activity', 'partner link click', data.eventlabel || 'undefined');
            });
        }
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/traveler-activity',['ua/ua-wrapper', 'ua/ua-config', 'adlhelpers', 'doneable'], function(ua, config, ADL, Doneable) {
    'use strict';

    /**
     * EVENTS:
     *  datepicker.open
     *  datepicker.dates.selected
     *  datepicker.dates.cleared
     *  listing.compare.toggle
     *  listing.compare.submit
     *  listing.favorite.click
     *  listing.favorite.toggle
     *  listing.infotab.click
     *  listing.phone.reveal
     *  favoritelist.create.submit
     *  favoritelist.email.share
     *  review.submit
     *  traveler.review.submit
     *  listing.review.submit
     *  conversation.message.send
     *  reservation.cancellation.request.submit
     *  map.pin.click
     *
     */
    function setupListeners(edap) {
        edap.on('datepicker.open', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'datepicker',
                'open',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('datepicker.dates.selected', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'datepicker',
                'dates change',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('datepicker.dates.cleared', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'datepicker',
                'dates clear',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('listing.compare.toggle', function(data, setAsync, done) {
            setAsync();

            if (data.actionstate === 'on') {
                ua.sendEvent('compare', 'checkbox').then(done);
            } else if (data.actionstate === 'off') {
                ua.sendEvent('compare', 'uncheckbox').then(done);
            }
        });

        edap.on('listing.compare.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent('compare', 'submit').then(done);
        });

        edap.on('listing.favorite.click', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent('favorite', 'favorite clicked', adl.getPublicUUID()).then(done);
        });

        edap.on('listing.favorite.toggle', function(data, setAsync, done) {
            var adl = new ADL(data),
                puuid = adl.getPublicUUID();

            setAsync();

            if (data.actionstate === 'on') {
                ua.sendEvent('favorite', 'favorite created', puuid).then(done);
            } else if (data.actionstate === 'off') {
                ua.sendEvent('favorite', 'favorite removed', puuid).then(done);
            }
        });

        edap.on('hearting.heart', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'hearting',
                'hearted',
                undefined,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('hearting.unheart', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'hearting',
                'unhearted',
                undefined,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('listing.infotab.click', function(data, setAsync, done) {
            var pt = data.pagetype;

            setAsync();

            ua.sendEvent(pt + ' page tabs', data.tabname).then(done);
        });

        edap.on('listing.booknow.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'pdp page',
                'booking button click',
                data.actionlocation,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('listing.phone.reveal', function(data, setAsync, done) {
            var opts = {},
                adl = new ADL(data);

            setAsync();

            // custom metric 9
            opts[ua.metricName(9)] = 1;

            ua.sendEvent(
                'show phone',
                'click to reveal',
                adl.getListingIds(),
                undefined,
                opts
            ).then(done);
        });

        edap.on('favoritelist.create.submit', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent('favorite', 'favorite list created', adl.getPublicUUID()).then(done);
        });

        edap.on('favoritelist.email.share', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent('favorite', 'favorite list shared', adl.getPublicUUID()).then(done);
        });

        // DEPRECATED
        edap.on('review.submit', function(data, setAsync, done) {
            setAsync();

            Doneable.all([
                ua.sendInteractionPageview(
                    data,
                    config.staticVPVs.reviewsubmit,
                    ua.buildInteractionVpvPagetype(data.pagetype)
                ),
                ua.sendEvent(
                    'traveler review',
                    'traveler submitted'
                )
            ]).then(done);
        });

        edap.on('traveler.review.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent('reviews', 'review for traveler submitted').then(done);
        });

        edap.on('listing.review.submit', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent('reviews', 'review for property submitted').then(done);
        });

        edap.on('conversation.message.send', function(data, setAsync, done) {
            // don't want to send traveler event for owner dashboard
            // TECHDEBT: this should probably be combined with the handler from rm.js
            if (data.pagetype === 'travelerdash') {
                setAsync();

                ua.sendEvent('traveler activity', 'inbox message sent').then(done);
            }
        });

        edap.on('reservation.cancellation.request.submit', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            ua.sendEvent(
                'traveler activity',
                'cancellation request sent',
                adl.get('cancellationreason'),
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('map.pin.click', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'traveler activity',
                'map pin clicked',
                data.pintype,
                undefined,
                undefined,
                data
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/traveler-conversion',[
    'ua/ua-wrapper',
    'ua/ecomm',
    'ua/ua-config',
    'doneable',
    'adlhelpers'
], function(ua, ecomm, config, Doneable, ADL) {
    'use strict';

    /**
     * EVENTS:
     *  inquiry.attempt
     *  inquiry.success
     *  reservation.request.submit
     *  payment.submit
     *  vas.submit
     *
     */
    function setupListeners(edap) {
        function getID(data) {
            return data.reservationid || data.bookingid || data.bookingId;
        }

        edap.on('inquiry.attempt', function(data, setAsync, done) {
            var newData = {},
                passedADL = new ADL(data),
                pageADL = new ADL();

            // Only fire the inquiry.success if we are on the inquiry confirmation.
            // Since this is a delayed command we need to check both the page's ADL and the passed ADL data to see
            // if we are on the correct page. This is a special case message that is purpose built to only be fired using
            // delayProcessing it should be safe to look at the page's ADL.
            if (pageADL.get('pagename') === 'inquiry confirmation') {
                setAsync();

                if (passedADL.isSet('eventlistingids')) {
                    newData.eventlistingids = passedADL.get('eventlistingids');
                }

                edap.trigger('inquiry.success', newData).then(done);
            }
        });

        edap.on('inquiry.success', function(data, setAsync, done) {
            var opts = {},
                adl = new ADL(data),
                listingids;

            setAsync();

            if (adl.isSet('eventlistingids')) {
                listingids = adl.get('eventlistingids');
            } else {
                listingids = adl.getListingIds();
            }

            // custom metric 2
            opts[ua.metricName(2)] = 1;

            Doneable.all([
                ua.sendInteractionPageview(
                    data,
                    config.staticVPVs['inquiry confirmation'],
                    ua.buildInteractionVpvPagetype(data.pagetype)
                ),
                ua.sendEvent(
                    'property inquiry',
                    listingids,
                    data.inquiryid,
                    undefined,
                    opts,
                    data
                )
            ]).then(done);
        });

        edap.on('reservation.request.submit', function(data, setAsync, done) {
            var opts = {};

            setAsync();

            // custom metric 8
            opts[ua.metricName(8)] = 1;

            Doneable.all([
                ua.sendInteractionPageview(
                    data,
                    config.staticVPVs['booking confirmation'],
                    ua.buildInteractionVpvPagetype(data.pagetype)
                ),
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'booking',
                    'confirm',
                    getID(data),
                    undefined,
                    opts,
                    data
                )
            ]).then(done);
        });

        edap.on('payment.submit', function(data, setAsync, done) {
            setAsync();

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'traveler payment',
                    'confirm',
                    getID(data),
                    undefined,
                    undefined,
                    data
                )
            ]).then(done);
        });

        edap.on('vas.submit', function(data, setAsync, done) {
            var opts = {};

            setAsync();

            opts[ua.metricName(4)] = 1;

            Doneable.all([
                ecomm.trackEcommerce(data),
                ua.sendEvent(
                    'vas cart',
                    'confirm',
                    undefined,
                    undefined,
                    opts,
                    data
                )
            ]).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/listeners/user',['adlhelpers', 'ua/ua-wrapper'], function(ADL, ua) {
    'use strict';

    /*
     * COREUI-574
     *
     * EVENTS:
     *  user.sms.entered
     *
     */
    function setupListeners(edap) {
        edap.on('user.sms.entered', function(data) {
            var adl = new ADL(data);

            ua.sendEvent('phone', 'sms:enrollment', adl.get('eventlabel'));
        });
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/register-ua-listeners',[
    'ua/listeners/cart',
    'ua/listeners/flsp',
    'ua/listeners/identity',
    'ua/listeners/partner-conversion',
    'ua/listeners/ppb',
    'ua/listeners/quote',
    'ua/listeners/rm',
    'ua/listeners/search',
    'ua/listeners/component-interaction',
    'ua/listeners/social',
    'ua/listeners/software',
    'ua/listeners/traveler-activity',
    'ua/listeners/traveler-conversion',
    'ua/listeners/user'
], function() {
    'use strict';

    var listeners = arguments,
        i;

    function setupListeners(edap, ua) {
        for (i = 0; i < listeners.length; i++) {
            listeners[i].setupListeners(edap, ua);
        }
    }

    return {
        setupListeners: setupListeners
    };
});

define('ua/edap-ua-integration',[
    'edap',
    'ua/ua-config',
    'ua/ua-wrapper',
    'ua/register-ua-listeners'
], function(edap, uaConfig, ua, listeners) {
    'use strict';

    var moduleName = uaConfig.edapScopeName,
        myEdap = new edap.Scope(moduleName);

    function init() {
        var inittedSuccessfully;

        // Before we load the UA script, check if the "_ga" cookie already exists.
        // This allows us to determine if this a user's first hit on the site.
        ua.checkIfNewUser();

        inittedSuccessfully = ua.init();

        // skip registering listeners if we are unable to set up UA successfully
        if (inittedSuccessfully) {
            listeners.setupListeners(myEdap);
        }

        return edap;
    }

    return {
        init: init
    };
});

define('hadoop/hadoop-wrapper',['edap', 'domhelpers', 'doneable'], function(edap, domHelpers, Doneable) {
    'use strict';
    var hadoopInstance;

    function Hadoop() {
        /**
         *  Constant value for a missing required field (matches api-operations-client-logging)
         */
        this.missingDefaultValue = 'NA';

        /**
         *  Beacon-type to url mapping object
         */
        this.urls = {
            'beacon': '/edap/elo/v1/event/beacon',
            'img': '/edap/elo/v1/event/img'
        };

        /**
         * When we're able to use the `fetch` API, determines whether requests should be sent with `keepalive` option set
         * This is updated once the initial burst of requests complete because of capacity limits on `keepalive` requests.
         */
        this.shouldFetchWithKeepalive = false;

        /**
         *  Gets a user's session id
         *  Due to the lack of a unified web session for unauthenticated users this *may* break...
         *
         *  @example
         *    var sid = getHasId();
         *
         *  @returns {String} - Session ID from the associated brand session cookie or this.missingDefaultValue
         */
        this.getHasId = function() {
            var hadoop = this,
                sid = domHelpers.getCookie('has');

            if (sid === null) {
                sid = hadoop.missingDefaultValue;
            }

            return sid;
        };


        /**
         *  Gets a user's visitor id
         *  Due to the lack of a unified web session for unauthenticated users this *may* break...
         *
         *  @example
         *    var sid = getHavId();
         *
         *  @returns {String} - Visitor ID from the associated brand visitor cookie or this.missingDefaultValue
         */
        this.getHavId = function() {
            var hadoop = this,
                vid = domHelpers.getCookie('hav');

            if (vid === null) {
                vid = hadoop.missingDefaultValue;
            }

            return vid;
        };


        /**
         *  Check that required fields are present
         *
         *  @param {String} [eventName] - The EDAP event name
         *  @param {String} [sessionId] - Session ID to send to Hadoop
         *  @param {String} [visitorId] - Visitor ID to send to Hadoop
         *  @param {Object} [payload] - *optional* Object of data to be JSON.stringify()'d
         *
         *  @example
         *    var valid = checkData('pageview', '1234-1234', '5678-5678', {listingid: '123.1234.1234'});
         *
         *  @returns {Boolean} - True if expected fields are present and appropriate data types. False if not.
         */
        function checkData(eventName, sessionId, visitorId, payload) {
            if (typeof eventName !== 'string') {
                edap.error('hadoop.buildUrl requires that "eventName" be a string: ' + eventName);
                return false;
            }

            if (typeof sessionId !== 'string') {
                edap.error('hadoop.buildUrl requires that "sessionId" be a string: ' + sessionId);
                return false;
            }

            if (typeof visitorId !== 'string') {
                edap.error('hadoop.buildUrl requires that "visitorId" be a string: ' + visitorId);
                return false;
            }

            // Payload is optional, but if it is set then it needs to be an object
            if (payload && typeof payload !== 'object') {
                edap.error('hadoop.buildUrl requires that "payload" be an object, if set: ' + sessionId);
                return false;
            }

            return true;
        }

        /**
         *  Creates the structured object used by buildBeaconBlob or buildUrl to send params
         *
         *  @param {String} [eventName] - The EDAP event name
         *  @param {String} [sessionId] - Session ID to send to Hadoop
         *  @param {String} [visitorId] - Visitor ID to send to Hadoop
         *  @param {Object} [payload] - Analytics data object
         *
         *  @example
         *    var analyticsObj = createDataObject('pageview', '1234-1234', '5678-5678', {listingid: '123.1234.1234'}, {emailaddress: 'test@test.com'});
         *
         *  @returns {Object} - structured object returned to be converted into a blob or an IMG url
         */
        this.createDataObject = function(eventName, sessionId, visitorId, payload) {
            var analyticsObj = {
                    type: 'edap:' + eventName,
                    sessionId: sessionId,
                    visitorId: visitorId,
                    site: this.missingDefaultValue,
                    payload: payload
                },
                n = null;

            if (!checkData(eventName, sessionId, visitorId, payload)) {
                return n;
            }

            if (payload && payload.hasOwnProperty('monikerbrand')) {
                analyticsObj.site = payload.monikerbrand;
            }

            return analyticsObj;
        };

        /**
         *  Builds the text blob to "send" via sendEventWithFetch. The analytics payload will be stringified and sent as type: 'text/plain'
         *  because of https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests and CORS-safelisted request-header
         *
         *  @example
         *    var beaconBlob = buildBeaconBlob('pageview', '1234-1234', '5678-5678', {listingid: '123.1234.1234'});
         *
         *  @param {String} [eventName] - The EDAP event name
         *  @param {String} [sessionId] - Session ID to send to Hadoop
         *  @param {String} [visitorId] - Visitor ID to send to Hadoop
         *  @param {Object} [payload] - *optional* Object of data to be JSON.stringify()'d
         *  @param {Object} [optionalParams] - *optional* Object of optional parameter data to be added
         *  @returns {Object} - Stringified blob of data to be sent via fetch API
         */
        this.buildBeaconBlob = function(eventName, sessionId, visitorId, payload, optionalParams) {
            var analyticsObj = this.createDataObject(eventName, sessionId, visitorId, payload, optionalParams);

            if (analyticsObj === null) {
                return analyticsObj;
            }

            return new Blob(
                [JSON.stringify(analyticsObj)]
            );
        };


        /**
         *  Builds the entire Hadoop url to "send" via an image request. All query parameters will URI encoded.
         *
         *  @example
         *    var imageUrl = buildUrl('pageview', '1234-1234', '5678-5678', {listingid: '123.1234.1234'});
         *
         *  @param {String} [eventName] - The EDAP event name
         *  @param {String} [sessionId] - Session ID to send to Hadoop
         *  @param {String} [visitorId] - Visitor ID to send to Hadoop
         *  @param {Object} [payload] - *optional* Object of data to be JSON.stringify()'d
         *  @param {Object} [optionalParams] - *optional* Object of optional parameter data to be added to the URL
         *  @returns {String} - url path for the Hadoop endpoint with data encoded in query parameters, or null if there was an error
         */
        this.buildUrl = function(eventName, sessionId, visitorId, payload, optionalParams) {
            var analyticsObj = this.createDataObject(eventName, sessionId, visitorId, payload, optionalParams),
                win = domHelpers.getWindow(),
                paramList = [],
                url = this.urls.img,
                encodedPayloadContent,
                prop;

            if (analyticsObj === null) {
                return analyticsObj;
            }

            // Add all of the analytics object properties as key=encodedValue other than payload
            for (prop in analyticsObj) {
                if (analyticsObj.hasOwnProperty(prop) && prop !== 'payload') {
                    paramList.push(prop + '=' + win.encodeURIComponent(analyticsObj[prop]));
                }
            }

            // Stringify, encode and push any payload data(already validated to be an object if set)
            if (analyticsObj.payload && win.JSON && typeof win.JSON.stringify === 'function') {
                try {
                    encodedPayloadContent = win.encodeURIComponent(win.JSON.stringify(analyticsObj.payload));
                } catch (err) {
                    edap.error(err);
                    encodedPayloadContent = win.encodeURIComponent('{"error":"Could not JSON.stringify payload"}');
                }

                paramList.push('payload=' + encodedPayloadContent);
            }

            paramList.push('_restfully=true');

            url = url + '?' + paramList.join('&');
            return url;
        };

        /**
         *  Use fetch API to POST data
         *
         *  @example
         *    sendEventWithFetch({data});
         *
         *  @param {String} [Object] - data payload to send
         *  @param {Function} [onSuccess] - (optional) function to run if successful with logging
         *  @param {Function} [onFailure] - (optional) function to run if unsuccessful with logging
         */
        this.sendEventWithFetch = function(dataBlob, site, onSuccess, onFailure) {
            var that = this,
                url = this.urls.beacon;

            domHelpers.getWindow().fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain',
                    'x-homeaway-site': site
                },
                referrerPolicy: 'origin-when-cross-origin',
                mode: 'same-origin',
                credentials: 'same-origin',
                cache: 'no-cache',
                redirect: 'follow',
                keepalive: that.shouldFetchWithKeepalive,
                body: dataBlob
            }).then(function(response) {
                // don't actually need the text but console shows error if you don't read it
                response.text().then(function() {
                    try {
                        if (typeof onSuccess === 'function') {
                            onSuccess(url);
                        }

                        if (!response.ok) {
                            throw new Error('non-2XX response received from collector: ' + response.status + ' ' + response.statusText);
                        }
                    } catch (error) {
                        edap.error(error, {}, {logErrorOnly: true});
                    }
                });
            })['catch'](function() {
                onFailure(); // allow us to fall back to img
            });
        };


        /**
         *  "Sends" a Hadoop request via an IMG pixel
         *
         *  @example
         *    var sendDoneable = send('pageview', {listingid: '123.1234.1234'}, null, null);
         *
         *  @param {String} [eventName] - The EDAP event name
         *  @param {Object} [data] - Object of data to be JSON.stringify()'d
         *  @param {String} [sessionId] - *optional* Session ID to send to Hadoop, will be filled in if set to null (ex. ADL.sessionid)
         *  @param {String} [visitorId] - *optional* Visitor ID to send to Hadoop, will be filled in if set to null (ex. ADL.visitorid)
         *  @returns {Doneable} - Then-able object so you can associate callbacks upon completion
         */
        this.send = function(eventName, data, sessionId, visitorId) {
            var that = this,

                // Fields to remove from the payload object because of of PII concerns
                optionalPIIParamsFromData = ['emailaddress', 'firstname', 'lastname'],

                // Keys that should be removed from the data payload before sending
                // Currently these are the Ensighten 1 tracking objects that don't need to be pushed into Hadoop
                removeFromData = ['gaevents', 'thirdparty', 'criteoevents'];

            return new Doneable(function(done) {
                var url,
                    key,
                    i,
                    len,
                    beaconBlob,
                    site;

                if (!sessionId) {
                    sessionId = that.getHasId();
                }

                if (!visitorId) {
                    visitorId = that.getHavId();
                }

                if (data) {
                    for (i = 0, len = optionalPIIParamsFromData.length; i < len; i++) {
                        key = optionalPIIParamsFromData[i];

                        if (data.hasOwnProperty(key)) {
                            delete data[key];
                        }
                    }

                    // Now let's remove other keys that don't need to go to Hadoop
                    for (i = 0, len = removeFromData.length; i < len; i++) {
                        key = removeFromData[i];

                        if (data.hasOwnProperty(key)) {
                            delete data[key];
                        }
                    }
                }

                // send the event using the appropriate API
                // (fetch POST if possible, fall back to img otherwise)
                if (typeof domHelpers.getWindow().fetch === 'function') {
                    beaconBlob = that.buildBeaconBlob(eventName, sessionId, visitorId, data);
                    /* istanbul ignore else  */
                    if (data) {
                        site = data.monikerbrand;
                    } else {
                        site = '';
                    }
                    that.sendEventWithFetch(beaconBlob, site, done, function() {
                        url = that.buildUrl(eventName, sessionId, visitorId, data);
                        domHelpers.getImage(url, done);
                    });
                } else {
                    url = that.buildUrl(eventName, sessionId, visitorId, data);
                    domHelpers.getImage(url, done);
                }
            }, {
                error: function(err) {
                    edap.error(err);
                }
            });
        };
    }

    hadoopInstance = new Hadoop();

    // user is trying to do something so assume page is interactive
    // start using keepalive flag in case that "something" is exit the page
    document.addEventListener('mousedown', function() {
        hadoopInstance.shouldFetchWithKeepalive = true;
    }, {
        once: true // for perf reasons, remove the listener once we're done
    });

    return hadoopInstance;
});

define('hadoop/listeners/test-exposure-handlers',['adlhelpers', 'domhelpers', 'edaphelpers', 'doneable'], function(ADL, domHelpers, edapHelpers, Doneable) {
    'use strict';

    var defaultEntityId = '-1';
    var cachedExposuresWithEntityId = {};
    var batchedExposureCalls = [];
    var testNameProperty = 'testname';
    var variantProperty = 'variant';
    var entityIdProperty = 'entityid';

    /**
     * Processes a 'test.exposure' event and send it to Hadoop
     *
     * @throws {TypeError} - if paremeters do not pass validation
     * @param {Object} [hadoop] - Instance of hadoop-wrapper
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     * @param {ADL} [adl] - Instance of an ADL model
     * @param {boolean} [pageviewTriggered] - True when a pageview has been triggered
     * @param {boolean} [finalize] - True when a pageview has been triggered and edap.trigger needs to be called
     * @returns {Doneable} - resolved when the Hadoop send() is complete, or if there was an error
     */
    function processTestExposure(hadoop, edap, adl, pageviewTriggered, finalize) {
        if (!edap || typeof edap.trigger !== 'function') {
            throw new TypeError('processTestExposure(): must pass in an EDAP instance');
        }

        return new Doneable(function(done) {
            if (!hadoop) {
                throw new TypeError('processTestExposure(): hadoop must be set');
            }

            if (!(adl instanceof ADL)) {
                throw new TypeError('processTestExposure(): adl must be an ADLHelpers instance');
            }

            // Push data into the array unless finalized
            if (!finalize) {
                if (!(typeof adl.get(variantProperty) === 'string' && adl.get(testNameProperty) && adl.get(variantProperty))) {
                    throw new ReferenceError('processTestExposure(): event data must contain testname and variant in string format');
                }

                if (adl.isSet(entityIdProperty)) {
                    if (cachedExposuresWithEntityId.hasOwnProperty(adl.get(entityIdProperty))) {
                        cachedExposuresWithEntityId[adl.get(entityIdProperty)][testNameProperty].push(adl.get(testNameProperty));
                        cachedExposuresWithEntityId[adl.get(entityIdProperty)][variantProperty].push(adl.get(variantProperty));
                    } else {
                        cachedExposuresWithEntityId[adl.get(entityIdProperty)] = {};
                        cachedExposuresWithEntityId[adl.get(entityIdProperty)][testNameProperty] = [adl.get(testNameProperty)];
                        cachedExposuresWithEntityId[adl.get(entityIdProperty)][variantProperty] = [adl.get(variantProperty)];
                    }
                } else {
                    if (cachedExposuresWithEntityId.hasOwnProperty(defaultEntityId)) {
                        cachedExposuresWithEntityId[defaultEntityId][testNameProperty].push(adl.get(testNameProperty));
                        cachedExposuresWithEntityId[defaultEntityId][variantProperty].push(adl.get(variantProperty));
                    } else {
                        cachedExposuresWithEntityId[defaultEntityId] = {};
                        cachedExposuresWithEntityId[defaultEntityId][testNameProperty] = [adl.get(testNameProperty)];
                        cachedExposuresWithEntityId[defaultEntityId][variantProperty] = [adl.get(variantProperty)];
                    }
                }
            } else {
                // Only trigger a test.exposure event if there's something to send
                if (Object.keys(cachedExposuresWithEntityId).length) {
                    edapHelpers.forOwn(cachedExposuresWithEntityId, function(value, key) {
                        /* istanbul ignore else */
                        if (value[testNameProperty].length && value[variantProperty].length) {
                            batchedExposureCalls.push(edap.trigger('test.exposure', {
                                testname: value[testNameProperty].join(','),
                                variant: value[variantProperty].join(','),
                                entityid: key
                            }));
                        }
                    });
                    Doneable.all(batchedExposureCalls).then(function() {
                        // Make sure the same data isn't sent repeatedly
                        cachedExposuresWithEntityId = {};
                        batchedExposureCalls = [];
                        done();
                    });
                } else {
                    // pageview has happened without anything to be done for test exposures
                    done();
                }
                return;
            }
            // Test for pageview having been triggered previously or fall through to done()
            if (pageviewTriggered === true) {
                hadoop.send('test.exposure', adl.get(), adl.isSetGet('sessionid'), adl.isSetGet('visitorid')).then(function() {
                    cachedExposuresWithEntityId = {};
                    done();
                });
                return;
            }
            done();
        }, {
            error: edap.error
        });
    }

    return {
        processTestExposure: processTestExposure
    };
});

define('hadoop/listeners/featureflagged',[
    'hadoop/hadoop-wrapper',
    'hadoop/listeners/test-exposure-handlers',
    'adlhelpers',
    'domhelpers',
    'doneable'
], function(hadoop, testExposureHandlers, ADL, domHelpers, Doneable) {
    'use strict';

    // Module globals that are set in various functions at runtime
    var pageviewTestCookie = 'edap-d-l-pageview',
        genericTestCookie = 'edap-d-l-generic',
        namedTestCookie = 'edap-d-l-named',
        loadedRegex = /^[a-z]+[.](load|did[.]load)$/,
        genericRegex = /^generic[.].[a-z.]+/,
        sentReferrer = false,
        disabledLoggingTimeMinutes = 30,
        disabledLoggingCookieValue = '1',
        defaultListenerInitialized = false,
        value = 'value',
        pageViewTriggered = false,
        ignoredEvents,
        enablePageviewTest,
        enableGenericTest,
        enableNamedTest,
        enableLoadedTest;


    /**
     * Get the value of a cookie and return if the test is enabled or the defaultValue.
     * If the cookie doesn't exist, or the value isn't as expected, then it will return
     * the passed defaultValue.
     *
     * @param {String} [cookieName] - Name of cookie
     * @param {Boolean} [defaultValue] - Value to return if cookie doesn't exist
     * @returns {Boolean} - false: if the cookie is set (ie. the test is NOT enabled)
     *                      defaultValue: if the cookie is missing or incorrectly set
     */
    function testEnabledFromCookie(cookieName, defaultValue) {
        var cookieValue = domHelpers.getCookie(cookieName),
            ret;

        // If the cookie doesn't exist then we return the defalt value
        if (cookieValue === null) {
            return defaultValue;
        }

        // If the cookie is set then it means that we should NOT log and therefore should
        // return a false
        if (cookieValue === disabledLoggingCookieValue) {
            ret = false;
        } else {
            domHelpers.removeCookie(cookieName);
            ret = defaultValue;
        }

        return ret;
    }


    /**
     * Builds the list of events that should be ignored and NEVER sent to Hadoop.
     * NOTE: 'edap.error' will always be sent to Hadoop
     *
     * @param {Array} [eventList] - Array of event names that should never be sent to Hadoop
     */
    function setupEventsToIgnore(eventList) {
        var edapErrorIndex;

        // build the list of events to ignore
        ignoredEvents = eventList;

        // Look to see if 'edap.error' is in the list
        edapErrorIndex = ignoredEvents.indexOf('edap.error');

        // Prepare the ignoredEvents list by removing 'edap.error' since we want to load that to Hadoop
        if (edapErrorIndex > -1) {
            ignoredEvents.splice(edapErrorIndex, 1);
        }
    }


    /**
     * Checks if an eventName is in the list of eventNames to be ignored and NEVER sent to Hadoop
     *
     * @param {String} [eventName] - Name of an EDAP event to check
     * @returns {Boolean} - true if this event should be ignored and not sent to Hadoop (just based on eventName)
     *                      false if it should be processed
     */
    function isEventToIgnore(eventName) {
        return ignoredEvents.indexOf(eventName) > -1;
    }


    /**
     * Processes a Feature Flag that has persistent cookies associated with it.
     *
     * @param {String} [featureValue] - Value of the feature to process and assoicate with cookieName
     * @param {String} [cookieName] - Cookie to set/remove depending on the state of feature flags
     * @returns {Boolean} - If the feature flag is enabled or not
     */
    function processCookieBasedFeatureFlag(featureValue, cookieName) {
        var enabledFeatureValue = (featureValue === 1),
            featureCookieValue = domHelpers.getCookie(cookieName);

        // Only remove the cookie if it is set and the feature is enabled
        if (enabledFeatureValue && featureCookieValue) {
            domHelpers.removeCookie(cookieName);
        } else if (featureValue === 0) {
            domHelpers.setCookie(cookieName, disabledLoggingCookieValue, domHelpers.getHostname(), disabledLoggingTimeMinutes);
        }

        return enabledFeatureValue;
    }


    /**
     * Reads the features and sets some cached module globals with their status
     *
     * @param {Features} [features] - Features instance, like from edap.public.features
     */
    function readAndSetFeatureFlags(features) {
        // Caching the state of these tests for easier readability
        enablePageviewTest = processCookieBasedFeatureFlag(features.getFeatureProperty('edapFeatureHadoopPageviewLogging', value), pageviewTestCookie);
        enableGenericTest = processCookieBasedFeatureFlag(features.getFeatureProperty('edapFeatureHadoopGenericLogging', value), genericTestCookie);
        enableNamedTest = processCookieBasedFeatureFlag(features.getFeatureProperty('edapFeatureHadoopNamedLogging', value), namedTestCookie);
        enableLoadedTest = features.getFeatureProperty('edapFeatureHadoopLoadedLogging', value) === 1;
    }


    /**
     * The handler that is called for each event that is triggered.
     *
     * @param {String} [eventName] - Name of an EDAP event
     * @returns {Boolean} - true if this event should be logged to Hadoop,
     *                      false if it should not be logged to Hadoop
     */
    function shouldLogtoHadoop(eventName) {
        // Cache this so we don't have to process it twice in the condition below
        var isGeneric = genericRegex.test(eventName),
            isLoad = loadedRegex.test(eventName),
            isPageview = (eventName === 'pageview');

        // If it is a pageview and the pageview logging is enabled -OR-
        // If it is a generic event and generic logging is enabled -OR-
        // If it is a load event and load logging is enabled -OR-
        // If it is neither a pageview nor generic event nor load event and named event logging is enabled
        // then log the event to Hadoop
        if (
            (isPageview && enablePageviewTest) ||
            (isGeneric && enableGenericTest) ||
            (isLoad && enableLoadedTest) ||
            (!isPageview && !isGeneric && !isLoad && enableNamedTest)
        ) {
            return true;
        }

        return false;
    }


    /**
     * The function handles the logic on if a "page.referrer" event should be triggered.
     *
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     * @param {Object} [adl] - Data object passed into every listener from EDAP
     * @returns {Doneable} - Donable instance that is returned when all referrer logging processing
     *                       is complete
     */
    function handleReferrerLogging(edap, adl) {
        return new Doneable(function(done) {
            var referrer = domHelpers.getDocumentReferrer(),
                pageviewReferrerData = new ADL({}),
                pageReferrerEventName = 'page.referrer',
                fullClonedDataAdl = new ADL(adl.get()),
                propsToCopy = [
                    'visitorid',
                    'sessionid',
                    'pagehref',
                    'edapintegrationsversion',
                    'clienttimestamp',
                    'edapeventid',
                    'currentpageviewid',
                    'parentpageviewid',
                    'inauthid',
                    'clienttype',
                    'appenvironment',
                    'appname',
                    'appversion',
                    'monikerbrand',
                    'mpaasregion',
                    'pageflow',
                    'pagename',
                    'pagetype',
                    'publicuuid',
                    'sensitive',
                    'visitortype',
                    'analyticsbrand',
                    'exposedtests',
                    'fssessionurl',
                    'gbsessionurl',
                    'item5',
                    'pageurl',
                    'proctor',
                    'proctorpayload',
                    'requestmarker',
                    'testing',
                    'displaycurrency',
                    'displaylocale',
                    'preferredlanguage'
                ],
                i;

            // If we've already sent a referrer then we won't need to resend it again
            if (sentReferrer) {
                done();
                return;
            }

            // We need to process this referrer
            if (domHelpers.isCrossDomainReferral()) {
                // This needs to happen before the edap.trigger to avoid an infinite loop
                sentReferrer = true;

                // TECHDEBT: edap internal functions should not be called outside of edap but this whole thing is a hack and we need to do that because of using forceData below
                fullClonedDataAdl = new ADL(edap.internal.buildTriggerData(pageReferrerEventName, adl.get()));

                pageviewReferrerData.setIfNotSet('referrer', referrer);

                // TECHDEBT: filtering to only add specific fields to the page.referrer event's payload
                for (i = 0; i < propsToCopy.length; i++) {
                    pageviewReferrerData.setIfNotSet(propsToCopy[i], fullClonedDataAdl.isSetGet(propsToCopy[i]));
                }

                // Normally set via EDAP core, but when using "forceData" it has to be manually specificed
                pageviewReferrerData.setIfNotSet('edapeventname', pageReferrerEventName);

                // Special case where we are telling EDAP NOT to extend the ADL due to concerns about payload length
                // TECHDEBT: This should be removed when we can use sendBeacon()
                edap.trigger(pageReferrerEventName, pageviewReferrerData.get(), {forceData: true}).then(done);
            }
        }, {
            error: edap.error
        });
    }

    /**
     *
     * @param {Array} [doneableList] - Array of Doneable objects to be processed
     * @param {String} [eventName] - Event name sent along with the data to be sent to Hadoop
     * @param {ADL} [adl] - Instance of an ADL model
     */
    function sendFullEvent(doneableList, eventName, adl) {
        doneableList.push(
            hadoop.send(eventName, adl.get(), adl.isSetGet('sessionid'), adl.isSetGet('visitorid'))
        );
    }

    /**
     * The handler that is called for each event that is triggered.
     *
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     * @param {Object} [data] - Data object passed into every listener from EDAP
     * @param {Function} [setAsync] - Function to be called when the handler is async
     * @param {Function} [done] - Signals that the listener has completed. Can only be used when setAsync was executed previously
     */
    function handleEvent(edap, data, setAsync, done) {
        var adl = new ADL(data),
            eventName = adl.get('edapeventname'),
            doneableList = [],
            doneableOpts = {
                error: edap.error
            };


        setAsync();

        // Bail if this is an ignored Hadoop Event
        if (isEventToIgnore(eventName)) {
            done();
            return;
        }

        // Check the Feature Flags and see if we should log here
        if (shouldLogtoHadoop(eventName)) {
            // Some events require special handling and so we should route them accordingly here
            // NOTE: If we start adding more special case handlers then we should move then into an object
            //       and use it as a lookup table to route.
            switch (eventName) {
                case 'test.exposure':
                    doneableList.push(
                        testExposureHandlers.processTestExposure(hadoop, edap, adl, pageViewTriggered)
                    );
                    break;
                case 'page.unload':
                    // Send the event to Hadoop like default, but don't fall through to pageview
                    pageViewTriggered = false;
                    sendFullEvent(doneableList, eventName, adl);
                    break;
                case 'pageview':
                    if (!pageViewTriggered) {
                        pageViewTriggered = true;
                        // Finalize and trigger test exposures once on a page view
                        doneableList.push(
                            testExposureHandlers.processTestExposure(hadoop, edap, adl, pageViewTriggered, true)
                        );
                    }
                    doneableList.push(
                        handleReferrerLogging(edap, adl)
                    );
                    // fall through to the default use case here so the event is sent to Hadoop after referrer processing
                default:
                    sendFullEvent(doneableList, eventName, adl);
            }

            Doneable.all(doneableList, doneableOpts).then(done);
        } else {
            done();
        }
    }


    /**
     * Adds the Hadoop event listener for "conditional" events that depend on the Feature Flags being
     * loaded before they are processed and potentially sent to Hadoop.
     *
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     */
    function doConditionalListenerSetup(edap) {
        if (enableLoadedTest) {
            edap.on('*', function(data, setAsync, done) {
                var adl = new ADL(data),
                    eventName = adl.get('edapeventname');

                if (loadedRegex.test(eventName)) {
                    handleEvent(edap, data, setAsync, done);
                }
            });
        }
    }


    /**
     * Adds the Hadoop event listener for events that are enabled-by-default to be logged to Hadoop.
     *
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     */
    function doDefaultListenerSetup(edap) {
        if (defaultListenerInitialized) {
            return;
        }

        // List of ignored events that we will not send to Hadoop regardless of the status of the feature flags
        setupEventsToIgnore(edap['public'].coreSupportedEvents);

        // If any of the default enabled tests are enabled then we should setup the listener
        if (enablePageviewTest || enableGenericTest || enableNamedTest) {
            edap.on('*', function(data, setAsync, done) {
                var adl = new ADL(data),
                    eventName = adl.get('edapeventname');

                // We don't want to process `.load/loaded` events here since they are considered
                // conditional from the edap/service response. If we did process them here then when
                // replay() is triggered post onLoad() this listener woudln't be re-executed since it
                // technically already processed the .load/.did.load events.
                // TECHDEBT: This isn't very clean but for the one off example we have it works and is pretty simple
                //           If we start having more of these conditions then we should consider refactoring
                if (!loadedRegex.test(eventName)) {
                    handleEvent(edap, data, setAsync, done);
                }
            });

            defaultListenerInitialized = true;
        }
    }


    /**
     * Function to setup listeners for this module
     *
     * @param {Object} [edap] - Instance of edap or an EDAP Scope instance
     */
    function setupListeners(edap) {
        defaultListenerInitialized = false;

        // Default Tests
        // Initialize the cached feature values from cookies or defaults
        enablePageviewTest = testEnabledFromCookie(pageviewTestCookie, true);
        enableGenericTest = testEnabledFromCookie(genericTestCookie, true);
        enableNamedTest = testEnabledFromCookie(namedTestCookie, true);

        // Conditional Tests
        enableLoadedTest = false;

        /**
         * We register an onLoad callback that will be executed when edap['public'].features.load() is called.
         */
        edap['public'].features.onLoad(function() {
            // Process the Feature Flags and set the module globals accordingly
            readAndSetFeatureFlags(edap['public'].features);

            // We call doDefaultListenerSetup() again to register the liseners in the case that logging was
            // disabled via cookie and is now enabled via the edap-service response
            doDefaultListenerSetup(edap);
            doConditionalListenerSetup(edap);
        });

        // Register the listeners that CAN be enabled by default
        doDefaultListenerSetup(edap);
    }

    return {
        setupListeners: setupListeners
    };
});

define('hadoop/register-hadoop-listeners',['hadoop/listeners/featureflagged'], function() {
    'use strict';

    var listeners = arguments,
        i;

    /**
     *  Loops through all the listener dependencies and calls the "setupListener" functions
     *
     *  @param {Object} [edap] - The EDAP scope instance to initialize all the listeners with
     */
    function setupListeners(edap) {
        for (i = 0; i < listeners.length; i++) {
            listeners[i].setupListeners(edap);
        }
    }

    return {
        setupListeners: setupListeners
    };
});

define('hadoop/edap-hadoop-integration',['edap', 'hadoop/register-hadoop-listeners'], function(edap, listeners) {
    'use strict';

    var moduleName = 'hadoop',
        myEdap = new edap.Scope(moduleName);

    /**
     *  Main init() for the hadoop integration. It kicks off registering all the listeners.
     *
     *  @returns {Object} - EDAP instance to make this chainable
     */
    function init() {
        listeners.setupListeners(myEdap);

        return edap;
    }

    return {
        init: init
    };
});

define('tagmanager/tmshelpers',[
    'domhelpers'
], function(domHelpers) {
    'use strict';

    var ensightenTestName = 'edapFeatureLoadEnsighten',
        spacePlaceHolder = '{SPACE}',
        ensightenTempateUrl = '//nexus.ensighten.com/away/' + spacePlaceHolder + '/Bootstrap.js',
        envSpaceMappings = {
            bnb: {
                'unit': 'bnb-test',
                'dev': 'bnb-test',
                'test': 'bnb-test',
                'stage': 'bnb-stage',
                'production': 'bnb-production'
            },
            toprural: {
                'unit': 'toprural-test',
                'dev': 'toprural-test',
                'test': 'toprural-test',
                'stage': 'toprural-stage',
                'production': 'toprural-production'
            },
            'default': {
                'unit': 'test',
                'dev': 'test',
                'test': 'test',
                'stage': 'stage',
                'production': 'production'
            }
        },
        monikerToSpaceMappings = {
            bnb: 'bnb',
            toprural: 'toprural',
            'default': 'default'
        },
        myEdap;

    return {
        /**
         * Simple getter for tagmanager EDAP Scope
         *
         * @return {Object} tagmanager EDAP scope
         */
        getEdapScope: function() {
            return myEdap;
        },

        /**
         * Simple setter for tagmanager EDAP Scope
         *
         * @param  {Object} edapInstance New value for tagmanager EDAP scope
         */
        setEdapScope: function(edapInstance) {
            myEdap = edapInstance;
        },

        /**
         * Initialize tag manager tools
         *
         * @param  {Object} edapInstance The tagmanager integration's EDAP Scope
         */
        init: function(edapInstance) {
            var that = this;

            that.setEdapScope(edapInstance);

            that.initEnsighten();
        },

        /**
         * Sets up necessary edap on() handler for loading the appropriate bootstrapper
         */
        initEnsighten: function() {
            var that = this;

            myEdap.once('tagmanager.load', function(data) {
                myEdap['public'].features.onLoad(function() {
                    var ensightenEnabled = myEdap['public'].features.getFeatureProperty(ensightenTestName, 'value') === 1;

                    if (ensightenEnabled) {
                        that.loadEnsighten(data.monikerbrand, data.appenvironment);
                    }
                });
            });
        },

        /**
         * Loads the appropriate Ensighten bootstrapper
         *
         * @param  {String} monikerbrand   The monikerbrand to load the bootstrapper for
         * @param  {String} appenvironment The app environment to load a bootstrapper for
         */
        loadEnsighten: function(monikerbrand, appenvironment) {
            var that = this,
                bootstrapperUrl = that.getBootstrapperUrl(monikerbrand, appenvironment),
                currentTimestamp = domHelpers.getMsFromEpoch();

            // getBootstrapperUrl is guaranteed to return a valid URL
            domHelpers.loadScript(bootstrapperUrl);

            // store current timestamp into scope data so we can check how long loading took
            myEdap.getData().loadtimestamp = currentTimestamp;
        },


        /**
         * Gets the appropriate bootstrapper URL for the given app environment
         * Will always return a valid URL - if appenvironment is invalid, defaults to 'production'
         *
         * @param  {String} monikerbrand   The monikerbrand to load the bootstrapper for
         * @param  {String} appenvironment The app environment to retrieve a bootstrapper URL for
         * @return {String}                The URL for appenvironment
         */
        getBootstrapperUrl: function(monikerbrand, appenvironment) {
            var brandLookup = 'default',
                envSpaceName;

            // If the monikerbrand starts with bnb then it is one of the bnb brands
            if (monikerbrand && (monikerbrand.indexOf('bnb') === 0)) {
                brandLookup = 'bnb';
            } else if (monikerToSpaceMappings.hasOwnProperty(monikerbrand)) {
                brandLookup = monikerbrand;
            }


            envSpaceName = envSpaceMappings[monikerToSpaceMappings[brandLookup]][appenvironment];

            // Figure out which Bootstrapper is appropriate
            if (envSpaceName === undefined) {
                // default to production URL
                envSpaceName = envSpaceMappings[monikerToSpaceMappings[brandLookup]].production;
            }

            return ensightenTempateUrl.replace(spacePlaceHolder, envSpaceName);
        }
    };
});

define('tagmanager/edap-tagmanager-integration',[
    'edap',
    'tagmanager/tmshelpers'
], function(edap, tmsHelpers) {
    'use strict';

    var moduleName = 'tagmanager',
        myEdap = new edap.Scope(moduleName);

    /**
     * Sets up the tag manager integration
     *
     * @return {Object} edap
     */
    function init() {
        tmsHelpers.init(myEdap);

        return edap;
    }

    return {
        init: init
    };
});

define('demo/edap-demo-integration',['edap'], function(edap) {
    'use strict';

    var moduleName = 'demo',
        myEdap = new edap.Scope(moduleName);

    function init() {
        myEdap.on('whos.there', function() {
            console.log(moduleName + ' is ready and listening'); // eslint-disable-line no-console
        });

        return edap;
    }

    return {
        init: init
    };
});

define('xhrhelpers',['domhelpers', 'edap'], function(domHelpers, edap) {
    'use strict';

    /**
     * Create a XMLHttpRequest
     *
     * @example
     *    var xhr = createXMLHttpRequest();
     *
     * @returns {Object} XMLHttpRequest
     */
    function createXMLHttpRequest() {
        return new XMLHttpRequest();
    }


    /**
     * this.xhr -- XMLHttpRequest
     * this.get() -- the getter function for this.xhr
     * this.set() -- the getter function for this.xhr
     * this.setRequestHeader() -- set the request header of xhr
     * this.open() -- Open the XHR
     * this.createXHR() -- create the request, set the onload, onerror, and ontimeout function
     *
     *
     * @returns {XhrHelpers}
     * @constructor
     */
    function XhrHelpers() {
        /**
         *  Getter for an xhr property or the entire xhr
         *
         *
         *  @example
         *    // gets the entire xhr
         *    var xhr = xhr.get();
         *    // gets the attribute of the xhr
         *    var xhr = xhr.get('responseText');
         *
         *  @returns {Object} - Returns the this value || {String} - the corresponding value for key
         */

        this.get = function(key) {
            if (typeof key === 'undefined') {
                return this.xhr;
            }
            return this.xhr[key];
        };


        /**
         *  Setter for an xhr property
         *
         *  @param {String} [key] - xhr key name to set
         *  @param {Object|String|Number|Function} [value] - xhr value to set
         *  @returns {Boolean} - Returns if the value was set or not
         */
        this.set = function(key, value) {
            if (typeof key !== 'string') {
                edap.error('Attempting to set xhr key with non-strings:' + key);
                return false;
            }

            this.xhr[key] = value;
            return true;
        };

        /**
         * Setter for request header
         *
         * @param {String} [header] - header to set
         * @param {String} [value] - header value to set
         * @returns {boolean} - Returns if the header was set or not
         *
         */
        this.setRequestHeader = function(header, value) {
            if (typeof header !== 'string' || typeof value !== 'string') {
                edap.error('Attempting to set the header with non strings');
                return false;
            }
            this.xhr.setRequestHeader(header, value);
            return true;
        };

        /**
         *  Determines if a key is set in the xhr
         *
         *  @param {String} [key] - The xhr key name to check
         *  @returns {Boolean} - Returns if the value is set or not
         */
        this.isSet = function(key) {
            return (this.xhr[key] !== undefined && this.xhr[key] !== null);
        };

        /**
         *  Open the XHR
         *
         *  @param {String} [method] - The xhr method e.g. GET/POST/DELETE
         *  @param {String} [url] - The xhr url The URL to send the request to
         *  @returns {Boolean} - true if it successfully opened the XHR
         *                       false if it fails paremeter validation
         */
        this.open = function(method, url) {
            if (typeof method !== 'string' || typeof url !== 'string') {
                edap.error('Attempting to open the request with non strings');
                return false;
            }

            // Force Async since Synchronous AJAX is deprecated
            this.xhr.open(method, url, true);
            return true;
        };

        /**
         * Send the XHR
         */
        this.send = function() {
            this.xhr.send();
        };

        /**
         *
         * @param {String} - [method] - HTTP method GET/POST/PUT/DELETE
         * @param {String} - [url] - the url for AJAX request
         * @param {Function} - [onload] - the onload function for ajax
         * @param {Function} - [onerror] - the onerror function for ajax
         * @param {Function} - [ontimeout] - the timeout function for ajax
         * @returns {Boolean} - true if the XHR is created
         *                      false if the XHR is not created
         */
        this.createXHR = function(method, url, onload, onerror, ontimeout) {
            var that = this;

            function executeCallback(cb) {
                try {
                    cb(that);
                } catch (err) {
                    edap.error(err);
                }
            }

            if (this.xhr) {
                this.open(method, url);
            } else {
                edap.error('createXHR(): browser does not support XHRequest');
                return false;
            }

            this.set('onload', function() {
                executeCallback(onload);
            });

            this.set('onerror', function() {
                executeCallback(onerror);
            });

            this.set('ontimeout', function() {
                executeCallback(ontimeout);
            });

            return true;
        };

        /**
         *  Constructor
         */
        this.xhr = createXMLHttpRequest();

        return this;
    }

    return XhrHelpers;
});

define('feature-flag/feature-flags',['domhelpers', 'doneable', 'adlhelpers', 'edaphelpers', 'xhrhelpers'], function(domHelpers, Doneable, ADL, edapHelpers, XHRHelper) {
    'use strict';

    /**
     * Feature flag model constructor.
     * Contains all the business logic for communicating with and parsing responses from edap-service.
     *
     * @constructor
     * @param {Object} [edap] - window.edap or an EDAP scope to be used internally
     * @param {Object} [config] - configuration options supported:
     *                           - {String} [endpointOrigin] - Origin of the edap-service endpoint, (origin automatically added if blank)
     *                           - {String} [endpointPath] - Path to the edap-service endpoint
     *                           - {Integer} [ajaxTimeout] - Max time, in ms, to wait for the AJAX response
     */
    function Features(edap, config) {
        var features = this,
            initErr;

        /**
         * Validate
         */

        if (!edap || !edap.hasOwnProperty('edapVersion')) {
            throw new TypeError('Features: must pass in EDAP when creating a new instance');
        }

        if (!(features instanceof Features)) {
            initErr = new TypeError('Features must be called with the "new" keyword');
            edap.error(initErr);
            throw initErr;
        }

        /**
         * Configuration Options
         */

        config = config || {};

        // Default config values
        features.config = edapHelpers.defaults({}, [config, {
            endpointOrigin: '',
            endpointPath: '/edap/service/v1/getInitData',
            ajaxTimeout: 3 * 1000 // 3 s
        }]);

        // Set this to a local property in case a consumer of EDAP-Integrations doesn't
        // have access to the Features model
        features.state = Features.state;

        // Init our data container when we load the data
        features.data = {
            featureFlagList: [],
            status: Features.state.INIT
        };


        /**
         * Parses the response object from the edap-service "responseText" string
         *
         * @private
         * @param {String} [responseText] - edap-service XHR "responseText" string
         * @return {Object} - edap-service response object, or an empty object if there's a parse error
         */
        features.getResponseJSON = function(responseText) {
            try {
                return JSON.parse(responseText);
            } catch (e) {
                edap.error('getResponseJSON(): Could not parse JSON responseText: ' + responseText);
            }

            return {};
        };


        /**
         * Parses the payload of a feature
         *
         * @private
         * @param {Object} [payload] - The payload string form a feature
         * @return {*} - The JSON.parse() value of payload, if it was a JSON.stringify()'d object
         *               If it doesn't JSON.parse() then it returns the passed in parameter
         */
        features.parsePayload = function(payload) {
            var parsePayload = payload;

            if (typeof payload === 'string') {
                try {
                    parsePayload = JSON.parse(payload);
                } catch (e) {
                    parsePayload = payload;
                }
            }

            return parsePayload;
        };


        /**
         * Parses the list of features and builds a list of FeatureFlag models
         *
         * @private
         * @param {Object} [responseJSON] - JSON response object from edap-service
         * @return {Array} - The list of FeatureFlag models populated with the edap-service features data
         */
        features.getFeatureFlagList = function(responseJSON) {
            var ffList = [],
                ff;

            if (typeof responseJSON.features !== 'object') {
                return ffList;
            }

            edapHelpers.forOwn(responseJSON.features, function(data, key) {
                try {
                    ff = new edap['public'].FeatureFlag(edap, {
                        name: key,
                        value: data.bucketValue,
                        payload: features.parsePayload(data.payload)
                    });
                    ffList.push(ff);
                } catch (e) {
                    edap.error('getFeatureFlagList(): Could not parse entry ' + key + ': ' + JSON.stringify(data));
                }
            });

            return ffList;
        };


        /**
         * Executes the edap-service XHR and parses the return values.
         * All parsed data is stored in features.data.*. Currently the following properties are set:
         *  - {Array} [features.data.featureFlagList] - Contains the list of FeatureFlags models
         *
         * @public
         * @returns {Doneable} - Doneable that is resolved when the network request is complete. You need to check
         *                       features.data.status. It can be set to:
         *                        - Features.state.INIT - Default value that means loadFeaturesData() has not been called
         *                        - Features.state.PENDING - XHR request has been sent but no response has been parsed.
         *                        - Features.state.LOADED - XHR response received, validated and parsed, features.data.* is ready
         *                        - Features.state.BADRESPONSE - XHR response received but did not pass validation, features.data.* not set
         *                        - Features.state.ERROR - XHR threw an error, features.data.* not set
         *                        - Features.state.TIMEOUT - XHR timed out, features.data.* not set
         */
        features.loadFeaturesData = function() {
            return new Doneable(function(done) {
                var logName = 'loadFeaturesData',
                    adl = new ADL(),
                    site = adl.get('monikerbrand'),
                    url,
                    xhr,
                    err;

                // onload function for xhr object
                function onload(xhrHelper) {
                    var status = xhrHelper.get('status'),
                        responseJSON;

                    if (status === 200) {
                        responseJSON = features.getResponseJSON(xhrHelper.get('responseText'));

                        // Now get parse, build and store the data
                        features.data.featureFlagList = features.getFeatureFlagList(responseJSON);
                        features.data.status = Features.state.LOADED;
                    } else {
                        err = new Error([
                            logName + '():',
                            'got status',
                            status,
                            'on requesting',
                            url
                        ].join(' '));
                        edap.error(err);

                        features.data.status = Features.state.BADRESPONSE;
                    }

                    done();
                }

                function onerror() {
                    err = new Error([
                        logName + '():',
                        'network error attempting to reach',
                        url
                    ].join(' '));

                    edap.error(err);

                    features.data.status = Features.state.ERROR;

                    done();
                }

                function ontimeout() {
                    err = new Error([
                        logName + '():',
                        'network request timed out attempting to reach',
                        url
                    ].join(' '));

                    edap.error(err);

                    features.data.status = Features.state.TIMEOUT;

                    done();
                }

                url = encodeURI([
                    features.config.endpointOrigin,
                    features.config.endpointPath
                ].join(''));

                xhr = new XHRHelper();

                xhr.createXHR('GET', url, onload, onerror, ontimeout);
                xhr.set('timeout', features.ajaxTimeout);

                if (site) {
                    xhr.setRequestHeader('x-homeaway-site', site);
                }

                // Reset the data containers since we are requesting new data
                features.data.featureFlagList = [];
                features.data.status = Features.state.PENDING;

                xhr.send();
            }, {
                error: edap.error
            });
        };

        return features;
    }

    // Static ENUM of states of the Features model
    Features.state = {
        INIT: 'init',
        PENDING: 'pending',
        LOADED: 'loaded',
        BADRESPONSE: 'bad response',
        ERROR: 'error',
        TIMEOUT: 'timeout'
    };

    return Features;
});

define('feature-flag/edap-feature-flag-integration',['domhelpers', 'edap', 'feature-flag/feature-flags'], function(domHelpers, edap, Features) {
    'use strict';

    var moduleName = 'features',
        myEdap = new edap.Scope(moduleName);

    /**
     * Sets up a listener to tell EDAP when to grab the feature flag bucketing info
     *
     * @returns {Object} - edap
     */
    function init() {
        myEdap.once('features.load', function(data, setAsync, done) {
            var features = myEdap.getData().features,
                edapOpts = myEdap.globalOptions, // EDAP guarantees that globalOptions is always an {}
                startLoad = domHelpers.getMsFromEpoch(),
                replayExecutionTime = null,
                hasLoadedFeatures = false,
                endLoad,
                startReplay;

            // This function is called when loading the feature flag data is done, one way or another
            function listenerComplete() {
                // If we haven't loaded the features yet then we do that now to make sure any onLoad()
                // callbacks are called
                if (!hasLoadedFeatures) {
                    myEdap['public'].features.load([]);
                }

                // trigger our "did.load" event for feature flags
                myEdap.trigger('features.did.load', {
                    loadtime: '' + (endLoad - startLoad),
                    replaytime: '' + replayExecutionTime,
                    loadstatus: features.data.status
                }).then(done);
            }

            setAsync();

            if (!(features instanceof Features)) {
                features = new Features(myEdap, {
                    endpointOrigin: edapOpts.endpointOrigin
                });
                myEdap.getData().features = features;
            }

            features.loadFeaturesData().then(function() {
                var hasFeatures = features.data.featureFlagList.length > 0;

                endLoad = domHelpers.getMsFromEpoch();

                if (features.data.status === features.state.LOADED && hasFeatures) {
                    myEdap['public'].features.load(features.data.featureFlagList);
                    hasLoadedFeatures = true;

                    startReplay = domHelpers.getMsFromEpoch();

                    myEdap['public'].playback.replay().then(function() {
                        replayExecutionTime = domHelpers.getMsFromEpoch() - startReplay;
                        listenerComplete();
                    });
                } else {
                    listenerComplete();
                }
            });
        });

        return edap;
    }

    return {
        init: init
    };
});

define('init',['edap'], function(edap) {
    'use strict';

    // EDAP guarantees that edap.globalOptions is always an {}
    var edapOpts = edap.globalOptions,
        skipPageview = edapOpts.skipPageview;

    function init() {
        // Add integrations version to EDAP
        edap.integrationsVersion = '11.106.0';

        if (edapOpts.skipFlush !== true) {
            edap.trigger('edap.flush');
        }

        if (skipPageview !== true) {
            edap.trigger('pageview');
        }

        if (edapOpts.skipTagManager !== true) {
            // if skipPageview option is set to true, trigger this on the manual pageview
            // to guarantee the data layer is set before the tag manager loads
            if (skipPageview === true) {
                edap.once('pageview', function() {
                    edap.trigger('tagmanager.load');
                });
            } else {
                edap.trigger('tagmanager.load');
            }
        }

        if (edapOpts.skipFeatureFlags === true) {
            // We want to call features.load() immediately so that any features.onLoad()
            // callbacks are executed just with no FeatureFlags set.
            edap['public'].features.load([]);
        } else {
            edap.trigger('features.load');
        }

        return edap;
    }

    return {
        init: init
    };
});

define('loader',[
    'edap',
    'debughelpers',
    'domhelpers',
    'data-enrichment/edap-data-enrichment-integration',
    'ua/edap-ua-integration',
    'hadoop/edap-hadoop-integration',
    'tagmanager/edap-tagmanager-integration',
    'demo/edap-demo-integration',
    'feature-flag/edap-feature-flag-integration',
    'init'
], function(inittedEdap, debugHelpers, domHelpers, dataEnrichment, ua, hadoop, tagmanager, demo, features, integrations) {
    'use strict';

    var verboseDebugName = 'logloadevents',
        loadEvents = [
            'ua.load',
            'ua.did.load',
            'tagmanager.load',
            'tagmanager.did.load',
            'features.load',
            'features.did.load'
        ],
        i;

    // If we are not in debug mode then we will need to add the load/did.load events to the ignore console events
    if (!debugHelpers.isInDebugMode(verboseDebugName)) {
        for (i = 0; i < loadEvents.length; i++) {
            inittedEdap['public'].addIgnoredConsoleEvent(loadEvents[i]);
        }
    }

    // this one should always be first to ensure it gets to augment the data object before any other integration consumes it
    dataEnrichment.init();

    // Skip GA if in the EU or the skipGA flag is set
    if (!inittedEdap.globalOptions.skipGA && domHelpers.getCookie('eu-site') !== '1') {
        ua.init();
    }
    hadoop.init();
    tagmanager.init();
    demo.init();
    features.init();

    // this one should always be last to make sure all other integrations have registered their callbacks
    integrations.init();

    return inittedEdap;
});

return require('loader'); }));
